import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import UserDetailsModal from '../components/UserDetailsModal';  // 🚨 NUEVO
import PenalizacionesPanel from '../components/PenalizacionesPanel';  // 🚨 NUEVO PANEL
import AdminPenalizacionesPanel from '../components/AdminPenalizacionesPanel';  // 🚨 PANEL IGUAL QUE VE TECH
import RelocateTechnicianPanel from '../components/RelocateTechnicianPanel';  // 🔀 Solo admin maestro (IGNOROSA)
import HallazgosIDRPanel from '../components/HallazgosIDRPanel';  // 📑 Carga semanal de hallazgos IDR
import { getMediaBaseUrl } from '../config';

// Configuración de iconos de Leaflet mediante CSS (sin usar imágenes externas que pueden romperse)
const createCustomIcon = (color, size = 16) => {
  return new L.divIcon({
    className: 'custom-div-icon',
    html: `<div style="background-color: ${color}; width: ${size}px; height: ${size}px; border-radius: 50%; border: 2px solid white; box-shadow: 0 0 4px rgba(0,0,0,0.6);"></div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    popupAnchor: [0, -size / 2]
  });
};

const greenIcon = createCustomIcon('#16A34A', 16); // Segmentos válidos
const orangeIcon = createCustomIcon('#EA580C', 16); // Segmentos descartados
const redIcon = createCustomIcon('#DC2626', 16); // No realizables
const blueIcon = createCustomIcon('#2563EB', 20); // Inicio (ligeramente más grande)
const purpleIcon = createCustomIcon('#7C3AED', 22); // Fin de recorrido (más grande y violeta)


const MultiSelectDropdown = ({ label, options, selectedValues, onChange, placeholder = "-- Todos --" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleOption = (val) => {
    if (selectedValues.includes(val)) {
      onChange(selectedValues.filter(v => v !== val));
    } else {
      onChange([...selectedValues, val]);
    }
  };

  const getLabel = () => {
    if (selectedValues.length === 0) return placeholder;
    if (selectedValues.length <= 2) return selectedValues.join(", ");
    return `${selectedValues.length} seleccionados`;
  };

  return (
    <div ref={dropdownRef} style={{ position: 'relative', width: '100%' }}>
      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569', fontSize: '14px' }}>{label}</label>
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: '100%', padding: '12px', borderRadius: '10px',
          border: '1px solid #CBD5E1', fontSize: '15px', backgroundColor: 'white',
          cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          boxSizing: 'border-box'
        }}
      >
        <span style={{
          textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '90%',
          color: selectedValues.length === 0 ? '#64748B' : '#0F172A'
        }}>
          {getLabel()}
        </span>
        <span style={{ fontSize: '12px', color: '#64748B' }}>{isOpen ? '▲' : '▼'}</span>
      </div>

      {isOpen && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1000,
          backgroundColor: 'white', border: '1px solid #CBD5E1', borderRadius: '10px',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', marginTop: '4px',
          maxHeight: '200px', overflowY: 'auto', padding: '8px', boxSizing: 'border-box'
        }}>
          {options.length === 0 ? (
            <div style={{ padding: '8px', color: '#64748B', fontSize: '14px', textAlign: 'center' }}>No hay opciones disponibles</div>
          ) : (
            options.map(opt => {
              const isSelected = selectedValues.includes(opt);
              return (
                <div
                  key={opt}
                  onClick={() => toggleOption(opt)}
                  style={{
                    display: 'flex', alignItems: 'center', padding: '8px', borderRadius: '6px',
                    cursor: 'pointer', backgroundColor: isSelected ? '#F1F5F9' : 'transparent',
                    transition: 'background-color 0.1s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = isSelected ? '#E2E8F0' : '#F8FAFC'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = isSelected ? '#F1F5F9' : 'transparent'}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => {}}
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: '#0F172A', userSelect: 'none' }}>{opt}</span>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};


function ChangeView({ bounds }) {
  const map = useMap();
  if (bounds && bounds.length > 0) {
    map.fitBounds(bounds, { padding: [30, 30], maxZoom: 18 });
  }
  return null;
}

const haversineDistance = (lat1, lon1, lat2, lon2) => {
  if (!lat1 || !lon1 || !lat2 || !lon2) return 0;
  const R = 6371000;
  const dLat = (parseFloat(lat2) - parseFloat(lat1)) * Math.PI / 180;
  const dLon = (parseFloat(lon2) - parseFloat(lon1)) * Math.PI / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(parseFloat(lat1) * Math.PI / 180) * Math.cos(parseFloat(lat2) * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

const DashboardMap = ({ reports, height = '500px' }) => {
  const mapRef = useRef(null);
  const leafletMapRef = useRef(null);
  const [mapInitialized, setMapInitialized] = useState(false);
  const [modalPhoto, setModalPhoto] = useState(null);

  const baseUrl = getMediaBaseUrl();

  // Registrar callback global para abrir foto ampliada desde el popup de Leaflet
  useEffect(() => {
    window.__openDashboardPhoto = (url, title) => {
      setModalPhoto({ url, title });
    };
    return () => {
      delete window.__openDashboardPhoto;
    };
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    try {
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });
    } catch (e) {
      return dateStr;
    }
  };

  const getFullPhotoUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    if (path.startsWith('/static/')) return `${baseUrl}${path}`;
    if (path.startsWith('static/')) return `${baseUrl}/${path}`;
    if (path.startsWith('/')) return `${baseUrl}${path}`;
    return `${baseUrl}/static/uploads/${path}`;
  };

  // Procesar puntos y bounds primero (sin early returns)
  const allPoints = [];
  const bounds = [];

  if (reports && reports.length > 0) {
    reports.forEach(report => {
      // Punto de inicio del recorrido
      if (report.start_lat && report.start_lng) {
        const startPoint = {
          lat: parseFloat(report.start_lat),
          lng: parseFloat(report.start_lng),
          type: 'start',
          time: report.start_time,
          label: `🟢 Inicio: ${formatDate(report.start_time)}`
        };
        allPoints.push(startPoint);
        bounds.push([startPoint.lat, startPoint.lng]);
      }

      let lastPoint = report.start_lat ? { lat: report.start_lat, lng: report.start_lng } : null;

      if (report.map_points && report.map_points.length > 0) {
        report.map_points.forEach(p => {
          // Validar que existan coordenadas válidas
          const currentLat = parseFloat(p.lat);
          const currentLng = parseFloat(p.lng);

          if (isNaN(currentLat) || isNaN(currentLng)) {
            console.warn('⚠️ Segmento con coordenadas inválidas:', p);
            return; // Saltar este punto
          }

          let colorType = p.type; // 'segment' o 'unrealizable'

          let dist = 0;
          if (lastPoint && p.type === 'segment') {
            dist = haversineDistance(lastPoint.lat, lastPoint.lng, currentLat, currentLng);
            if (dist > 150) colorType = 'discarded';
          }

          const point = {
            id: p.id,
            lat: currentLat,
            lng: currentLng,
            type: colorType,
            originalType: p.type,
            time: p.time,
            createdAt: p.created_at || p.time,
            submittedAt: p.submitted_at || p.time,
            activities: p.activities || [],
            photo1Url: p.photo1_url || p.photo1_path || '',
            photo2Url: p.photo2_url || p.photo2_path || '',
            comments: p.comments || '',
            dist: dist,
            reason: p.reason,
            label: `${p.type === 'segment' ? 'Mantenimiento' : 'No Realizable (' + (p.reason || 'Desconocida') + ')'} - ${p.time ? formatDate(p.time) : 'Sin hora'}`
          };
          allPoints.push(point);
          bounds.push([currentLat, currentLng]);
          lastPoint = { lat: currentLat, lng: currentLng };
        });
      }

      // Punto de FIN de recorrido
      if (report.end_lat && report.end_lng) {
        const endLat = parseFloat(report.end_lat);
        const endLng = parseFloat(report.end_lng);
        if (!isNaN(endLat) && !isNaN(endLng)) {
          const endLabel = report.end_time
            ? `🔴 Fin de recorrido: ${formatDate(report.end_time)}`
            : '🔴 Fin de recorrido';
          const endPoint = {
            lat: endLat,
            lng: endLng,
            type: 'end',
            time: report.end_time,
            label: endLabel
          };
          allPoints.push(endPoint);
          bounds.push([endLat, endLng]);
        }
      }
    });
  }

  // Función para calcular distancia entre dos puntos en metros
  const getDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371e3;
    const x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2 * Math.PI / 180);
    const y = (lat2 - lat1);
    return Math.sqrt(x * x + y * y) * (Math.PI / 180) * R;
  };

  // Agrupar puntos cercanos (radio de 3 metros)
  const clusters = [];
  if (allPoints.length > 0) {
    allPoints.forEach(p => {
      const lat = parseFloat(p.lat);
      const lng = parseFloat(p.lng);

      let foundCluster = null;
      for (const cl of clusters) {
        if (getDistance(lat, lng, cl.lat, cl.lng) < 3) {
          foundCluster = cl;
          break;
        }
      }

      if (foundCluster) {
        foundCluster.points.push(p);
      } else {
        clusters.push({ lat, lng, points: [p] });
      }
    });
  }

  // Hook useEffect - SIEMPRE se ejecuta (reglas de React)
  useEffect(() => {
    if (!mapRef.current || leafletMapRef.current || allPoints.length === 0) return;

    const center = clusters.length > 0
      ? [clusters[0].lat, clusters[0].lng]
      : [parseFloat(allPoints[0].lat), parseFloat(allPoints[0].lng)];

    const map = L.map(mapRef.current).setView(center, 15);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap',
      maxZoom: 22,
      maxNativeZoom: 19
    }).addTo(map);

    // Control de Regla de Medición interactivo nativo (Leaflet)
    const MeasureControl = L.Control.extend({
      options: { position: 'topleft' },
      onAdd: function () {
        const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
        container.style.backgroundColor = 'white';
        container.style.width = '34px';
        container.style.height = '34px';
        container.style.display = 'flex';
        container.style.alignItems = 'center';
        container.style.justifyContent = 'center';
        container.style.cursor = 'pointer';
        container.style.fontSize = '18px';
        container.style.boxShadow = '0 1px 5px rgba(0,0,0,0.65)';
        container.style.borderRadius = '4px';
        container.title = 'Regla de medición lineal';
        container.innerHTML = '📏';

        let measuring = false;
        let points = [];
        let tempPolyline = null;
        let tempMarkers = [];
        let tooltip = null;

        L.DomEvent.disableClickPropagation(container);

        container.addEventListener('click', () => {
          measuring = !measuring;
          if (measuring) {
            resetMeasure();
            measuring = true;
            container.style.backgroundColor = '#FEF3C7';
            container.style.border = '2px solid #D97706';
            map.getContainer().style.cursor = 'crosshair';
            map.doubleClickZoom.disable();
            map.on('click', onMapClick);
            map.on('mousemove', onMapMouseMove);
            map.on('dblclick', onMapDblClick);
          } else {
            resetMeasure();
          }
        });

        function resetMeasure() {
          measuring = false;
          container.style.backgroundColor = 'white';
          container.style.border = 'none';
          map.getContainer().style.cursor = '';
          map.doubleClickZoom.enable();
          map.off('click', onMapClick);
          map.off('mousemove', onMapMouseMove);
          map.off('dblclick', onMapDblClick);
          if (tempPolyline) {
            map.removeLayer(tempPolyline);
            tempPolyline = null;
          }
          tempMarkers.forEach(m => map.removeLayer(m));
          tempMarkers = [];
          if (tooltip) {
            map.removeLayer(tooltip);
            tooltip = null;
          }
          points = [];
        }

        function finishMeasure() {
          map.off('click', onMapClick);
          map.off('mousemove', onMapMouseMove);
          map.off('dblclick', onMapDblClick);
          map.getContainer().style.cursor = '';
          map.doubleClickZoom.enable();
          if (tooltip) {
            map.removeLayer(tooltip);
            tooltip = null;
          }
          if (tempPolyline && points.length > 0) {
            tempPolyline.setLatLngs(points);
          }
          if (tempMarkers.length > 0) {
            let totalDist = 0;
            for (let i = 0; i < points.length - 1; i++) {
              totalDist += map.distance(points[i], points[i + 1]);
            }
            const lastMarker = tempMarkers[tempMarkers.length - 1];
            lastMarker.bindTooltip(`Medición Finalizada: ${totalDist.toFixed(1)} m (Click en 📏 para limpiar)`, {
              permanent: true,
              direction: 'top',
              className: 'custom-measure-tooltip'
            }).openTooltip();
          }
          measuring = false;
          container.style.backgroundColor = 'white';
          container.style.border = 'none';
        }

        function onMapDblClick(e) {
          L.DomEvent.stopPropagation(e);
          // Remover el último punto duplicado por la acción del click que antecede al dblclick
          if (points.length > 1) {
            points.pop();
            const lastMarker = tempMarkers.pop();
            if (lastMarker) map.removeLayer(lastMarker);
          }
          finishMeasure();
        }

        function onMapClick(e) {
          const latlng = e.latlng;
          points.push(latlng);

          const marker = L.circleMarker(latlng, {
            radius: 5,
            color: '#D97706',
            fillColor: '#FBBF24',
            fillOpacity: 1,
            weight: 2
          }).addTo(map);
          tempMarkers.push(marker);

          if (points.length === 1) {
            tempPolyline = L.polyline([latlng], {
              color: '#D97706',
              weight: 3,
              opacity: 0.8,
              dashArray: '6, 6'
            }).addTo(map);
          } else {
            tempPolyline.addLatLng(latlng);

            let totalDist = 0;
            for (let i = 0; i < points.length - 1; i++) {
              totalDist += map.distance(points[i], points[i + 1]);
            }

            marker.bindTooltip(`Medido: ${totalDist.toFixed(1)} m`, {
              permanent: true,
              direction: 'top',
              className: 'custom-measure-tooltip'
            }).openTooltip();
          }
        }

        function onMapMouseMove(e) {
          if (points.length === 0) return;
          const latlng = e.latlng;

          const previewPath = [...points, latlng];
          tempPolyline.setLatLngs(previewPath);

          let totalDist = 0;
          for (let i = 0; i < points.length - 1; i++) {
            totalDist += map.distance(points[i], points[i + 1]);
          }
          totalDist += map.distance(points[points.length - 1], latlng);

          if (tooltip) {
            tooltip.setLatLng(latlng);
            tooltip.setContent(`📏 Distancia: ${totalDist.toFixed(1)} m<br><span style="font-size:10px;color:#64748B;">Doble click para finalizar | Click en 📏 para limpiar</span>`);
          } else {
            tooltip = L.tooltip({
              className: 'custom-measure-tooltip-dynamic',
              direction: 'right',
              sticky: false
            })
              .setLatLng(latlng)
              .setContent(`📏 Distancia: ${totalDist.toFixed(1)} m`)
              .addTo(map);
          }
        }

        map.on('contextmenu', (e) => {
          if (measuring) {
            L.DomEvent.stopPropagation(e);
            resetMeasure();
          }
        });

        // Limpieza automática
        map.on('unload', resetMeasure);

        return container;
      }
    });

    map.addControl(new MeasureControl());

    // Dibujar polyline de la ruta con flechas direccionales
    for (let i = 1; i < allPoints.length; i++) {
      const p1 = allPoints[i - 1];
      const p2 = allPoints[i];
      const lat1 = parseFloat(p1.lat);
      const lng1 = parseFloat(p1.lng);
      const lat2 = parseFloat(p2.lat);
      const lng2 = parseFloat(p2.lng);

      if (!isNaN(lat1) && !isNaN(lng1) && !isNaN(lat2) && !isNaN(lng2)) {
        // Dibujar segmento de línea
        L.polyline([[lat1, lng1], [lat2, lng2]], { color: '#3b82f6', weight: 3, opacity: 0.6, dashArray: '5, 10' }).addTo(map);

        // Calcular ángulo y punto medio para la flecha indicadora
        const dy = lat2 - lat1;
        const dx = lng2 - lng1;
        if (Math.abs(dx) > 1e-6 || Math.abs(dy) > 1e-6) {
          const angle = Math.atan2(dy, dx);
          const angleDeg = -angle * 180 / Math.PI;
          const midLat = lat1 + dy * 0.5;
          const midLng = lng1 + dx * 0.5;

          const arrowIcon = L.divIcon({
            html: `<div style="transform: rotate(${angleDeg}deg); color: #2563EB; font-size: 14px; font-weight: bold; line-height: 1; text-shadow: 0 0 2px white; display: flex; align-items: center; justify-content: center;">➤</div>`,
            className: '',
            iconSize: [14, 14],
            iconAnchor: [7, 7]
          });
          L.marker([midLat, midLng], { icon: arrowIcon, interactive: false }).addTo(map);
        }
      }
    }

    // Estado del spiderfy "on-click"
    let activeSpiders = [];
    const clearSpiders = () => {
      activeSpiders.forEach(layer => {
        if (layer && map.hasLayer(layer)) map.removeLayer(layer);
      });
      activeSpiders = [];
    };

    // Si se toca en el mapa vacío, cerramos nodos extendidos
    map.on('click', clearSpiders);

    // Función para renderizar un punto individual
    const renderPoint = (pt, displayLat, displayLng, isSpiderfied, clusterCenter) => {
      let iconColor = '#16A34A'; // Verde - segmentos válidos
      if (pt.type === 'start') iconColor = '#2563EB'; // Azul - inicio
      else if (pt.type === 'end') iconColor = '#7C3AED'; // Púrpura - fin
      else if (pt.type === 'unrealizable') iconColor = '#DC2626'; // Rojo - no realizable
      else if (pt.type === 'discarded') iconColor = '#EA580C'; // Naranja - descartado

      let polyline = null;
      if (isSpiderfied && clusterCenter) {
        polyline = L.polyline([clusterCenter, [displayLat, displayLng]], {
          color: '#3b82f6', weight: 2, opacity: 0.6, dashArray: '4, 4'
        }).addTo(map);
      }

      const icon = L.divIcon({
        className: '',
        html: `<div style="background-color: ${iconColor}; width: 16px; height: 16px; border-radius: 50%; border: 2px solid white; box-shadow: 0 0 4px rgba(0,0,0,0.6);"></div>`,
        iconSize: [16, 16],
        iconAnchor: [8, 8],
        popupAnchor: [0, -8]
      });

      const marker = L.marker([displayLat, displayLng], { icon }).addTo(map);

      // Bloquear el clic del marcador para que no llegue al mapa y cierre la espiral
      marker.on('click', (e) => L.DomEvent.stopPropagation(e));

      const isStart = pt.type === 'start';
      const isEnd = pt.type === 'end';
      const isUnrealizable = pt.type === 'unrealizable';
      const isDiscarded = pt.type === 'discarded';

      let popupContent = '';

      if (isStart) {
        popupContent = `
          <div style="font-family: system-ui, -apple-system, sans-serif; font-size: 13px; line-height: 1.4; min-width: 180px;">
            <b style="color: #2563EB; font-size: 14px;">🟢 Inicio de Recorrido</b>
            <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 6px 0;" />
            <div style="font-size: 11.5px; color: #334155; background: #eff6ff; padding: 6px 8px; border-radius: 6px; border: 1px solid #dbeafe;">
              <b>🕒 Hora:</b> ${formatDate(pt.time)}
            </div>
          </div>
        `;
      } else if (isEnd) {
        popupContent = `
          <div style="font-family: system-ui, -apple-system, sans-serif; font-size: 13px; line-height: 1.4; min-width: 180px;">
            <b style="color: #7C3AED; font-size: 14px;">🏁 Fin de Recorrido</b>
            <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 6px 0;" />
            <div style="font-size: 11.5px; color: #334155; background: #faf5ff; padding: 6px 8px; border-radius: 6px; border: 1px solid #f3e8ff;">
              <b>🕒 Hora:</b> ${formatDate(pt.time)}
            </div>
          </div>
        `;
      } else if (isUnrealizable) {
        // Segmento No Realizable
        const fullPhotoUrl = getFullPhotoUrl(pt.photo1Url);
        const photoHtml = fullPhotoUrl ? `
          <div style="margin-top: 8px;">
            <span style="font-size: 10.5px; font-weight: 600; color: #64748b; display: block; margin-bottom: 3px;">📷 Foto Evidencia:</span>
            <div style="text-align: center;">
              <img src="${fullPhotoUrl}" alt="Evidencia" style="width: 100%; max-height: 95px; object-fit: cover; border-radius: 6px; border: 1px solid #cbd5e1; cursor: pointer; transition: transform 0.15s;" onclick="window.__openDashboardPhoto && window.__openDashboardPhoto('${fullPhotoUrl}', 'Foto Evidencia - No Realizable #${pt.id || ''}')" title="Clic para ampliar" />
            </div>
          </div>
        ` : `<div style="font-size: 11px; color: #94a3b8; font-style: italic; margin-top: 6px;">📷 Sin foto evidencia</div>`;

        const commentsHtml = pt.comments ? `
          <div style="margin-top: 3px; font-size: 11.5px; color: #475569;">
            <b>Comentarios:</b> ${pt.comments}
          </div>
        ` : '';

        popupContent = `
          <div style="font-family: system-ui, -apple-system, sans-serif; font-size: 13px; line-height: 1.4; min-width: 220px; max-width: 280px;">
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <b style="color: #dc2626; font-size: 13.5px;">⚠️ No Realizable #${pt.id || ''}</b>
            </div>
            <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 6px 0;" />
            
            <div style="font-size: 12px; margin-bottom: 4px;">
              <b>Tipo de trabajo:</b> <span style="color: #dc2626; font-weight: 600;">No Realizable</span>
            </div>
            <div style="font-size: 12px; color: #991b1b; margin-bottom: 4px;">
              <b>Motivo:</b> <span style="font-weight: 500;">${pt.reason || 'Sin razón especificada'}</span>
            </div>
            ${commentsHtml}

            <div style="margin-top: 6px; font-size: 11px; color: #334155; background: #fef2f2; padding: 6px 8px; border-radius: 6px; border: 1px solid #fecaca; line-height: 1.5;">
              <div><b>📸 Hora Captura:</b> ${formatDate(pt.createdAt || pt.time)}</div>
              <div><b>🚀 Hora Envío:</b> ${formatDate(pt.submittedAt || pt.time)}</div>
            </div>

            ${photoHtml}
          </div>
        `;
      } else {
        // Segmento Realizado (Mantenimiento)
        const fullPhoto1 = getFullPhotoUrl(pt.photo1Url);
        const fullPhoto2 = getFullPhotoUrl(pt.photo2Url);

        let photosSectionHtml = '';
        if (fullPhoto1 || fullPhoto2) {
          photosSectionHtml = `
            <div style="margin-top: 8px;">
              <span style="font-size: 10.5px; font-weight: 600; color: #64748b; display: block; margin-bottom: 3px;">📷 Fotos del Segmento:</span>
              <div style="display: flex; gap: 8px;">
                ${fullPhoto1 ? `
                  <div style="flex: 1; text-align: center;">
                    <span style="font-size: 9.5px; font-weight: 600; color: #475569; display: block; margin-bottom: 2px;">ANTES</span>
                    <img src="${fullPhoto1}" alt="Antes" style="width: 100%; height: 75px; object-fit: cover; border-radius: 6px; border: 1px solid #cbd5e1; cursor: pointer;" onclick="window.__openDashboardPhoto && window.__openDashboardPhoto('${fullPhoto1}', 'Foto ANTES - Segmento #${pt.id || ''}')" title="Clic para ampliar" />
                  </div>
                ` : ''}
                ${fullPhoto2 ? `
                  <div style="flex: 1; text-align: center;">
                    <span style="font-size: 9.5px; font-weight: 600; color: #475569; display: block; margin-bottom: 2px;">DESPUÉS</span>
                    <img src="${fullPhoto2}" alt="Después" style="width: 100%; height: 75px; object-fit: cover; border-radius: 6px; border: 1px solid #cbd5e1; cursor: pointer;" onclick="window.__openDashboardPhoto && window.__openDashboardPhoto('${fullPhoto2}', 'Foto DESPUÉS - Segmento #${pt.id || ''}')" title="Clic para ampliar" />
                  </div>
                ` : ''}
              </div>
            </div>
          `;
        } else {
          photosSectionHtml = `<div style="font-size: 11px; color: #94a3b8; font-style: italic; margin-top: 6px;">📷 Sin fotos registradas</div>`;
        }

        let activitiesHtml = '';
        if (Array.isArray(pt.activities) && pt.activities.length > 0) {
          activitiesHtml = `
            <div style="margin-top: 4px; margin-bottom: 4px;">
              <b style="font-size: 11.5px; color: #334155;">Tipo de trabajo:</b>
              <div style="display: flex; flex-wrap: wrap; gap: 3px; margin-top: 3px;">
                ${pt.activities.map(act => `<span style="background: #e0f2fe; color: #0369a1; padding: 2px 6px; border-radius: 4px; font-size: 10.5px; font-weight: 500;">${act}</span>`).join('')}
              </div>
            </div>
          `;
        } else if (typeof pt.activities === 'string' && pt.activities.trim()) {
          activitiesHtml = `
            <div style="margin-top: 4px; font-size: 12px; color: #334155;">
              <b>Tipo de trabajo:</b> ${pt.activities}
            </div>
          `;
        } else {
          activitiesHtml = `
            <div style="margin-top: 4px; font-size: 12px; color: #334155;">
              <b>Tipo de trabajo:</b> <span style="color: #16a34a; font-weight: 500;">Mantenimiento Preventivo</span>
            </div>
          `;
        }

        const distanceHtml = pt.dist > 0 ? `
          <div style="margin-top: 3px; color: ${isDiscarded ? '#ea580c' : '#16a34a'}; font-size: 11.5px; font-weight: 600;">
            Distancia anterior: ${pt.dist.toFixed(1)} m ${isDiscarded ? '<span style="color: #ea580c;">(Tirada larga >150m)</span>' : ''}
          </div>
        ` : '';

        popupContent = `
          <div style="font-family: system-ui, -apple-system, sans-serif; font-size: 13px; line-height: 1.4; min-width: 220px; max-width: 280px;">
            <b style="color: #1e3a8a; font-size: 13.5px;">⚡ Segmento #${pt.id || ''}</b>
            <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 6px 0;" />
            
            ${activitiesHtml}
            ${distanceHtml}

            <div style="margin-top: 6px; font-size: 11px; color: #334155; background: #f8fafc; padding: 6px 8px; border-radius: 6px; border: 1px solid #e2e8f0; line-height: 1.5;">
              <div><b>📸 Hora Captura:</b> ${formatDate(pt.createdAt || pt.time)}</div>
              <div><b>🚀 Hora Envío:</b> ${formatDate(pt.submittedAt || pt.time)}</div>
            </div>

            ${photosSectionHtml}
          </div>
        `;
      }

      marker.bindPopup(popupContent, { maxWidth: 300, minWidth: 230 });

      return { marker, polyline };
    };

    // Pintar los clústeres / puntos individuales
    clusters.forEach(clusterData => {
      const { lat, lng, points } = clusterData;

      if (points.length === 1) {
        // Punto único sin agrupar
        renderPoint(points[0], lat, lng, false, null);
      } else {
        // Mostrar nodo "Agrupador / Clúster" con número
        const icon = L.divIcon({
          html: `<div style="background-color: #f59e0b; color: white; border-radius: 50%; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; font-weight: bold; border: 2px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3); font-size: 14px;">${points.length}</div>`,
          className: '',
          iconAnchor: [16, 16]
        });
        const clusterMarker = L.marker([lat, lng], { icon }).addTo(map);

        clusterMarker.on('click', (e) => {
          L.DomEvent.stopPropagation(e); // Prevenir el map.click
          clearSpiders(); // Si hay otra espiral abierta, la cerramos

          points.forEach((pt, idx) => {
            const angle = idx * (Math.PI * 2 / points.length);
            const radius = 0.00035; // Aprox 38m de separación
            // Ajustar visualmente según longitud
            const displayLat = lat + Math.sin(angle) * radius;
            const displayLng = lng + Math.cos(angle) * (radius / Math.cos(lat * Math.PI / 180));

            const res = renderPoint(pt, displayLat, displayLng, true, [lat, lng]);
            activeSpiders.push(res.marker);
            if (res.polyline) activeSpiders.push(res.polyline);
          });
        });
      }
    });

    // Ajustar vista para mostrar todos los puntos
    if (bounds.length > 0) {
      const latLngBounds = L.latLngBounds(bounds.map(b => [b[0], b[1]]));
      if (latLngBounds.isValid()) {
        map.fitBounds(latLngBounds, { padding: [30, 30] });
      }
    }

    leafletMapRef.current = map;
    setMapInitialized(true);

    // Cleanup al desmontar
    return () => {
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
        leafletMapRef.current = null;
      }
    };
  }, [allPoints.length, clusters.length]); // eslint-disable-line

  // Early return DESPUÉS de todos los hooks
  if (!reports || reports.length === 0 || allPoints.length === 0) return null;

  const downloadKML = () => {
    let kmlStr = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>Recorrido Tecnico</name>
    <description>Ruta generada desde Control Campo</description>
    <Style id="routeStyle">
      <LineStyle>
        <color>ffeb3a25</color>
        <width>4</width>
      </LineStyle>
    </Style>
    <Placemark>
      <name>Ruta</name>
      <styleUrl>#routeStyle</styleUrl>
      <LineString>
        <tessellate>1</tessellate>
        <coordinates>\n`;
    allPoints.forEach(pt => {
      kmlStr += `          ${pt.lng},${pt.lat},0\n`;
    });
    kmlStr += `        </coordinates>
      </LineString>
    </Placemark>\n`;

    allPoints.forEach((pt, i) => {
      const typeLabel = pt.type === 'start' ? 'Inicio' : pt.type === 'end' ? 'Fin' : pt.type;
      kmlStr += `    <Placemark>
      <name>${pt.label || typeLabel}</name>
      <description>
        <![CDATA[
          Tipo: ${typeLabel}<br/>
          Hora: ${pt.time ? formatDate(pt.time) : 'N/A'}<br/>
          Coordenadas: ${pt.lat}, ${pt.lng}
        ]]>
      </description>
      <Point>
        <coordinates>${pt.lng},${pt.lat},0</coordinates>
      </Point>
    </Placemark>\n`;
    });

    kmlStr += `  </Document>
</kml>`;

    const blob = new Blob([kmlStr], { type: 'application/vnd.google-earth.kml+xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `recorrido_${new Date().toISOString().replace(/[:.]/g, '-')}.kml`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div style={{ position: 'relative', height: height, width: '100%', borderRadius: '12px', overflow: 'hidden', marginBottom: '24px', border: '5px solid #1E293B', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' }}>
      <div ref={mapRef} style={{ height: '100%', width: '100%' }} />

      <button
        onClick={downloadKML}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          zIndex: 1000,
          backgroundColor: '#1E293B',
          color: 'white',
          border: 'none',
          padding: '8px 12px',
          borderRadius: '8px',
          fontSize: '13px',
          fontWeight: 'bold',
          cursor: 'pointer',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.2)',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
        title="Descargar KML para Google Earth"
      >
        🌍 Descargar KML
      </button>

      {/* Lightbox / Modal para ampliar imagen al hacer clic */}
      {modalPhoto && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 99999,
            padding: '20px'
          }}
          onClick={() => setModalPhoto(null)}
        >
          <div
            style={{
              position: 'relative',
              maxWidth: '90vw',
              maxHeight: '85vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px',
              color: 'white'
            }}>
              <h4 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold' }}>{modalPhoto.title}</h4>
              <button
                onClick={() => setModalPhoto(null)}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  color: 'white',
                  fontSize: '18px',
                  cursor: 'pointer',
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                ✕
              </button>
            </div>
            <img
              src={modalPhoto.url}
              alt={modalPhoto.title}
              style={{
                maxWidth: '100%',
                maxHeight: '75vh',
                objectFit: 'contain',
                borderRadius: '8px',
                boxShadow: '0 10px 25px rgba(0,0,0,0.5)',
                border: '2px solid rgba(255,255,255,0.2)'
              }}
            />
            <div style={{ marginTop: '8px', color: '#94a3b8', fontSize: '12px' }}>
              Haz clic fuera de la imagen o en la ✕ para cerrar
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const InspectorDashboardMap = ({ reports, height = '500px' }) => {
  const mapRef = useRef(null);
  const leafletMapRef = useRef(null);

  const baseUrl = getMediaBaseUrl();

  const allPoints = [];
  const bounds = [];

  if (reports && reports.length > 0) {
    reports.forEach(report => {
      // Inicio
      if (report.start_lat && report.start_lng) {
        const startPoint = {
          lat: parseFloat(report.start_lat),
          lng: parseFloat(report.start_lng),
          type: 'start',
          time: report.start_time,
          serverTime: report.server_created_at || report.start_time,
          label: `🟢 Inicio de Recorrido`
        };
        allPoints.push(startPoint);
        bounds.push([startPoint.lat, startPoint.lng]);
      }

      // Segmentos / Puntos registrados por el inspector
      if (report.map_points && report.map_points.length > 0) {
        report.map_points.forEach(p => {
          const currentLat = parseFloat(p.lat);
          const currentLng = parseFloat(p.lng);

          if (isNaN(currentLat) || isNaN(currentLng)) return;

          const hasIncidences = p.incidences && p.incidences.length > 0;
          let pointType = hasIncidences ? 'incidence' : (p.network_type === 'canalizado' ? 'canalizado' : 'aereo');

          const point = {
            id: p.id,
            lat: currentLat,
            lng: currentLng,
            type: pointType,
            network_type: p.network_type,
            incidences: p.incidences || [],
            photo_path: p.photo_path,
            time: p.recorded_at,
            serverTime: p.server_received_at || p.recorded_at,
            distance: p.distance_from_previous || 0
          };
          allPoints.push(point);
          bounds.push([currentLat, currentLng]);
        });
      }

      // Fin (si finalizó la jornada)
      if (report.end_lat && report.end_lng) {
        const endPoint = {
          lat: parseFloat(report.end_lat),
          lng: parseFloat(report.end_lng),
          type: 'end',
          time: report.end_time,
          serverTime: report.server_created_at || report.end_time,
          label: `🏁 Fin de Recorrido`
        };
        allPoints.push(endPoint);
        bounds.push([endPoint.lat, endPoint.lng]);
      }
    });
  }

  const haversineDist = (lat1, lon1, lat2, lon2) => {
    const R = 6371000;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return Math.round(R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  };

  useEffect(() => {
    if (!mapRef.current || leafletMapRef.current || allPoints.length === 0) return;

    const map = L.map(mapRef.current).setView([allPoints[0].lat, allPoints[0].lng], 14);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 22
    }).addTo(map);

    // Dibujar trayectorias distinguiendo tiradas largas y traslados
    for (let i = 1; i < allPoints.length; i++) {
      const p1 = allPoints[i - 1];
      const p2 = allPoints[i];
      if (!isNaN(p1.lat) && !isNaN(p1.lng) && !isNaN(p2.lat) && !isNaN(p2.lng)) {
        const dist = haversineDist(p1.lat, p1.lng, p2.lat, p2.lng);
        let lineColor = '#2563eb';
        let lineDash = '6, 8';
        let isDiscarded = false;
        let transferReason = '';

        if (p1.type === 'start') {
          if (dist >= 500) {
            lineColor = '#ea580c';
            lineDash = '4, 8';
            isDiscarded = true;
            transferReason = `🚗 Traslado Inicio (>500m): ${dist} m (Descontado)`;
          } else if (dist > 150) {
            lineColor = '#ea580c';
            isDiscarded = true;
            transferReason = `⚠️ Tirada larga inicio (>150m): ${dist} m`;
          }
        } else if (p2.type === 'end') {
          if (dist >= 500) {
            lineColor = '#ea580c';
            lineDash = '4, 8';
            isDiscarded = true;
            transferReason = `🚗 Traslado Fin (>500m): ${dist} m (Descontado)`;
          } else if (dist > 150) {
            lineColor = '#ea580c';
            isDiscarded = true;
            transferReason = `⚠️ Tirada larga fin (>150m): ${dist} m`;
          } else {
            lineColor = '#7c3aed';
          }
        } else {
          // Entre segmentos
          if (dist > 150) {
            lineColor = '#ea580c';
            lineDash = '6, 6';
            isDiscarded = true;
            transferReason = `⚠️ Tirada larga (>150m): ${dist} m (Descontada de metraje efectivo)`;
          }
        }

        const polyline = L.polyline([[p1.lat, p1.lng], [p2.lat, p2.lng]], {
          color: lineColor,
          weight: isDiscarded ? 4 : 4,
          opacity: 0.85,
          dashArray: lineDash
        }).addTo(map);

        if (transferReason) {
          polyline.bindTooltip(transferReason, { sticky: true });
        }

        const dy = p2.lat - p1.lat;
        const dx = p2.lng - p1.lng;
        if (Math.abs(dx) > 1e-6 || Math.abs(dy) > 1e-6) {
          const angleDeg = -Math.atan2(dy, dx) * 180 / Math.PI;
          const arrowColor = isDiscarded ? '#ea580c' : (p2.type === 'end' ? '#7c3aed' : '#1d4ed8');
          const arrowIcon = L.divIcon({
            html: `<div style="transform: rotate(${angleDeg}deg); color: ${arrowColor}; font-size: 14px; font-weight: bold; line-height: 1; text-shadow: 0 0 2px white;">➤</div>`,
            className: '',
            iconSize: [14, 14],
            iconAnchor: [7, 7]
          });
          L.marker([(p1.lat + p2.lat) * 0.5, (p1.lng + p2.lng) * 0.5], { icon: arrowIcon, interactive: false }).addTo(map);
        }
      }
    }

    // Renderizar pines
    allPoints.forEach((pt, i) => {
      let iconHtml = '';
      if (pt.type === 'start') {
        iconHtml = `<div style="background:#2563eb; color:white; border-radius:50%; width:26px; height:26px; display:flex; align-items:center; justify-content:center; border:2px solid white; font-weight:bold; font-size:13px; box-shadow:0 2px 4px rgba(0,0,0,0.4)">🟢</div>`;
      } else if (pt.type === 'end') {
        iconHtml = `<div style="background:#7c3aed; color:white; border-radius:50%; width:26px; height:26px; display:flex; align-items:center; justify-content:center; border:2px solid white; font-weight:bold; font-size:13px; box-shadow:0 2px 4px rgba(0,0,0,0.4)">🏁</div>`;
      } else if (pt.type === 'incidence') {
        iconHtml = `<div style="background:#dc2626; color:white; border-radius:50%; width:24px; height:24px; display:flex; align-items:center; justify-content:center; border:2px solid white; font-weight:bold; font-size:12px; box-shadow:0 2px 4px rgba(0,0,0,0.4)">⚠️</div>`;
      } else if (pt.type === 'canalizado') {
        iconHtml = `<div style="background:#8b5cf6; color:white; border-radius:8px; width:24px; height:24px; display:flex; align-items:center; justify-content:center; border:2px solid white; font-weight:bold; font-size:13px; box-shadow:0 2px 4px rgba(0,0,0,0.4)">⛖</div>`;
      } else {
        // Aéreo
        iconHtml = `<div style="background:#059669; color:white; border-radius:50%; width:24px; height:24px; display:flex; align-items:center; justify-content:center; border:2px solid white; font-weight:bold; font-size:13px; box-shadow:0 2px 4px rgba(0,0,0,0.4)">⚡</div>`;
      }

      const icon = L.divIcon({ html: iconHtml, className: '', iconSize: [26, 26], iconAnchor: [13, 13] });
      const marker = L.marker([pt.lat, pt.lng], { icon }).addTo(map);
      const devTime = pt.time ? new Date(pt.time).toLocaleString('es-MX') : 'N/A';
      const serverTime = pt.serverTime ? new Date(pt.serverTime).toLocaleString('es-MX') : 'N/A';

      // Calcular distancia respecto al punto anterior
      let prevDistHtml = '';
      if (i > 0) {
        const prevPt = allPoints[i - 1];
        const segDist = haversineDist(prevPt.lat, prevPt.lng, pt.lat, pt.lng);
        if (prevPt.type === 'start' && segDist >= 500) {
          prevDistHtml = `<div style="margin-top: 4px; color: #ea580c; font-size: 11.5px; font-weight: 700;">🚗 Inicio a ${segDist} m (Traslado >500m, no sumado a metraje)</div>`;
        } else if (pt.type === 'end' && segDist >= 500) {
          prevDistHtml = `<div style="margin-top: 4px; color: #ea580c; font-size: 11.5px; font-weight: 700;">🚗 Cierre a ${segDist} m (Traslado >500m, no sumado a metraje)</div>`;
        } else if (segDist > 150) {
          prevDistHtml = `<div style="margin-top: 4px; color: #ea580c; font-size: 11.5px; font-weight: 700;">⚠️ Tirada larga: ${segDist} m (>150m, descontada de efectiva)</div>`;
        } else {
          prevDistHtml = `<div style="margin-top: 4px; color: #16a34a; font-size: 11.5px; font-weight: 600;">Distancia tramo: ${segDist} m</div>`;
        }
      }

      let popupText = `
        <div style="font-size:13px; line-height:1.4; min-width:180px;">
          <b style="color:#1e3a8a; font-size:14px;">Punto Inspector #${pt.id || (i+1)}</b><br/>
          <hr style="border:none; border-top:1px solid #ddd; margin:4px 0;" />
          <b>Red:</b> ${pt.type === 'start' ? '📍 Inicio Jornada' : pt.type === 'end' ? '🏁 Fin Jornada' : pt.type === 'canalizado' ? '⛖ Canalizado' : pt.type === 'incidence' ? '⚠️ Con Incidencia' : '⚡ Aéreo'}<br/>
          ${pt.incidences && pt.incidences.length > 0 ? `<b style="color:#dc2626;">Incidencias:</b> ${pt.incidences.join(', ')}<br/>` : ''}
          ${prevDistHtml}
          <div style="margin-top:6px; font-size:11px; color:#334155; background:#f1f5f9; padding:6px; border-radius:6px;">
            <b>📱 Hora Celular:</b> ${devTime}<br/>
            <b>🖥️ Recepción Servidor:</b> ${serverTime}
          </div>
        </div>
      `;

      marker.bindPopup(popupText);
    });

    if (bounds.length > 0) {
      const latLngBounds = L.latLngBounds(bounds);
      if (latLngBounds.isValid()) map.fitBounds(latLngBounds, { padding: [30, 30] });
    }

    leafletMapRef.current = map;

    return () => {
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
        leafletMapRef.current = null;
      }
    };
  }, [allPoints.length]);

  if (!reports || reports.length === 0 || allPoints.length === 0) return null;

  return (
    <div style={{ height: height, width: '100%', borderRadius: '12px', overflow: 'hidden', marginBottom: '24px', border: '5px solid #1E293B', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' }}>
      <div ref={mapRef} style={{ height: '100%', width: '100%' }} />
      <div style={{ background: '#0f172a', color: '#e2e8f0', padding: '10px 16px', fontSize: '12.5px', display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
        <span><strong>Leyenda Inspector:</strong></span>
        <span>🟢 Inicio</span>
        <span>⚡ Aéreo</span>
        <span>⛖ Canalizado</span>
        <span style={{ color: '#f87171' }}>⚠️ Incidencia</span>
        <span><span style={{ color: '#ea580c', fontWeight: 'bold' }}>- - -</span> 🟧 Tirada larga (&gt;150m) / Traslado (&gt;500m)</span>
        <span>🏁 Fin</span>
      </div>
    </div>
  );
};

const PortalAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const cleanInput = (str) => {
    if (!str) return '';
    return str
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const styles = {
    ...baseStyles,
    main: {
      ...baseStyles.main,
      margin: isMobile ? '12px auto' : '32px auto',
      padding: isMobile ? '0 12px' : '0 24px'
    },
    card: {
      ...baseStyles.card,
      padding: isMobile ? '16px' : '32px'
    },
    roleGrid: {
      ...baseStyles.roleGrid,
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)'
    },
    formGrid: {
      ...baseStyles.formGrid,
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)'
    },
    userGrid: {
      ...baseStyles.userGrid,
      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr'
    },
    filterGrid: {
      ...baseStyles.filterGrid,
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)'
    },
    dateRangeGroup: {
      ...baseStyles.dateRangeGroup,
      gridColumn: isMobile ? 'span 1' : 'span 2',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)'
    },
    headerContent: {
      ...baseStyles.headerContent,
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'stretch' : 'center',
      gap: isMobile ? '16px' : '0',
      textAlign: isMobile ? 'center' : 'left'
    },
    headerLeft: {
      ...baseStyles.headerLeft,
      flexDirection: isMobile ? 'column' : 'row',
      textAlign: isMobile ? 'center' : 'left',
      justifyContent: isMobile ? 'center' : 'flex-start'
    },
    userHeader: {
      ...baseStyles.userHeader,
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: isMobile ? 'stretch' : 'flex-start',
      gap: isMobile ? '16px' : '0'
    }
  };

  const isSuperAdmin = user?.usuario_ffm === 'IGNOROSA' || user?.role_name === 'SUPER_ADMIN';
  const isPEUser = user?.tipo_planta === 'PE';
  // 🔒 Seguridad: Usuarios de Planta Externa (PE, ej: ARHERNANDEZC) o usuarios que no sean admin están capados obligatoriamente
  const isPlantaFixed = !isSuperAdmin && (isPEUser || user?.role !== 'admin');

  // Helper for permissions
  const canAccess = (permission) => {
    if (!user) return false;
    // IGNOROSA has access to everything
    if (user.usuario_ffm === 'IGNOROSA' || user.role_name === 'SUPER_ADMIN') return true;
    if (user.usuario_ffm === 'TOT25CMXI2752' && ['admin:hallazgos_idr', 'admin:idr_dashboard', 'admin:idr_reports', 'admin:view_users', 'admin:reports', 'admin:dashboard'].includes(permission)) return true;
    if (!user.permissions) return false;
    return user.permissions.includes(permission);
  };

  const [activeCategory, setActiveCategory] = useState('admin');
  const [activeTab, setActiveTab] = useState('manage');
  const [selectedRole, setSelectedRole] = useState('technician');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [searchResultsList, setSearchResultsList] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [message, setMessage] = useState({ show: false, text: '', type: '' });
  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [reportFilters, setReportFilters] = useState({
    region: '', distrito: '', fechaInicio: '', fechaFin: '', usuario_ffm: '', tipo_planta: isPEUser ? 'PE' : ''
  });
  const [reportLoading, setReportLoading] = useState(false);
  const [activeRoutes, setActiveRoutes] = useState([]);
  const [routesLoading, setRoutesLoading] = useState(false);
  const [searchRoutesUser, setSearchRoutesUser] = useState('');
  const [exporting, setExporting] = useState(false);
  const [exportFilters, setExportFilters] = useState({
    role: 'all',
    status: 'all',
    tipo_planta: isPEUser ? 'PE' : 'all'
  });
  const [formData, setFormData] = useState({
    full_name: '', usuario_ffm: '', curp: '', region: '', distrito: '',
    telefono: '', email: '', empresa: '', cluster: '', gerente: '', role: 'technician',
    tipo_planta: isPEUser ? 'PE' : 'PI'
  });
  const [createdUser, setCreatedUser] = useState(null);
  const [previewData, setPreviewData] = useState({
    reports: [],
    total_records: 0,
    total_pages: 0,
    page: 1,
    limit: 10
  });
  const [previewLoading, setPreviewLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [editComment, setEditComment] = useState('');
  const [editEvidenceFile, setEditEvidenceFile] = useState(null);
  const [editEvidencePreview, setEditEvidencePreview] = useState(null);
  const [selectedEvidenceModalImage, setSelectedEvidenceModalImage] = useState(null);

  const handleStartEdit = () => {
    setIsEditing(true);
    setEditComment('');
    setEditEvidenceFile(null);
    if (editEvidencePreview) {
      URL.revokeObjectURL(editEvidencePreview);
    }
    setEditEvidencePreview(null);
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditFormData(searchResults);
    setEditComment('');
    setEditEvidenceFile(null);
    if (editEvidencePreview) {
      URL.revokeObjectURL(editEvidencePreview);
    }
    setEditEvidencePreview(null);
  };

  const handleEvidenceFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        showMessage('❌ El archivo debe ser una imagen (JPG, PNG, WEBP, GIF)', 'error');
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        showMessage('❌ La imagen de evidencia no debe superar los 10MB', 'error');
        return;
      }
      setEditEvidenceFile(file);
      if (editEvidencePreview) {
        URL.revokeObjectURL(editEvidencePreview);
      }
      setEditEvidencePreview(URL.createObjectURL(file));
    }
  };

  const API_URL = process.env.REACT_APP_API_URL || 'https://analisisoperativo.com/api/v1';

  const [dashboardFilters, setDashboardFilters] = useState({
    region: '', distrito: '', empresa: '', usuario_ffm: '', nombre_tecnico: '', fecha_inicio: '', fecha_fin: ''
  });
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [selectedTechReports, setSelectedTechReports] = useState(null);
  const [showReportsModal, setShowReportsModal] = useState(false);
  const [selectedMapReport, setSelectedMapReport] = useState(null);

  // 🔍 ESTADOS PARA DASHBOARD DE INSPECTORES (IDR)
  const [idrFilters, setIdrFilters] = useState({
    region: '', distrito: '', usuario_ffm: '', fecha_inicio: '', fecha_fin: ''
  });
  const [idrData, setIdrData] = useState(null);
  const [idrLoading, setIdrLoading] = useState(false);
  const [selectedInspectorTechReports, setSelectedInspectorTechReports] = useState(null);
  const [showInspectorReportsModal, setShowInspectorReportsModal] = useState(false);
  const [selectedInspectorMapReport, setSelectedInspectorMapReport] = useState(null);

  const fetchIdrDashboardData = async (e) => {
    e?.preventDefault();
    setIdrLoading(true);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const params = new URLSearchParams();
      if (idrFilters.region) params.append('region', idrFilters.region);
      if (idrFilters.distrito) params.append('distrito', idrFilters.distrito);
      if (idrFilters.usuario_ffm) params.append('usuario_ffm', idrFilters.usuario_ffm.toUpperCase());
      if (idrFilters.fecha_inicio) params.append('fecha_inicio', idrFilters.fecha_inicio);
      if (idrFilters.fecha_fin) params.append('fecha_fin', idrFilters.fecha_fin);

      const response = await fetch(`${API_URL}/admin/inspector-dashboard?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok) {
        setIdrData(data);
        showMessage('✅ Datos de Dashboard IDR cargados', 'success');
      } else {
        showMessage(`❌ Error: ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    } finally {
      setIdrLoading(false);
    }
  };

  // ⏰ ESTADOS PARA AUDITORÍA DE HORARIOS (TIEMPOS ALTERADOS)
  const [timeAuditFilters, setTimeAuditFilters] = useState({
    region: '',
    distrito: '',
    empresa: '',
    usuario_ffm: '',
    tipo_planta: isPEUser ? 'PE' : '',
    fecha_inicio: (() => {
      const d = new Date();
      d.setDate(d.getDate() - 7);
      return d.toISOString().split('T')[0];
    })(),
    fecha_fin: new Date().toISOString().split('T')[0]
  });
  const [timeAuditData, setTimeAuditData] = useState(null);
  const [timeAuditLoading, setTimeAuditLoading] = useState(false);
  const [timeAuditSortField, setTimeAuditSortField] = useState('desfase_maximo');
  const [timeAuditSortOrder, setTimeAuditSortOrder] = useState('asc'); // asc porque valores más negativos (ej. -300) son peores
  const [userSuggestions, setUserSuggestions] = useState([]);

  const handleTimeAuditUserChange = async (val) => {
    const upperVal = val.toUpperCase();
    setTimeAuditFilters(prev => ({ ...prev, usuario_ffm: upperVal }));
    
    if (upperVal.length >= 2) {
      try {
        const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
        const response = await fetch(`${API_URL}/admin/search-user?query=${encodeURIComponent(upperVal)}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setUserSuggestions(Array.isArray(data) ? data : []);
        } else {
          setUserSuggestions([]);
        }
      } catch (error) {
        console.error("Error fetching user suggestions:", error);
        setUserSuggestions([]);
      }
    } else {
      setUserSuggestions([]);
    }
  };

  const fetchTimeAuditData = async (e) => {
    e?.preventDefault();
    setTimeAuditLoading(true);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const params = new URLSearchParams();
      if (timeAuditFilters.region) params.append('region', timeAuditFilters.region.toUpperCase());
      if (timeAuditFilters.distrito) params.append('distrito', timeAuditFilters.distrito.toUpperCase());
      if (timeAuditFilters.empresa) params.append('empresa', timeAuditFilters.empresa.toUpperCase());
      if (timeAuditFilters.usuario_ffm) params.append('usuario_ffm', timeAuditFilters.usuario_ffm.toUpperCase());
      if (timeAuditFilters.fecha_inicio) params.append('fecha_inicio', timeAuditFilters.fecha_inicio);
      if (timeAuditFilters.fecha_fin) params.append('fecha_fin', timeAuditFilters.fecha_fin);
      const effectivePlanta = isPEUser ? 'PE' : (timeAuditFilters.tipo_planta || '');
      if (effectivePlanta) params.append('tipo_planta', effectivePlanta);

      const response = await fetch(`${API_URL}/admin/time-discrepancies?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok) {
        setTimeAuditData(data);
        showMessage('✅ Datos de auditoría de tiempos cargados', 'success');
      } else {
        showMessage(`❌ Error: ${data.detail || 'Error al consultar backend'}`, 'error');
      }
    } catch (error) {
      console.error("Error fetching time audit data:", error);
      showMessage(`❌ Error de conexión: ${error.message}`, 'error');
    } finally {
      setTimeAuditLoading(false);
    }
  };

  // 🛡️ NUEVOS ESTADOS PARA RBAC
  const [rbacUsers, setRbacUsers] = useState([]);
  const [rbacRoles, setRbacRoles] = useState([]);

  // 📋 ESTADOS PARA CUADRILLAS PACTADAS
  const [pactadasStartDate, setPactadasStartDate] = useState('');
  const [pactadasEndDate, setPactadasEndDate] = useState('');
  const [cierreFile, setCierreFile] = useState(null);
  const [pactadasFile, setPactadasFile] = useState(null);
  const [pactadasLoading, setPactadasLoading] = useState(false);
  const [pactadasResult, setPactadasResult] = useState(null);
  const [pactadasRegions, setPactadasRegions] = useState([]);
  const [pactadasDistritos, setPactadasDistritos] = useState([]);
  const [pactadasEmpresas, setPactadasEmpresas] = useState([]);
  // Fase 2: filtros independientes (se inicializan desde Fase 1 pero son editables)
  const [p2Regions, setP2Regions] = useState([]);
  const [p2Distritos, setP2Distritos] = useState([]);
  const [p2Empresas, setP2Empresas] = useState([]);
  const [cleanCierreFilename, setCleanCierreFilename] = useState('');
  const [cleanLoading, setCleanLoading] = useState(false);
  const [cierreSourceOption, setCierreSourceOption] = useState('temp'); // 'temp' o 'upload'
  const [modifiedCierreFile, setModifiedCierreFile] = useState(null);
  const [rbacPermissions, setRbacPermissions] = useState([]);
  const [rbacLoading, setRbacLoading] = useState(false);
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [newRoleData, setNewRoleData] = useState({ name: '', description: '', permission_ids: [] });
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [targetUserForRole, setTargetUserForRole] = useState(null);
  const [showCreateAdminModal, setShowCreateAdminModal] = useState(false);
  const [newAdminData, setNewAdminData] = useState({
    full_name: '',
    email: '',
    telefono: '',
    usuario_ffm: '',
    role_id: null,
    tipo_planta: 'PE'
  });

  // 🚨 NUEVO: Estados para modal de detalles de usuario con penalizaciones
  const [showUserDetailsModal, setShowUserDetailsModal] = useState(false);
  const [selectedUserForDetails, setSelectedUserForDetails] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);
  const [uploadPreview, setUploadPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [updateFilterField, setUpdateFilterField] = useState('ALL');
  const [acceptedUpdates, setAcceptedUpdates] = useState({});
  const [acceptedCreations, setAcceptedCreations] = useState({});
  const [updatesSearchQuery, setUpdatesSearchQuery] = useState('');

  // 🤖 ESTADOS PARA FEATURE FLAG IA POR PROVEEDOR (SOLO SUPERADMINISTRADOR)
  const [aiProviders, setAiProviders] = useState([]);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiToggling, setAiToggling] = useState({});
  const [aiSearchQuery, setAiSearchQuery] = useState('');

  const fetchAiFeatureFlags = async () => {
    if (user?.usuario_ffm !== 'IGNOROSA' && user?.role_name !== 'SUPER_ADMIN') return;
    setAiLoading(true);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/ai-feature-flags`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setAiProviders(data.providers || []);
      } else {
        showMessage(`❌ Error: ${data.detail || 'No se pudieron cargar los proveedores'}`, 'error');
      }
    } catch (error) {
      console.error("Error al cargar banderas de IA:", error);
      showMessage('❌ Error de conexión al cargar módulo de IA', 'error');
    } finally {
      setAiLoading(false);
    }
  };

  const handleToggleAiFeature = async (empresa, currentStatus) => {
    const newStatus = !currentStatus;
    setAiToggling(prev => ({ ...prev, [empresa]: true }));
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/ai-feature-flags/${encodeURIComponent(empresa)}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ ia_activa: newStatus })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setAiProviders(prev => prev.map(p => p.empresa === empresa ? { ...p, ia_activa: newStatus } : p));
        showMessage(`✅ Evaluación por IA ${newStatus ? 'ACTIVADA' : 'DESACTIVADA'} para ${empresa}`, 'success');
      } else {
        showMessage(`❌ Error: ${data.detail || 'No se pudo modificar el estado de IA'}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión al guardar cambio', 'error');
    } finally {
      setAiToggling(prev => ({ ...prev, [empresa]: false }));
    }
  };

  useEffect(() => {
    if (activeTab === 'ai-feature-flag') {
      fetchAiFeatureFlags();
    }
  }, [activeTab]);

  // 📊 ESTADOS Y HANDLERS PARA PESTAÑA DEDICADA "AUDITORÍA IA" (PERMISO: admin:ai_audits)
  const [aiAuditFilters, setAiAuditFilters] = useState({
    estado_ia: 'TODAS',
    empresa: '',
    usuario_ffm: '',
    fecha_inicio: '',
    fecha_fin: ''
  });
  const [aiAuditData, setAiAuditData] = useState(null);
  const [aiAuditLoading, setAiAuditLoading] = useState(false);
  const [aiAuditPage, setAiAuditPage] = useState(1);
  const [selectedAiImageModal, setSelectedAiImageModal] = useState(null);

  const fetchAiAuditData = async (e, pageNum = 1) => {
    e?.preventDefault();
    if (!canAccess('admin:ai_audits')) return;
    setAiAuditLoading(true);
    setAiAuditPage(pageNum);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const params = new URLSearchParams();
      if (aiAuditFilters.estado_ia && aiAuditFilters.estado_ia !== 'TODAS') params.append('estado_ia', aiAuditFilters.estado_ia);
      if (aiAuditFilters.empresa) params.append('empresa', aiAuditFilters.empresa.toUpperCase());
      if (aiAuditFilters.usuario_ffm) params.append('usuario_ffm', aiAuditFilters.usuario_ffm.toUpperCase());
      if (aiAuditFilters.fecha_inicio) params.append('fecha_inicio', aiAuditFilters.fecha_inicio);
      if (aiAuditFilters.fecha_fin) params.append('fecha_fin', aiAuditFilters.fecha_fin);
      params.append('page', pageNum);
      params.append('limit', 12);

      const response = await fetch(`${API_URL}/admin/ai-evaluations?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setAiAuditData(data);
      } else {
        showMessage(`❌ Error: ${data.detail || 'No se pudieron cargar las evaluaciones de IA'}`, 'error');
      }
    } catch (error) {
      console.error("Error al cargar auditoría de IA:", error);
      showMessage('❌ Error de conexión al consultar evaluaciones de IA', 'error');
    } finally {
      setAiAuditLoading(false);
    }
  };

  const [feedbackForms, setFeedbackForms] = useState({});

  const handleSendSupervisorFeedback = async (segmentId, acuerdo, customCorrectLabel = null) => {
    const form = feedbackForms[segmentId] || {};
    const comentario = form.comentario || '';
    
    if (!acuerdo && !comentario.trim()) {
      showMessage('⚠️ Por favor ingresa un comentario explicando la alucinación u observación para entrenar a la IA.', 'error');
      return;
    }

    const selectedLabel = customCorrectLabel || (acuerdo ? 'CORRECTA' : (form.correctLabel || 'INCORRECTA'));

    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/ai-evaluations/${segmentId}/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          acuerdo: acuerdo,
          comentario: comentario,
          correct_label: selectedLabel
        })
      });
      const data = await response.json();
      if (response.ok && data.success) {
        showMessage('✅ Retroalimentación guardada. La IA aprenderá de esta observación en siguientes análisis.', 'success');
        setFeedbackForms(prev => ({ ...prev, [segmentId]: { showForm: false, comentario: '', correctLabel: 'INCORRECTA' } }));
        fetchAiAuditData(null, aiAuditPage);
      } else {
        showMessage(`❌ Error: ${data.detail || 'No se pudo guardar el feedback'}`, 'error');
      }
    } catch (err) {
      console.error("Error enviando feedback:", err);
      showMessage('❌ Error de conexión al guardar el feedback', 'error');
    }
  };

  const handleReevaluateSegment = async (segmentId) => {
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      showMessage('🔄 Reevaluando fotos con nuevo motor de filtros e IA...', 'info');
      const response = await fetch(`${API_URL}/admin/ai-evaluations/${segmentId}/re-evaluate`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok && data.success) {
        showMessage('✅ Segmento reevaluado exitosamente con los nuevos criterios.', 'success');
        fetchAiAuditData(null, aiAuditPage);
      } else {
        showMessage(`❌ Error: ${data.detail || 'No se pudo reevaluar'}`, 'error');
      }
    } catch (err) {
      console.error("Error reevaluando segmento:", err);
      showMessage('❌ Error de conexión al reevaluar', 'error');
    }
  };

  useEffect(() => {
    if (activeTab === 'ai-audits') {
      fetchAiAuditData(null, 1);
    }
  }, [activeTab]);



  // Calcular la semana ISO actual
  const getCurrentWeekNumber = () => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    const yearStart = new Date(d.getFullYear(), 0, 1);
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  };

  // Estados para historial y acumulados de técnicos
  const [uploadWeekNumber, setUploadWeekNumber] = useState(getCurrentWeekNumber());
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyTech, setHistoryTech] = useState(null);
  const [techHistoryList, setTechHistoryList] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [showHistoryMatchesModal, setShowHistoryMatchesModal] = useState(false);
  const [historyMatchesList, setHistoryMatchesList] = useState([]);

  // Efecto para hacer scroll al mapa cuando se abre
  useEffect(() => {
    if (selectedMapReport) {
      setTimeout(() => {
        const mapSection = document.getElementById('map-scroll-anchor');
        if (mapSection) {
          mapSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [selectedMapReport]);

  // 📂 CATÁLOGOS DESDE EXCEL/CSV
  const [distritosCatalog, setDistritosCatalog] = useState([]);
  const [empresasCatalog, setEmpresasCatalog] = useState({});
  const [filteredDistritos, setFilteredDistritos] = useState([]);
  const [showDistritoSuggestions, setShowDistritoSuggestions] = useState(false);

  const fetchCatalogs = async () => {
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');

      const [distResp, empResp] = await Promise.all([
        fetch(`${API_URL}/catalog/distritos`, {
          headers: { 'Authorization': `Bearer ${token}` }
        }),
        fetch(`${API_URL}/catalog/empresas`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
      ]);

      if (distResp.ok) {
        const data = await distResp.json();
        setDistritosCatalog(data);
      }
      if (empResp.ok) {
        const data = await empResp.json();
        setEmpresasCatalog(data);
      }
    } catch (error) {
      console.error("Error fetching catalogs:", error);
    }
  };

  // 🔥 Cargar catálogos al montar el portal (distritos + empresas)
  useEffect(() => {
    fetchCatalogs();
  }, []);

  const [pactadasInfo, setPactadasInfo] = useState(null);

  const fetchPactadasInfo = async () => {
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/pactadas-info`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setPactadasInfo(data.data);
      }
    } catch (err) {
      console.error("Error fetching pactadas info:", err);
    }
  };

  useEffect(() => {
    if (activeTab === 'pactadas') {
      fetchPactadasInfo();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'time-audit' && !timeAuditData && !timeAuditLoading) {
      fetchTimeAuditData();
    }
  }, [activeTab]);

  const handleDistritoChange = (value) => {
    const val = value.toUpperCase();
    setFormData({ ...formData, distrito: val });

    if (val.length > 0) {
      const filtered = distritosCatalog.filter(d =>
        d.distrito.includes(val)
      ).slice(0, 10);
      setFilteredDistritos(filtered);
      setShowDistritoSuggestions(true);
    } else {
      setFilteredDistritos([]);
      setShowDistritoSuggestions(false);
    }
  };

  const selectDistrito = (item) => {
    setFormData({
      ...formData,
      distrito: item.distrito,
      region: item.region
    });
    setShowDistritoSuggestions(false);
  };

  const fetchDashboardData = async (e) => {
    e?.preventDefault();
    setDashboardLoading(true);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const params = new URLSearchParams();
      if (dashboardFilters.region) params.append('region', dashboardFilters.region);
      if (dashboardFilters.distrito) params.append('distrito', dashboardFilters.distrito);
      if (dashboardFilters.empresa) params.append('empresa', dashboardFilters.empresa);
      if (dashboardFilters.usuario_ffm) params.append('usuario_ffm', dashboardFilters.usuario_ffm.toUpperCase());
      if (dashboardFilters.nombre_tecnico) params.append('nombre_tecnico', dashboardFilters.nombre_tecnico);
      if (dashboardFilters.fecha_inicio) params.append('fecha_inicio', dashboardFilters.fecha_inicio);
      if (dashboardFilters.fecha_fin) params.append('fecha_fin', dashboardFilters.fecha_fin);

      const response = await fetch(`${API_URL}/admin/technician-dashboard?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok) {
        setDashboardData(data);
        showMessage('✅ Datos de dashboard cargados', 'success');
      } else {
        showMessage(`❌ Error: ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    } finally {
      setDashboardLoading(false);
    }
  };

  const showMessage = (text, type = 'success') => {
    setMessage({ show: true, text, type });
    if (type !== 'error') {
      setTimeout(() => setMessage({ show: false, text: '', type: '' }), 4000);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const query = searchQuery.trim().toUpperCase();
    if (!query) { showMessage('Por favor ingresa un usuario, nombre o CURP', 'error'); return; }
    setSearchLoading(true);
    setSearchResults(null);
    setSearchResultsList([]);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/search-user?query=${encodeURIComponent(query)}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok && data.users) {
        if (data.users.length === 1) {
          const user = data.users[0];
          setSearchResults(user);
          setEditFormData(user);
          setIsEditing(false);
          showMessage('Usuario encontrado', 'success');
        } else {
          setSearchResultsList(data.users);
          showMessage(`✅ ${data.users.length} coincidencias encontradas`, 'success');
        }
      } else {
        showMessage('Usuario no encontrado', 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    } finally {
      setSearchLoading(false);
    }
  };

  const selectUser = (user) => {
    setSearchResults(user);
    setEditFormData(user);
    setIsEditing(false);
    setSearchResultsList([]);
  };

  const handleChangePassword = async () => {
    if (!searchResults || !newPassword || newPassword.length < 8) {
      showMessage('La contraseña debe tener al menos 8 caracteres', 'error');
      return;
    }
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/auth/change-password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ usuario_ffm: searchResults.usuario_ffm, new_password: newPassword })
      });
      const data = await response.json();
      if (response.ok) {
        showMessage(`✅ Contraseña actualizada`, 'success');
        setNewPassword('');
      } else {
        showMessage(`❌ Error: ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const handleDeactivateUser = async (userId) => {
    if (!window.confirm(`⚠️ ¿Desactivar a ${searchResults.full_name}?`)) return;
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/deactivate-user/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ is_active: false })
      });
      const data = await response.json();
      if (response.ok) {
        showMessage(`✅ Usuario desactivado`, 'success');
        setSearchResults(null);
        setSearchQuery('');
      } else {
        showMessage(`❌ Error: ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const handleActivateUser = async (userId) => {
    if (!window.confirm(`✅ ¿Activar a ${searchResults.full_name}?`)) return;
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/activate-user/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ is_active: true })
      });
      const data = await response.json();
      if (response.ok) {
        showMessage(`✅ Usuario activado`, 'success');
        setSearchResults(null);
        setSearchQuery('');
      } else {
        showMessage(`❌ Error: ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const handleSaveUser = async () => {
    if (!editComment || editComment.trim().length < 3) {
      showMessage('❌ Es obligatorio ingresar un comentario o justificación válida (mínimo 3 caracteres).', 'error');
      return;
    }
    if (!editEvidenceFile) {
      showMessage('❌ Es obligatorio adjuntar una imagen de evidencia fotográfica.', 'error');
      return;
    }

    if (!window.confirm("¿Confirmar y guardar cambios con la evidencia adjunta?")) return;

    const cleanedEditData = {
      ...editFormData,
      full_name: cleanInput(editFormData.full_name),
      usuario_ffm: cleanInput(editFormData.usuario_ffm),
      curp: cleanInput(editFormData.curp),
      region: cleanInput(editFormData.region),
      distrito: cleanInput(editFormData.distrito),
      telefono: cleanInput(editFormData.telefono),
      email: cleanInput(editFormData.email),
      empresa: cleanInput(editFormData.empresa),
      cluster: cleanInput(editFormData.cluster),
      gerente: cleanInput(editFormData.gerente)
    };
    setEditFormData(cleanedEditData);

    if (/TO\d{3}$/.test(cleanedEditData.usuario_ffm || '')) {
      showMessage(`❌ El usuario tiene "TO###" al final en lugar de "T0###". Reemplace la "O" por un "0".`, 'error');
      return;
    }
    if ((cleanedEditData.usuario_ffm || '').length > 13) {
      showMessage(`❌ El usuario no puede tener más de 13 caracteres.`, 'error');
      return;
    }

    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const formDataToSend = new FormData();
      formDataToSend.append('comentario', editComment.trim());
      formDataToSend.append('evidencia', editEvidenceFile);

      if (cleanedEditData.full_name) formDataToSend.append('full_name', cleanedEditData.full_name);
      if (cleanedEditData.usuario_ffm) formDataToSend.append('usuario_ffm', cleanedEditData.usuario_ffm);
      if (cleanedEditData.curp) formDataToSend.append('curp', cleanedEditData.curp);
      if (cleanedEditData.region) formDataToSend.append('region', cleanedEditData.region);
      if (cleanedEditData.distrito) formDataToSend.append('distrito', cleanedEditData.distrito);
      if (cleanedEditData.telefono) formDataToSend.append('telefono', cleanedEditData.telefono);
      if (cleanedEditData.email) formDataToSend.append('email', cleanedEditData.email);
      if (cleanedEditData.empresa) formDataToSend.append('empresa', cleanedEditData.empresa);
      if (cleanedEditData.cluster) formDataToSend.append('cluster', cleanedEditData.cluster);
      if (cleanedEditData.gerente) formDataToSend.append('gerente', cleanedEditData.gerente);
      if (cleanedEditData.role) formDataToSend.append('role', cleanedEditData.role);
      if (cleanedEditData.tipo_planta) formDataToSend.append('tipo_planta', cleanedEditData.tipo_planta);

      const response = await fetch(`${API_URL}/admin/update-user/${searchResults.id}`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formDataToSend
      });
      const data = await response.json();
      if (response.ok) {
        showMessage('✅ Usuario actualizado exitosamente con evidencia', 'success');
        setSearchResults(data.user);
        setEditFormData(data.user);
        setIsEditing(false);
        setEditComment('');
        setEditEvidenceFile(null);
        if (editEvidencePreview) {
          URL.revokeObjectURL(editEvidencePreview);
        }
        setEditEvidencePreview(null);
      } else {
        showMessage(`❌ Error: ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const handleGeneratePassword = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*?-_";
    let pass = "";
    for (let i = 0; i < 16; i++) {
      pass += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setNewPassword(pass);
    setShowPassword(true);
  };

  const handleExportUsers = async (customFilters = null) => {
    setExporting(true);
    try {
      const filters = customFilters || exportFilters;
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const params = new URLSearchParams();
      if (filters.role && filters.role !== 'all') params.append('role', filters.role);
      if (filters.status && filters.status !== 'all') params.append('status', filters.status);
      const effectiveExportPlanta = isPEUser ? 'PE' : filters.tipo_planta;
      if (effectiveExportPlanta && effectiveExportPlanta !== 'all') params.append('tipo_planta', effectiveExportPlanta);

      const response = await fetch(`${API_URL}/admin/export-users?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        throw new Error('Error al exportar usuarios');
      }

      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);

      const now = new Date();
      const fecha = now.toISOString().split('T')[0].replace(/-/g, '');
      const hora = `${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}`;

      const roleTag = filters.role === 'all' ? 'todos' : filters.role;
      link.download = `usuarios_${roleTag}_${fecha}_${hora}.csv`;
      link.click();
      window.URL.revokeObjectURL(link.href);
      showMessage('✅ Usuarios exportados exitosamente (CSV)', 'success');
    } catch (error) {
      showMessage(`❌ Error: ${error.message}`, 'error');
    } finally {
      setExporting(false);
    }
  };

  const validateForm = () => {
    const required = ['full_name', 'usuario_ffm', 'curp', 'region', 'distrito', 'telefono', 'email'];
    if (selectedRole === 'technician') required.push('empresa', 'gerente');
    for (let field of required) {
      if (!formData[field] || formData[field].trim() === '') {
        showMessage(`❌ Campo obligatorio: ${field}`, 'error');
        return false;
      }
    }
    if (/TO\d{3}$/.test(formData.usuario_ffm)) {
      showMessage(`❌ El usuario tiene "TO###" al final en lugar de "T0###". Reemplace la "O" por un "0".`, 'error');
      return false;
    }
    return true;
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();

    const cleanedFormData = {
      ...formData,
      full_name: cleanInput(formData.full_name),
      usuario_ffm: cleanInput(formData.usuario_ffm),
      curp: cleanInput(formData.curp),
      region: cleanInput(formData.region),
      distrito: cleanInput(formData.distrito),
      telefono: cleanInput(formData.telefono),
      email: cleanInput(formData.email),
      empresa: cleanInput(formData.empresa),
      cluster: cleanInput(formData.cluster),
      gerente: cleanInput(formData.gerente)
    };
    setFormData(cleanedFormData);

    const required = ['full_name', 'usuario_ffm', 'curp', 'region', 'distrito', 'telefono', 'email'];
    if (selectedRole === 'technician') required.push('empresa', 'gerente');
    for (let field of required) {
      if (!cleanedFormData[field] || cleanedFormData[field].trim() === '') {
        showMessage(`❌ Campo obligatorio: ${field}`, 'error');
        return;
      }
    }
    if (/TO\d{3}$/.test(cleanedFormData.usuario_ffm)) {
      showMessage(`❌ El usuario tiene "TO###" al final en lugar de "T0###". Reemplace la "O" por un "0".`, 'error');
      return;
    }
    if (cleanedFormData.usuario_ffm.length > 13) {
      showMessage(`❌ El usuario no puede tener más de 13 caracteres.`, 'error');
      return;
    }

    // Generar contraseña de 16 caracteres una sola vez
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*?-_";
    let generatedPassword = "";
    for (let i = 0; i < 16; i++) {
      generatedPassword += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/create-user`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({
          ...cleanedFormData,
          usuario_ffm: cleanedFormData.usuario_ffm.toUpperCase(),
          full_name: cleanedFormData.full_name.toUpperCase(),
          curp: cleanedFormData.curp.toUpperCase(),
          region: cleanedFormData.region.toUpperCase(),
          distrito: cleanedFormData.distrito.toUpperCase(),
          empresa: cleanedFormData.empresa.toUpperCase(),
          gerente: cleanedFormData.gerente.toUpperCase(),
          cluster: cleanedFormData.cluster.toUpperCase(),
          role: selectedRole,
          password: generatedPassword,
          tipo_planta: cleanedFormData.tipo_planta || 'PI'
        })
      });
      const data = await response.json();
      if (response.ok) {
        showMessage(`✅ Usuario creado`, 'success');
        setCreatedUser({
          ...cleanedFormData,
          usuario_ffm: cleanedFormData.usuario_ffm.toUpperCase(),
          full_name: cleanedFormData.full_name.toUpperCase(),
          curp: cleanedFormData.curp.toUpperCase(),
          role: selectedRole,
          password: generatedPassword
        });
        setFormData({ full_name: '', usuario_ffm: '', curp: '', region: '', distrito: '', telefono: '', email: '', empresa: '', cluster: '', gerente: '', role: 'technician', tipo_planta: 'PI' });
      } else {
        showMessage(`❌ Error: ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const handleDownloadReport = async (e) => {
    e?.preventDefault();
    setReportLoading(true);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const params = new URLSearchParams();

      // AGREGAR TODOS LOS FILTROS - DEBEN SER EXACTAMENTE LOS MISMOS QUE EN VISTA PREVIA
      if (reportFilters.region) params.append('region', reportFilters.region);
      if (reportFilters.distrito) params.append('distrito', reportFilters.distrito);
      if (reportFilters.fechaInicio) params.append('fecha_inicio', reportFilters.fechaInicio);
      if (reportFilters.fechaFin) params.append('fecha_fin', reportFilters.fechaFin);
      if (reportFilters.usuario_ffm) {
        // Asegurar que esté en mayúsculas como en la BD
        params.append('usuario_ffm', reportFilters.usuario_ffm.toUpperCase());
      }
      const effectiveTipoPlanta = isPEUser ? 'PE' : (reportFilters.tipo_planta || '');
      if (effectiveTipoPlanta) params.append('tipo_planta', effectiveTipoPlanta);

      console.log("📤 Parámetros para descarga:", params.toString()); // Para debugging

      // La URL debe ser exactamente la misma
      const response = await fetch(`${API_URL}/simple-reports/export-csv?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error ${response.status}: ${errorText}`);
      }

      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);

      // Nombre del archivo basado en los filtros
      const now = new Date();
      const fecha = now.toISOString().split('T')[0].replace(/-/g, '');
      const hora = `${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}`;

      let filename = `reporte_${fecha}_${hora}`;
      if (reportFilters.usuario_ffm) {
        filename = `reporte_${reportFilters.usuario_ffm.toUpperCase()}_${fecha}_${hora}`;
      }
      if (reportFilters.region) {
        filename = `reporte_${reportFilters.region}_${fecha}_${hora}`;
      }

      link.download = `${filename}.csv`;
      link.click();
      window.URL.revokeObjectURL(link.href);
      showMessage('✅ Reporte descargado', 'success');
    } catch (error) {
      console.error("❌ Error en descarga:", error);
      showMessage(`❌ Error: ${error.message}`, 'error');
    } finally {
      setReportLoading(false);
    }
  };

  // Función auxiliar para cargar reportes con una página específica
  const handlePreviewReportsWithPage = async (page) => {
    setPreviewLoading(true);

    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const params = new URLSearchParams();

      // Agregar todos los filtros existentes
      if (reportFilters.region) params.append('region', reportFilters.region);
      if (reportFilters.distrito) params.append('distrito', reportFilters.distrito);
      if (reportFilters.fechaInicio) params.append('fecha_inicio', reportFilters.fechaInicio);
      if (reportFilters.fechaFin) params.append('fecha_fin', reportFilters.fechaFin);
      if (reportFilters.usuario_ffm) params.append('usuario_ffm', reportFilters.usuario_ffm.toUpperCase());
      const effectiveTipoPlanta = isPEUser ? 'PE' : (reportFilters.tipo_planta || '');
      if (effectiveTipoPlanta) params.append('tipo_planta', effectiveTipoPlanta);

      // Parámetros de paginación
      params.append('page', page);
      params.append('limit', previewData.limit);

      const response = await fetch(`${API_URL}/simple-reports/preview-reports?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const data = await response.json();

      if (response.ok) {
        setPreviewData(data);
      } else {
        showMessage(`❌ Error: ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    } finally {
      setPreviewLoading(false);
    }
  };

  // Función para vista previa de reportes
  const handlePreviewReports = async (e) => {
    e?.preventDefault();
    setShowPreview(true);

    // Resetear a página 1 cuando se hace una nueva búsqueda
    await handlePreviewReportsWithPage(1);
  };

  // Función para cambiar página
  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > previewData.total_pages) return;

    setPreviewData(prev => ({ ...prev, page: newPage }));

    // Recargar datos con la nueva página usando una función para asegurar que tenemos el estado actualizado
    setTimeout(() => {
      handlePreviewReportsWithPage(newPage);
    }, 100);
  };

  // Función para cambiar límite por página
  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setPreviewData(prev => ({ ...prev, limit: newLimit, page: 1 }));

    // Recargar datos después de cambiar el límite
    setTimeout(() => {
      handlePreviewReportsWithPage(1);
    }, 100);
  };

  // Función para descargar después de ver vista previa
  const handleDownloadAfterPreview = async () => {
    // Usar los mismos filtros de la vista previa
    setReportLoading(true);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const params = new URLSearchParams();

      // AGREGAR LOS MISMOS FILTROS QUE SE USARON EN LA VISTA PREVIA
      if (reportFilters.region) params.append('region', reportFilters.region);
      if (reportFilters.distrito) params.append('distrito', reportFilters.distrito);
      if (reportFilters.fechaInicio) params.append('fecha_inicio', reportFilters.fechaInicio);
      if (reportFilters.fechaFin) params.append('fecha_fin', reportFilters.fechaFin);
      if (reportFilters.usuario_ffm) params.append('usuario_ffm', reportFilters.usuario_ffm.toUpperCase());
      const effectiveTipoPlanta = isPEUser ? 'PE' : (reportFilters.tipo_planta || '');
      if (effectiveTipoPlanta) params.append('tipo_planta', effectiveTipoPlanta);

      console.log("📤 Descargando con filtros:", params.toString()); // Para debugging

      const response = await fetch(`${API_URL}/simple-reports/export-csv?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error ${response.status}: ${errorText}`);
      }

      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);

      // Nombre del archivo
      const now = new Date();
      const fecha = now.toISOString().split('T')[0].replace(/-/g, '');
      const hora = `${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}`;

      let filename = `reporte_vista_previa_${fecha}_${hora}`;
      if (reportFilters.usuario_ffm) {
        filename = `reporte_${reportFilters.usuario_ffm.toUpperCase()}_${fecha}_${hora}`;
      }

      link.download = `${filename}.csv`;
      link.click();
      window.URL.revokeObjectURL(link.href);
      showMessage(`✅ Descargados ${previewData.total_records} registros filtrados`, 'success');
    } catch (error) {
      console.error("❌ Error en descarga después de vista previa:", error);
      showMessage(`❌ Error: ${error.message}`, 'error');
    } finally {
      setReportLoading(false);
    }
  };

  const handleSearchActiveRoutes = async (e) => {
    e?.preventDefault();
    setRoutesLoading(true);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const params = new URLSearchParams();
      if (searchRoutesUser.trim()) params.append('usuario_ffm', searchRoutesUser.toUpperCase());
      const response = await fetch(`${API_URL}/admin/active-routes?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok) {
        setActiveRoutes(data.routes);
        showMessage(`✅ ${data.routes.length} recorrido(s) encontrado(s)`, 'success');
      } else {
        showMessage(`❌ ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    } finally {
      setRoutesLoading(false);
    }
  };

  const handleCloseRoute = async (routeId, usuario) => {
    if (!window.confirm(`⚠️ ¿Cerrar recorrido de ${usuario}?`)) return;
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/close-route/${routeId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok) {
        showMessage(`✅ Recorrido cerrado`, 'success');
        handleSearchActiveRoutes();
      } else {
        showMessage(`❌ ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const handleReactivateRoute = async (routeId, usuario) => {
    if (!window.confirm(`⚠️ ¿Deseas REACTIVAR el recorrido de ${usuario}?\n\nEsto permitirá que el técnico pueda seguir registrando puntos en el mismo recorrido.`)) return;
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/reactivate-route/${routeId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok) {
        showMessage(`✅ Recorrido reactivado para ${usuario}`, 'success');
        handleSearchActiveRoutes();
      } else {
        showMessage(`❌ ${data.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const handleExportRoutes = async () => {
    setExporting(true);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const params = new URLSearchParams();
      if (searchRoutesUser.trim()) params.append('usuario_ffm', searchRoutesUser.toUpperCase());
      const response = await fetch(`${API_URL}/admin/export-active-routes?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Error descargando CSV');
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const now = new Date();
      const fecha = now.toISOString().split('T')[0].replace(/-/g, '');
      const hora = `${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}`;
      link.download = `recorridos_activos_${fecha}_${hora}.csv`;
      link.click();
      window.URL.revokeObjectURL(link.href);
      showMessage('✅ Exportado', 'success');
    } catch (error) {
      showMessage(`❌ Error: ${error.message}`, 'error');
    } finally {
      setExporting(false);
    }
  };

  const handleLogout = () => {
    if (window.confirm('¿Cerrar sesión?')) {
      logout();
      navigate('/login');
    }
  };

  const copyToClipboard = (text, shouldCloseModal = false) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        showMessage('✅ Copiado al portapapeles', 'success');
        if (shouldCloseModal) setCreatedUser(null);
      }).catch(() => {
        fallbackCopyTextToClipboard(text, shouldCloseModal);
      });
    } else {
      fallbackCopyTextToClipboard(text, shouldCloseModal);
    }
  };

  const fallbackCopyTextToClipboard = (text, shouldCloseModal) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      showMessage('✅ Copiado al portapapeles', 'success');
      if (shouldCloseModal) setCreatedUser(null);
    } catch (err) {
      showMessage('❌ No se pudo copiar', 'error');
    }
    document.body.removeChild(textArea);
  };


  const handleCleanCierre = async (e) => {
    e.preventDefault();
    if (!cierreFile) {
      showMessage('❌ Por favor carga el archivo de cierre diario (.csv).', 'error');
      return;
    }

    setCleanLoading(true);
    setCleanCierreFilename('');

    // Helper para comprimir un archivo con gzip usando la API nativa de JavaScript
    const compressFileIfNeeded = async (file) => {
      if (file && file.size > 512 * 1024 && typeof CompressionStream !== 'undefined') {
        try {
          const stream = file.stream().pipeThrough(new CompressionStream('gzip'));
          const compressedBlob = await new Response(stream).blob();
          return new File([compressedBlob], `${file.name}.gz`, { type: 'application/gzip' });
        } catch (err) {
          console.error("Error comprimiendo archivo:", err);
          return file;
        }
      }
      return file;
    };

    try {
      const finalCierreFile = await compressFileIfNeeded(cierreFile);
      const formDataUpload = new FormData();
      formDataUpload.append('cierre_file', finalCierreFile);
      formDataUpload.append('region', pactadasRegions.join(','));
      formDataUpload.append('distrito', pactadasDistritos.join(','));
      formDataUpload.append('empresa', pactadasEmpresas.join(','));

      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/clean-cierre`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formDataUpload
      });

      if (!response.ok) {
        let errorMsg = `Error del servidor (${response.status})`;
        try {
          const rawText = await response.text();
          try {
            const errData = JSON.parse(rawText);
            if (errData && errData.detail) errorMsg = errData.detail;
          } catch (_) {
            if (response.status === 504) {
              errorMsg = 'El proceso excedió el tiempo de espera (504 Gateway Timeout).';
            }
          }
        } catch (_) {}
        showMessage(`❌ ${errorMsg}`, 'error');
        return;
      }

      const data = await response.json();
      if (data.success) {
        setCleanCierreFilename(data.filename);
        // Heredar filtros de Fase 1 a Fase 2 automáticamente (el usuario puede modificarlos luego)
        setP2Regions([...pactadasRegions]);
        setP2Distritos([...pactadasDistritos]);
        setP2Empresas([...pactadasEmpresas]);
        showMessage('✅ Archivo de cierre limpiado con éxito. Ahora puedes continuar al Paso 2.', 'success');
      } else {
        showMessage(`❌ Error: ${data.detail || 'Error al limpiar cierre'}`, 'error');
      }
    } catch (error) {
      console.error("Error al limpiar cierre diario:", error);
      showMessage('❌ Error de conexión al limpiar archivo', 'error');
    } finally {
      setCleanLoading(false);
    }
  };

  const handleProcessPactadas = async (e) => {
    e.preventDefault();
    if (!pactadasStartDate || !pactadasEndDate) {
      showMessage('❌ Por favor selecciona ambas fechas.', 'error');
      return;
    }

    if (cierreSourceOption === 'temp' && !cleanCierreFilename) {
      showMessage('❌ Primero debes limpiar el cierre diario en el Paso 1.', 'error');
      return;
    }
    if (cierreSourceOption === 'upload' && !modifiedCierreFile) {
      showMessage('❌ Por favor carga el archivo de cierre corregido (.csv).', 'error');
      return;
    }

    setPactadasLoading(true);
    setPactadasResult(null);

    // Helper para comprimir un archivo con gzip usando la API nativa de JavaScript
    const compressFileIfNeeded = async (file) => {
      if (file && file.size > 512 * 1024 && typeof CompressionStream !== 'undefined') {
        try {
          const stream = file.stream().pipeThrough(new CompressionStream('gzip'));
          const compressedBlob = await new Response(stream).blob();
          return new File([compressedBlob], `${file.name}.gz`, { type: 'application/gzip' });
        } catch (err) {
          console.error("Error comprimiendo archivo:", err);
          return file;
        }
      }
      return file;
    };

    try {
      const formDataUpload = new FormData();
      
      if (cierreSourceOption === 'temp') {
        formDataUpload.append('cierre_temp_filename', cleanCierreFilename);
        formDataUpload.append('cierre_is_already_clean', 'true');
      } else {
        const finalCierreFile = await compressFileIfNeeded(modifiedCierreFile);
        formDataUpload.append('cierre_file', finalCierreFile);
        formDataUpload.append('cierre_is_already_clean', 'true');
      }

      const finalPactadasFile = pactadasFile ? await compressFileIfNeeded(pactadasFile) : null;
      if (finalPactadasFile) {
        formDataUpload.append('pactadas_file', finalPactadasFile);
      }
      
      formDataUpload.append('start_date', pactadasStartDate);
      formDataUpload.append('end_date', pactadasEndDate);
      // Usar filtros específicos de Fase 2 (independientes de Fase 1)
      formDataUpload.append('region', p2Regions.join(','));
      formDataUpload.append('distrito', p2Distritos.join(','));
      formDataUpload.append('empresa', p2Empresas.join(','));

      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/process-pactadas`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formDataUpload
      });

      if (!response.ok) {
        let errorMsg = `Error del servidor (${response.status})`;
        try {
          const rawText = await response.text();
          try {
            const errData = JSON.parse(rawText);
            if (errData && errData.detail) errorMsg = errData.detail;
          } catch (_) {
            if (response.status === 504) {
              errorMsg = 'El proceso excedió el tiempo de espera del servidor (504 Gateway Timeout). Puede tardar más de lo permitido o intente filtrar por un rango de fechas menor.';
            }
          }
        } catch (_) {}
        showMessage(`❌ ${errorMsg}`, 'error');
        return;
      }

      const data = await response.json();
      if (data.success) {
        setPactadasResult(data.data);
        fetchPactadasInfo();
        showMessage('✅ Procesamiento de cuadrillas pactadas completado con éxito', 'success');
      } else {
        showMessage(`❌ Error: ${data.detail || 'Error en procesamiento'}`, 'error');
      }
    } catch (error) {
      console.error("Error al procesar cuadrillas pactadas:", error);
      showMessage('❌ Error de conexión al procesar archivos', 'error');
    } finally {
      setPactadasLoading(false);
    }
  };

  const handleDownloadPactadasFile = async (filename) => {
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/download-pactadas-file?filename=${filename}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Error al descargar archivo');
      
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      showMessage(`❌ Error: ${error.message}`, 'error');
    }
  };

  const categories = [
    { id: 'admin', label: 'Administración', icon: '⚙️', color: '#3B82F6' },
    { id: 'external', label: 'Operación y Reportes', icon: '🌐', color: '#10B981' },
    { id: 'idr', label: 'Inspección de Red', icon: '🔍', color: '#8B5CF6' }
  ].filter(cat => isPEUser ? cat.id !== 'idr' : true);

  const tabConfig = [
    // Categoría: Administración
    { id: 'manage', label: 'Gestionar Usuarios', icon: '👥', category: 'admin', permission: 'admin:view_users' },
    { id: 'create', label: 'Crear Usuario', icon: '➕', category: 'admin', permission: 'admin:create_user' },
    { id: 'rbac', label: 'Roles y Permisos', icon: '🛡️', category: 'admin', permission: 'system:manage_rbac' },
    { id: 'ai-feature-flag', label: 'Módulo IA', icon: '🤖', category: 'admin', customFilter: (u) => u?.usuario_ffm === 'IGNOROSA' || u?.role_name === 'SUPER_ADMIN' },
    { id: 'relocate-tech', label: 'Reubicar Técnico', icon: '🔀', category: 'admin', customFilter: (u) => u?.usuario_ffm === 'IGNOROSA' },


    // Categoría: Operación y Reportes
    { id: 'reports', label: 'Reportes', icon: '📊', category: 'external', permission: 'admin:reports' },
    { id: 'close-routes', label: 'Recorridos Activos', icon: '🚗', category: 'external', permission: 'admin:active_routes' },
    { id: 'dashboard', label: 'Dashboard Técnicos', icon: '📈', category: 'external', permission: 'admin:dashboard' },
    { id: 'time-audit', label: 'Auditoría de Horarios', icon: '⏰', category: 'external', permission: 'admin:time_audit' },
    { id: 'ai-audits', label: 'Auditoría IA', icon: '🔍', category: 'external', permission: 'admin:ai_audits' },
    { id: 'pactadas', label: 'Cuadrillas Pactadas', icon: '📋', category: 'external', customFilter: (u) => u?.usuario_ffm === 'IGNOROSA' },


    // Categoría: IDR (Placeholders - Solo Planta Interna)
    { id: 'idr-dashboard', label: 'Dashboard IDR', icon: '📈', category: 'idr', permission: 'admin:idr_dashboard' },
    { id: 'idr-reports', label: 'Exportar IDR', icon: '📥', category: 'idr', permission: 'admin:idr_reports' },
    { id: 'idr-hallazgos', label: 'Cargar Hallazgos IDR', icon: '📤', category: 'idr', permission: 'admin:hallazgos_idr' }
  ].filter(tab => {
    if (isPEUser && tab.category === 'idr') return false;
    if (tab.customFilter) return tab.customFilter(user);
    return !tab.permission || canAccess(tab.permission);
  });

  const visibleCategories = categories.filter(cat =>
    tabConfig.some(tab => tab.category === cat.id)
  );

  const filteredTabs = tabConfig.filter(tab => tab.category === activeCategory);

  // Set default tab if current is not accessible
  useEffect(() => {
    if (tabConfig.length > 0) {
      const currentTab = tabConfig.find(t => t.id === activeTab);
      if (!currentTab) {
        setActiveTab(tabConfig[0].id);
        setActiveCategory(tabConfig[0].category);
      } else {
        setActiveCategory(currentTab.category);
      }
    }
  }, [user]);

  // 🔗 Soporte para abrir pestaña directamente desde ?tab= (ej: ?tab=reports o ?tab=dashboard)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');
    if (tabParam && tabConfig.length > 0) {
      const target = tabConfig.find(t => t.id === tabParam);
      if (target) {
        setActiveTab(target.id);
        setActiveCategory(target.category);
      }
    }
  }, [location.search, tabConfig]);

  // 🔒 Si el usuario es Gerente de Distrito, forzar sus filtros a su distrito y región asignados
  useEffect(() => {
    if (user?.role === 'district_manager') {
      if (user.region || user.distrito) {
        setReportFilters(prev => ({
          ...prev,
          region: user.region || prev.region,
          distrito: user.distrito || prev.distrito
        }));
        setDashboardFilters(prev => ({
          ...prev,
          region: user.region || prev.region,
          distrito: user.distrito || prev.distrito
        }));
      }
    }
  }, [user]);

  // 🔒 Si el usuario es de Planta Externa (PE, ej: ARHERNANDEZC), forzar sus filtros a PE
  useEffect(() => {
    if (isPEUser) {
      setReportFilters(prev => ({ ...prev, tipo_planta: 'PE' }));
      setExportFilters(prev => ({ ...prev, tipo_planta: 'PE' }));
      setFormData(prev => ({ ...prev, tipo_planta: 'PE' }));
      setTimeAuditFilters(prev => ({ ...prev, tipo_planta: 'PE' }));
    }
  }, [user, isPEUser]);

  // Funciones para RBAC
  const fetchRbacData = async () => {
    if (!canAccess('system:manage_rbac') && !canAccess('admin:view_users')) return;
    setRbacLoading(true);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const headers = { 'Authorization': `Bearer ${token}` };

      const [rolesRes, permsRes] = await Promise.all([
        fetch(`${API_URL}/rbac/roles`, { headers }),
        fetch(`${API_URL}/rbac/permissions`, { headers })
      ]);

      if (rolesRes.ok) setRbacRoles(await rolesRes.json());
      if (permsRes.ok) setRbacPermissions(await permsRes.json());
    } catch (error) {
      console.error("Error fetching RBAC data:", error);
    } finally {
      setRbacLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'rbac') {
      fetchRbacData();
    }
  }, [activeTab]);

  const handleSaveRole = async () => {
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const method = editingRole ? 'PUT' : 'POST';
      const url = editingRole ? `${API_URL}/rbac/roles/${editingRole.id}` : `${API_URL}/rbac/roles`;

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(newRoleData)
      });

      if (response.ok) {
        showMessage(`✅ Rol ${editingRole ? 'actualizado' : 'creado'}`, 'success');
        setShowRoleModal(false);
        fetchRbacData();
      } else {
        const err = await response.json();
        showMessage(`❌ Error: ${err.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const handleDeleteRole = async (roleId) => {
    if (!window.confirm("¿Seguro que deseas eliminar este rol?")) return;
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/rbac/roles/${roleId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        showMessage('✅ Rol eliminado', 'success');
        fetchRbacData();
      } else {
        const err = await response.json();
        showMessage(`❌ Error: ${err.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const handleAssignRole = async () => {
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/rbac/assign-role`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({
          user_id: targetUserForRole.id,
          role_id: newRoleData.role_id
        })
      });
      if (response.ok) {
        showMessage('✅ Rol asignado con éxito', 'success');
        setShowAssignModal(false);
        // Refresh search results if necessary
        handleSearch({ preventDefault: () => { } });
      } else {
        const err = await response.json();
        showMessage(`❌ Error: ${err.detail}`, 'error');
      }
    } catch (error) {
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const handleCreateAdminUser = async (e) => {
    e.preventDefault();
    const cleanedAdminData = {
      ...newAdminData,
      full_name: cleanInput(newAdminData.full_name),
      email: cleanInput(newAdminData.email),
      telefono: cleanInput(newAdminData.telefono),
      usuario_ffm: cleanInput(newAdminData.usuario_ffm)
    };
    setNewAdminData(cleanedAdminData);

    if (!cleanedAdminData.full_name || !cleanedAdminData.email || !cleanedAdminData.usuario_ffm) {
      showMessage('⚠️ Por favor completa los campos obligatorios', 'error');
      return;
    }
    if (/TO\d{3}$/.test(cleanedAdminData.usuario_ffm)) {
      showMessage(`❌ El usuario tiene "TO###" al final en lugar de "T0###". Reemplace la "O" por un "0".`, 'error');
      return;
    }
    if (cleanedAdminData.usuario_ffm.length > 13) {
      showMessage(`❌ El usuario no puede tener más de 13 caracteres.`, 'error');
      return;
    }

    // Generar contraseña
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*?-_";
    let generatedPassword = "";
    for (let i = 0; i < 16; i++) {
      generatedPassword += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/create-user`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({
          full_name: cleanedAdminData.full_name.toUpperCase(),
          email: cleanedAdminData.email,
          telefono: cleanedAdminData.telefono,
          usuario_ffm: cleanedAdminData.usuario_ffm.toUpperCase(),
          role: 'admin', // System role
          rbac_role_id: cleanedAdminData.role_id, // Granular role
          tipo_planta: cleanedAdminData.tipo_planta || 'PE',
          password: generatedPassword,
          region: 'ADMIN', // Default required field
          distrito: 'OFFICE', // Default required field
          curp: `ADM_${Date.now()}` // Generate internal curp
        })
      });

      const data = await response.json();
      if (response.ok) {
        showMessage('✅ Administrador creado con éxito', 'success');
        setShowCreateAdminModal(false);
        setCreatedUser({
          full_name: newAdminData.full_name.toUpperCase(),
          usuario_ffm: newAdminData.usuario_ffm.toUpperCase(),
          password: generatedPassword,
          role: 'admin',
          region: 'ADMIN',
          distrito: 'OFFICE'
        });
      } else {
        showMessage(`❌ Error: ${data.detail}`, 'error');
      }
    } catch (error) {
      console.error(error);
      showMessage('❌ Error de conexión', 'error');
    }
  };

  const toggleChangeForUser = (usuarioFfm, field) => {
    setAcceptedUpdates(prev => {
      const current = prev[usuarioFfm] || [];
      const updated = current.includes(field)
        ? current.filter(f => f !== field)
        : [...current, field];
      return { ...prev, [usuarioFfm]: updated };
    });
  };

  const toggleAllChangesForUser = (usuarioFfm, userChanges) => {
    setAcceptedUpdates(prev => {
      const current = prev[usuarioFfm] || [];
      const allFields = userChanges.map(c => c.field);
      const isAllSelected = allFields.every(f => current.includes(f));
      return { ...prev, [usuarioFfm]: isAllSelected ? [] : allFields };
    });
  };

  const toggleFieldGlobally = (field, shouldAccept) => {
    if (!uploadPreview?.updates) return;
    setAcceptedUpdates(prev => {
      const next = { ...prev };
      uploadPreview.updates.forEach(upd => {
        const hasField = upd.changes.some(c => c.field === field);
        if (hasField) {
          const current = next[upd.usuario_ffm] || [];
          if (shouldAccept) {
            if (!current.includes(field)) {
              next[upd.usuario_ffm] = [...current, field];
            }
          } else {
            next[upd.usuario_ffm] = current.filter(f => f !== field);
          }
        }
      });
      return next;
    });
  };

  const setAllUpdatesGlobally = (acceptAll) => {
    if (!uploadPreview?.updates) return;
    const next = {};
    uploadPreview.updates.forEach(upd => {
      next[upd.usuario_ffm] = acceptAll ? upd.changes.map(c => c.field) : [];
    });
    setAcceptedUpdates(next);
  };

  const toggleCreation = (usuarioFfm) => {
    setAcceptedCreations(prev => ({
      ...prev,
      [usuarioFfm]: !prev[usuarioFfm]
    }));
  };

  const setAllCreationsGlobally = (acceptAll) => {
    if (!uploadPreview?.creations) return;
    const next = {};
    uploadPreview.creations.forEach(cre => {
      next[cre.usuario_ffm] = acceptAll;
    });
    setAcceptedCreations(next);
  };

  const handleBulkUpload = async (file) => {
    if (!file) return;

    setUploading(true);
    setUploadPreview(null);
    setUploadResult(null);
    setUpdateFilterField('ALL');

    try {
      // Leer el archivo a memoria para evitar net::ERR_UPLOAD_FILE_CHANGED en la posterior confirmación
      const arrayBuffer = await file.arrayBuffer();
      const memoryBlob = new Blob([arrayBuffer], { type: file.type || 'text/csv' });
      const memoryFile = new File([memoryBlob], file.name, { type: file.type || 'text/csv' });

      setSelectedFile(memoryFile);

      const formDataUpload = new FormData();
      formDataUpload.append('file', memoryFile);
      formDataUpload.append('preview', 'true');
      formDataUpload.append('week_number', String(uploadWeekNumber || ''));

      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/bulk-upload-technicians`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formDataUpload
      });

      let data;
      try {
        data = await response.json();
      } catch (jsonErr) {
        const textErr = await response.text().catch(() => '');
        throw new Error(`Error en el servidor (${response.status}): ${textErr.slice(0, 150) || response.statusText}`);
      }

      if (response.ok) {
        setUploadPreview(data);

        // Inicializar aceptaciones: por defecto todos los cambios y todas las creaciones están seleccionados
        const initialUpdates = {};
        if (data.updates && Array.isArray(data.updates)) {
          data.updates.forEach(upd => {
            initialUpdates[upd.usuario_ffm] = upd.changes.map(c => c.field);
          });
        }
        setAcceptedUpdates(initialUpdates);

        const initialCreations = {};
        if (data.creations && Array.isArray(data.creations)) {
          data.creations.forEach(cre => {
            initialCreations[cre.usuario_ffm] = true;
          });
        }
        setAcceptedCreations(initialCreations);
        setUpdatesSearchQuery('');

        showMessage('📋 Análisis previo de carga completado', 'info');
      } else {
        showMessage(`❌ Error: ${data.detail || 'Error al analizar archivo'}`, 'error');
        setSelectedFile(null);
      }
    } catch (error) {
      console.error(error);
      showMessage(`❌ ${error.message || 'Error de conexión al analizar archivo'}`, 'error');
      setSelectedFile(null);
    } finally {
      setUploading(false);
    }
  };

  const handleConfirmUpload = async () => {
    if (!selectedFile) return;

    // Verificar si hay algo seleccionado para procesar
    const activeUpdateTechs = Object.keys(acceptedUpdates).filter(ffm => (acceptedUpdates[ffm] || []).length > 0);
    const activeCreationsList = Object.keys(acceptedCreations).filter(ffm => acceptedCreations[ffm]);

    if (activeUpdateTechs.length === 0 && activeCreationsList.length === 0) {
      showMessage('⚠️ No has seleccionado ningún cambio ni técnico nuevo para aplicar', 'error');
      return;
    }

    setUploading(true);
    setUploadResult(null);

    const formDataUpload = new FormData();
    formDataUpload.append('file', selectedFile);
    formDataUpload.append('preview', 'false');
    formDataUpload.append('week_number', String(uploadWeekNumber || ''));
    formDataUpload.append('accepted_updates', JSON.stringify(acceptedUpdates));
    formDataUpload.append('accepted_creations', JSON.stringify(activeCreationsList));

    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/bulk-upload-technicians`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formDataUpload
      });

      let data;
      try {
        data = await response.json();
      } catch (jsonErr) {
        const textErr = await response.text().catch(() => '');
        throw new Error(`Error en el servidor (${response.status}): ${textErr.slice(0, 150) || response.statusText}`);
      }

      if (response.ok) {
        setUploadResult(data);
        setUploadPreview(null);
        setSelectedFile(null);
        setAcceptedUpdates({});
        setAcceptedCreations({});
        setUpdatesSearchQuery('');
        showMessage('✅ Procesamiento masivo completado', 'success');

        // Reset the file input element
        const fileInput = document.getElementById('bulkUpload');
        if (fileInput) fileInput.value = '';

        // Descargar credenciales generadas si hubo nuevos usuarios
        if (data.nuevos_usuarios && data.nuevos_usuarios.length > 0) {
          const csvConfig = ["Usuario FFM", "Nombre", "Email", "Contraseña", "Región", "Distrito", "Empresa"];
          const csvRows = [csvConfig.join(',')];

          data.nuevos_usuarios.forEach(user => {
            const row = csvConfig.map(header => {
              const val = user[header] || '';
              return `"${String(val).replace(/"/g, '""')}"`;
            });
            csvRows.push(row.join(','));
          });

          const blob = new Blob(["\ufeff" + csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.setAttribute("href", url);
          const fechaStr = new Date().toISOString().split('T')[0].replace(/-/g, '');
          link.setAttribute("download", `credenciales_nuevos_tecnicos_${fechaStr}.csv`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          showMessage(`Descargando contraseñas de ${data.nuevos_usuarios.length} técnicos nuevos`, 'success');
        }
      } else {
        showMessage(`❌ Error: ${data.detail || 'Error al subir archivo'}`, 'error');
      }
    } catch (error) {
      console.error(error);
      showMessage(`❌ ${error.message || 'Error de conexión al subir archivo'}`, 'error');
    } finally {
      setUploading(false);
    }
  };

  const handleCancelUpload = () => {
    setUploadPreview(null);
    setSelectedFile(null);
    setAcceptedUpdates({});
    setAcceptedCreations({});
    setUpdateFilterField('ALL');
    setUpdatesSearchQuery('');
    const fileInput = document.getElementById('bulkUpload');
    if (fileInput) fileInput.value = '';
    showMessage('🚫 Carga cancelada', 'info');
  };

  const handleSearchHistory = async (e) => {
    if (e) e.preventDefault();
    if (!searchQuery || searchQuery.trim() === '') {
      showMessage('⚠️ Por favor ingresa un término de búsqueda', 'error');
      return;
    }

    setHistoryLoading(true);
    setHistoryMatchesList([]);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/search-history?query=${encodeURIComponent(searchQuery)}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setHistoryMatchesList(data.results);
        setShowHistoryMatchesModal(true);
        if (data.results.length === 0) {
          showMessage('🔍 No se encontraron registros en el historial para esta búsqueda', 'info');
        }
      } else {
        showMessage(`❌ Error: ${data.detail || 'No se pudo buscar en el historial'}`, 'error');
      }
    } catch (error) {
      console.error(error);
      showMessage('❌ Error de conexión al buscar en el historial', 'error');
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleViewTechnicianHistory = async (usuarioFfm, techData) => {
    setHistoryTech(techData);
    setHistoryLoading(true);
    setTechHistoryList([]);
    try {
      const token = localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token');
      const response = await fetch(`${API_URL}/admin/technician-history/${encodeURIComponent(usuarioFfm)}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (response.ok && data.success) {
        setTechHistoryList(data.history);
        setShowHistoryModal(true);
      } else {
        showMessage(`❌ Error: ${data.detail || 'No se pudo cargar el historial'}`, 'error');
      }
    } catch (error) {
      console.error(error);
      showMessage('❌ Error de conexión al obtener el historial', 'error');
    } finally {
      setHistoryLoading(false);
    }
  };

  const roleConfig = {
    technician: { label: 'Técnico', icon: '👷', color: '#3B82F6' },
    inspector: { label: 'Inspector', icon: '🔍', color: '#8B5CF6' },
    district_manager: { label: 'Gerente', icon: '👔', color: '#10B981' }
  };

  const pactadasRegionOptions = Array.from(new Set(distritosCatalog.map(d => d.region))).filter(Boolean).sort();
  const pactadasDistritoOptions = distritosCatalog
    .filter(d => pactadasRegions.length === 0 || pactadasRegions.includes(d.region))
    .map(d => d.distrito)
    .filter(Boolean)
    .sort();
  
  // Report Filters Options
  const reportRegionOptions = Array.from(new Set(distritosCatalog.map(d => d.region))).filter(Boolean).sort();
  const reportDistritoOptions = Array.from(
    new Set(
      distritosCatalog
        .filter(d => !reportFilters.region || d.region === reportFilters.region)
        .map(d => d.distrito)
    )
  ).filter(Boolean).sort();

  // Audit Filters Options
  const auditRegionOptions = Array.from(new Set(distritosCatalog.map(d => d.region))).filter(Boolean).sort();
  const auditDistritoOptions = Array.from(
    new Set(
      distritosCatalog
        .filter(d => !timeAuditFilters.region || d.region === timeAuditFilters.region)
        .map(d => d.distrito)
    )
  ).filter(Boolean).sort();
  const auditEmpresaOptions = Array.from(
    new Set(
      distritosCatalog
        .filter(d => (!timeAuditFilters.region || d.region === timeAuditFilters.region) && (!timeAuditFilters.distrito || d.distrito === timeAuditFilters.distrito))
        .flatMap(d => empresasCatalog[d.distrito] || [])
    )
  ).filter(Boolean).sort();

  // Dashboard Filters Options
  const dashboardRegionOptions = Array.from(new Set(distritosCatalog.map(d => d.region))).filter(Boolean).sort();
  const dashboardDistritoOptions = Array.from(
    new Set(
      distritosCatalog
        .filter(d => !dashboardFilters.region || d.region === dashboardFilters.region)
        .map(d => d.distrito)
    )
  ).filter(Boolean).sort();
  const dashboardEmpresaOptions = Array.from(
    new Set(
      distritosCatalog
        .filter(d => (!dashboardFilters.region || d.region === dashboardFilters.region) && (!dashboardFilters.distrito || d.distrito === dashboardFilters.distrito))
        .flatMap(d => empresasCatalog[d.distrito] || [])
    )
  ).filter(Boolean).sort();
  const getPactadasEmpresaOptions = () => {
    let distritosToUse = pactadasDistritos;
    if (distritosToUse.length === 0) {
      distritosToUse = distritosCatalog
        .filter(d => pactadasRegions.length === 0 || pactadasRegions.includes(d.region))
        .map(d => d.distrito);
    }
    return Array.from(new Set(distritosToUse.flatMap(d => empresasCatalog[d] || []))).filter(Boolean).sort();
  };
  const pactadasEmpresaOptions = getPactadasEmpresaOptions();

  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.headerLeft}>
            <div style={styles.headerIcon}></div>
            <div>
              <h1 style={styles.headerTitle}>Portal Administrativo</h1>
              <p style={styles.headerSubtitle}>
                Gestión completa de usuarios y reportes
                {user && (
                  <span style={{ marginLeft: '16px', color: '#60A5FA', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <span>👤 {user.full_name} ({user.usuario_ffm})</span>
                    {isPEUser ? (
                      <span style={{ background: '#F59E0B', color: '#0F172A', padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>
                        ⚡ Planta Externa (PE)
                      </span>
                    ) : (
                      <span style={{ background: '#10B981', color: 'white', padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>
                        🌐 Planta Interna (PI / Master)
                      </span>
                    )}
                  </span>
                )}
              </p>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {user?.role === 'district_manager' && (
              <button
                onClick={() => navigate('/gerente-distrito')}
                style={{
                  backgroundColor: '#7C3AED',
                  color: 'white',
                  border: 'none',
                  padding: '9px 16px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '13px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  boxShadow: '0 2px 4px rgba(124, 58, 237, 0.2)'
                }}
              >
                <span>📋</span>
                <span>Panel de Incidencias</span>
              </button>
            )}
            <button
              onClick={handleLogout}
              style={styles.logoutButton}
            >
              <span>🚪</span>
              <span style={{ marginLeft: '8px' }}>Cerrar sesión</span>
            </button>
          </div>
        </div>
      </header>

      {/* Area Selection (Categories) */}
      <div style={styles.categoriesWrapper}>
        <div style={styles.categoriesContainer}>
          {visibleCategories.map(cat => (
            <button
              key={cat.id}
              onClick={() => {
                setActiveCategory(cat.id);
                const firstTab = tabConfig.find(t => t.category === cat.id);
                if (firstTab) setActiveTab(firstTab.id);
              }}
              style={{
                ...styles.categoryButton,
                ...(activeCategory === cat.id ? {
                  ...styles.categoryButtonActive,
                  color: cat.color,
                  backgroundColor: 'white',
                  borderColor: cat.color
                } : {})
              }}
            >
              <span style={{ fontSize: '18px', marginRight: '10px' }}>{cat.icon}</span>
              <span style={{ fontWeight: '700' }}>{cat.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Navigation Tabs (Sub-tabs) with Glassmorphism */}
      <div style={styles.tabsWrapperContainer}>
        <div style={styles.tabsContainer}>
          <div style={styles.tabsWrapper}>
            {filteredTabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  ...styles.tabButton,
                  ...(activeTab === tab.id ? {
                    ...styles.tabButtonActive,
                    borderBottom: `3px solid ${categories.find(c => c.id === activeCategory)?.color || '#2563EB'}`
                  } : {})
                }}
              >
                <span style={{ marginRight: '8px' }}>{tab.icon}</span>
                <span>{tab.label}</span>
                {activeTab === tab.id && (
                  <span style={{
                    marginLeft: '8px',
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: categories.find(c => c.id === activeCategory)?.color || '#2563EB'
                  }}></span>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Modal Centrado de Notificaciones y Errores */}
      {message.show && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 99999,
          backgroundColor: 'rgba(15, 23, 42, 0.75)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            maxWidth: '460px',
            width: '90%',
            padding: '28px',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            textAlign: 'center',
            border: message.type === 'error' ? '2px solid #EF4444' : message.type === 'success' ? '2px solid #10B981' : '2px solid #3B82F6'
          }}>
            <div style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              backgroundColor: message.type === 'error' ? '#FEE2E2' : message.type === 'success' ? '#D1FAE5' : '#DBEAFE',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '32px',
              margin: '0 auto 16px'
            }}>
              {message.type === 'error' ? '❌' : message.type === 'success' ? '✅' : 'ℹ️'}
            </div>
            
            <h3 style={{
              fontSize: '18px',
              fontWeight: '700',
              color: message.type === 'error' ? '#991B1B' : message.type === 'success' ? '#065F46' : '#1E40AF',
              marginBottom: '12px'
            }}>
              {message.type === 'error' ? 'Atención / Error' : message.type === 'success' ? 'Operación Exitosa' : 'Aviso del Sistema'}
            </h3>

            <p style={{
              fontSize: '15px',
              color: '#374151',
              lineHeight: '1.5',
              marginBottom: '24px',
              whiteSpace: 'pre-line'
            }}>
              {message.text}
            </p>

            <button
              onClick={() => setMessage({ show: false, text: '', type: '' })}
              style={{
                width: '100%',
                padding: '12px 24px',
                backgroundColor: message.type === 'error' ? '#DC2626' : message.type === 'success' ? '#059669' : '#2563EB',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                fontSize: '15px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }}
            >
              Aceptar
            </button>
          </div>
        </div>
      )}

      {/* Main Content */}
      <main style={styles.main}>
        {/* Tab 1: Manage Users */}
        {activeTab === 'manage' && (
          <div style={styles.card}>
            <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: isMobile ? 'stretch' : 'center', gap: '16px', marginBottom: '24px', flexWrap: 'wrap', borderBottom: '1px solid #E2E8F0', paddingBottom: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={styles.cardIcon}>🔍</span>
                <div style={{ marginLeft: '16px' }}>
                  <h2 style={styles.cardTitle}>Gestión y Exportación de Usuarios</h2>
                  <p style={styles.cardSubtitle}>Busca usuarios o exporta la base de datos con filtros por perfil y estatus</p>
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <label style={{ fontSize: '11px', fontWeight: 'bold', color: '#64748B' }}>Perfil / Rol:</label>
                  <select
                    value={exportFilters.role}
                    onChange={(e) => setExportFilters({ ...exportFilters, role: e.target.value })}
                    style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px', backgroundColor: 'white' }}
                  >
                    <option value="all">🌐 Todos los Perfiles</option>
                    <option value="technician">⚡ Técnicos</option>
                    <option value="inspector">🔍 Inspectores (IDR)</option>
                    <option value="supervisor">📋 Supervisores</option>
                    <option value="coordinator">👔 Coordinadores</option>
                    <option value="admin">⚙️ Administradores</option>
                  </select>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  <label style={{ fontSize: '11px', fontWeight: 'bold', color: '#64748B' }}>Estatus:</label>
                  <select
                    value={exportFilters.status}
                    onChange={(e) => setExportFilters({ ...exportFilters, status: e.target.value })}
                    style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px', backgroundColor: 'white' }}
                  >
                    <option value="all">📊 Todos</option>
                    <option value="active">🟢 Solo Activos</option>
                    <option value="inactive">🔴 Solo Dados de Baja</option>
                  </select>
                </div>

                {!isPlantaFixed && (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <label style={{ fontSize: '11px', fontWeight: 'bold', color: '#64748B' }}>Planta:</label>
                    <select
                      value={exportFilters.tipo_planta}
                      onChange={(e) => setExportFilters({ ...exportFilters, tipo_planta: e.target.value })}
                      style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px', backgroundColor: 'white' }}
                    >
                      <option value="all">🏢 Todas</option>
                      <option value="PI">Planta Interna (PI)</option>
                      <option value="PE">Planta Externa (PE)</option>
                    </select>
                  </div>
                )}

                <button
                  onClick={(e) => { e.preventDefault(); handleExportUsers(); }}
                  disabled={exporting}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: exporting ? '#9CA3AF' : '#10B981',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: exporting ? 'not-allowed' : 'pointer',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                    height: '34px'
                  }}
                  onMouseOver={(e) => { if (!exporting) e.currentTarget.style.backgroundColor = '#059669'; }}
                  onMouseOut={(e) => { if (!exporting) e.currentTarget.style.backgroundColor = '#10B981'; }}
                >
                  {exporting ? (
                    <div style={{ ...styles.spinner, width: '16px', height: '16px' }}></div>
                  ) : (
                    <span>📥</span>
                  )}
                  <span>Exportar Usuarios (CSV)</span>
                </button>
              </div>
            </div>

            <form onSubmit={handleSearch} style={{ marginBottom: '32px' }}>
              <div style={styles.searchContainer}>
                <input
                  type="text"
                  placeholder="Ingresa usuario, nombre o CURP..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  style={styles.searchInput}
                />
                <button
                  type="submit"
                  disabled={searchLoading}
                  style={styles.searchButton}
                >
                  {searchLoading ? (
                    <div style={styles.spinner}></div>
                  ) : (
                    <span>🔍</span>
                  )}
                  <span style={{ marginLeft: '8px' }}>Buscar</span>
                </button>
                <button
                  type="button"
                  onClick={handleSearchHistory}
                  disabled={searchLoading || historyLoading}
                  style={{
                    ...styles.searchButton,
                    backgroundColor: '#4B5563',
                    marginLeft: '8px'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#374151'}
                  onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#4B5563'}
                >
                  {historyLoading ? (
                    <div style={styles.spinner}></div>
                  ) : (
                    <span>📜</span>
                  )}
                  <span style={{ marginLeft: '8px' }}>Ver Historial / Acumulados</span>
                </button>
              </div>
            </form>

            {searchResultsList.length > 0 && !searchResults && (
              <div style={styles.selectionList}>
                <h3 style={{ ...styles.mainSectionTitle, fontSize: '16px', marginBottom: '16px' }}>
                  Selecciona el usuario:
                </h3>
                {searchResultsList.map((user) => (
                  <div
                    key={user.id}
                    onClick={() => selectUser(user)}
                    style={styles.selectionItem}
                    onMouseOver={(e) => {
                      e.currentTarget.style.borderColor = '#3B82F6';
                      e.currentTarget.style.backgroundColor = '#F9FAFB';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.borderColor = '#E5E7EB';
                      e.currentTarget.style.backgroundColor = 'white';
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <div style={{ fontWeight: 'bold', fontSize: '16px' }}>{user.full_name}</div>
                        <div style={{ fontSize: '14px', color: '#6B7280' }}>
                          {user.usuario_ffm} | {user.region} / {user.distrito} {user.role === 'technician' && `| ${user.tipo_planta || 'PI'}`}
                        </div>
                      </div>
                      <span style={{
                        ...styles.roleBadge,
                        backgroundColor: roleConfig[user.role]?.color + '20',
                        color: roleConfig[user.role]?.color
                      }}>
                        {roleConfig[user.role]?.label}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {searchResults && (
              <div style={styles.userCard}>
                <div style={styles.userHeader}>
                  <div>
                    <div style={styles.userNameRow}>
                      {isEditing ? (
                        <input
                          value={editFormData.full_name || ''}
                          onChange={(e) => setEditFormData({ ...editFormData, full_name: e.target.value.toUpperCase() })}
                          style={{
                            ...styles.formInput,
                            padding: '6px 10px',
                            height: 'auto',
                            fontSize: '18px',
                            fontWeight: '700',
                            flex: 1,
                            maxWidth: '400px'
                          }}
                          placeholder="Nombre completo"
                        />
                      ) : (
                        <h3 style={styles.userName}>{searchResults.full_name}</h3>
                      )}
                      <span style={{
                        ...styles.statusBadge,
                        backgroundColor: searchResults.is_active ? '#DCFCE7' : '#FEE2E2',
                        color: searchResults.is_active ? '#166534' : '#991B1B'
                      }}>
                        {searchResults.is_active ? 'Activo' : 'Inactivo'}
                      </span>
                    </div>
                    <div style={styles.userInfoRow}>
                      <div style={styles.infoItem}>
                        <span style={styles.infoLabel}>Usuario:</span>
                        {isEditing ? (
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <input
                              value={editFormData.usuario_ffm || ''}
                              onChange={(e) => {
                                const val = e.target.value.toUpperCase();
                                let tipoPlanta = editFormData.tipo_planta;
                                if (val.length >= 5) {
                                  const sub = val.substring(3, 5);
                                  tipoPlanta = (sub === 'MT') ? 'PI' : 'PE';
                                }
                                setEditFormData({ ...editFormData, usuario_ffm: val, tipo_planta: tipoPlanta });
                              }}
                              maxLength="13"
                              style={{
                                ...styles.formInput,
                                padding: '2px 4px',
                                width: '120px',
                                height: 'auto',
                                fontFamily: 'monospace',
                                fontWeight: 'bold',
                                border: /TO\d{3}$/.test(editFormData.usuario_ffm || '') ? '2px solid #EF4444' : styles.formInput.border,
                                boxShadow: /TO\d{3}$/.test(editFormData.usuario_ffm || '') ? '0 0 0 3px rgba(239, 68, 68, 0.2)' : 'none'
                              }}
                              placeholder="Usuario"
                            />
                            {/TO\d{3}$/.test(editFormData.usuario_ffm || '') && (
                              <span style={{ color: '#EF4444', fontSize: '10px', marginTop: '2px', fontWeight: 'bold' }}>
                                Reemplace "O" por "0"
                              </span>
                            )}
                          </div>
                        ) : (
                          <code style={styles.code}>{searchResults.usuario_ffm}</code>
                        )}
                      </div>
                      <div style={styles.infoItem}>
                        <span style={styles.infoLabel}>Rol:</span>
                        <span style={{
                          ...styles.roleBadge,
                          backgroundColor: roleConfig[searchResults.role]?.color + '20',
                          color: roleConfig[searchResults.role]?.color
                        }}>
                          {roleConfig[searchResults.role]?.label}
                        </span>
                      </div>
                      <div style={styles.infoItem}>
                        <span style={styles.infoLabel}>Ubicación:</span>
                        {isEditing ? (
                          <div style={{ display: 'flex', gap: '4px' }}>
                            <input
                              value={editFormData.region}
                              onChange={(e) => setEditFormData({ ...editFormData, region: e.target.value.toUpperCase() })}
                              style={{ ...styles.formInput, padding: '2px 4px', width: '80px', height: 'auto' }}
                              placeholder="Región"
                            />
                            <span>/</span>
                            <input
                              value={editFormData.distrito}
                              onChange={(e) => setEditFormData({ ...editFormData, distrito: e.target.value.toUpperCase() })}
                              style={{ ...styles.formInput, padding: '2px 4px', width: '100px', height: 'auto' }}
                              placeholder="Distrito"
                            />
                          </div>
                        ) : (
                          <span>{searchResults.region} / {searchResults.distrito}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div style={styles.userActions}>
                    {!isEditing ? (
                      <>
                        {searchResults.role === 'technician' && (
                          <button
                            onClick={() => handleViewTechnicianHistory(searchResults.usuario_ffm, searchResults)}
                            style={{
                              ...styles.activateButton,
                              backgroundColor: '#8B5CF6',
                              color: 'white',
                              marginRight: '8px',
                              border: 'none'
                            }}
                          >
                            <span>📜</span>
                            <span style={{ marginLeft: '6px' }}>Ver Historial</span>
                          </button>
                        )}
                        {canAccess('admin:edit_user') && (
                          <button
                            onClick={handleStartEdit}
                            style={{
                              ...styles.activateButton,
                              backgroundColor: '#3B82F6',
                              color: 'white',
                              marginRight: '8px',
                              border: 'none'
                            }}
                          >
                            <span>✏️</span>
                            <span style={{ marginLeft: '6px' }}>Editar</span>
                          </button>
                        )}
                        {canAccess('admin:delete_user') && searchResults.is_active ? (
                          <button
                            onClick={() => handleDeactivateUser(searchResults.id)}
                            style={styles.deactivateButton}
                          >
                            <span>❌</span>
                            <span style={{ marginLeft: '6px' }}>Desactivar</span>
                          </button>
                        ) : canAccess('admin:delete_user') && !searchResults.is_active ? (
                          <button
                            onClick={() => handleActivateUser(searchResults.id)}
                            style={styles.activateButton}
                          >
                            <span>✅</span>
                            <span style={{ marginLeft: '6px' }}>Activar</span>
                          </button>
                        ) : null}
                      </>
                    ) : (
                      <>
                        <button
                          onClick={handleSaveUser}
                          style={{
                            ...styles.activateButton,
                            backgroundColor: '#10B981',
                            color: 'white',
                            marginRight: '8px',
                            border: 'none'
                          }}
                        >
                          <span>💾</span>
                          <span style={{ marginLeft: '6px' }}>Guardar</span>
                        </button>
                        <button
                          onClick={handleCancelEdit}
                          style={{
                            ...styles.deactivateButton,
                            backgroundColor: '#6B7280',
                            color: 'white',
                            border: 'none'
                          }}
                        >
                          <span>🚫</span>
                          <span style={{ marginLeft: '6px' }}>Cancelar</span>
                        </button>
                      </>
                    )}
                  </div>
                </div>

                <div style={styles.userGrid}>
                  {canAccess('admin:change_password') && (
                    <div style={styles.passwordSection}>
                      <h4 style={styles.sectionTitle}>
                        <span style={{ marginRight: '8px' }}>🔐</span>
                        Cambiar Contraseña
                      </h4>
                      <div style={styles.passwordInputContainer}>
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="Nueva contraseña (mín. 8 caracteres)"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          style={styles.passwordInput}
                        />
                        <button
                          type="button"
                          onClick={handleGeneratePassword}
                          style={{ ...styles.showPasswordButton, marginRight: '8px', padding: '0 8px', width: 'auto', minWidth: '40px' }}
                          title="Generar contraseña de 16 caracteres"
                        >
                          🎲
                        </button>
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          style={styles.showPasswordButton}
                        >
                          {showPassword ? '👁️' : '👁️‍🗨️'}
                        </button>
                      </div>
                      <button
                        onClick={handleChangePassword}
                        disabled={!newPassword || newPassword.length < 8}
                        style={{
                          ...styles.updatePasswordButton,
                          opacity: (!newPassword || newPassword.length < 8) ? 0.5 : 1
                        }}
                      >
                        <span>🔐</span>
                        <span style={{ marginLeft: '8px' }}>Actualizar Contraseña</span>
                      </button>
                    </div>
                  )}

                  <div style={styles.infoSection}>
                    <h4 style={styles.sectionTitle}>Información del Usuario</h4>
                    <div style={styles.infoGrid}>
                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Email:</span>
                        {isEditing ? (
                          <input
                            value={editFormData.email || ''}
                            onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
                            style={{ ...styles.formInput, padding: '4px', height: 'auto' }}
                          />
                        ) : (
                          <span style={styles.infoValue}>{searchResults.email}</span>
                        )}
                      </div>
                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Teléfono:</span>
                        {isEditing ? (
                          <input
                            value={editFormData.telefono || ''}
                            onChange={(e) => setEditFormData({ ...editFormData, telefono: e.target.value })}
                            style={{ ...styles.formInput, padding: '4px', height: 'auto' }}
                          />
                        ) : (
                          <span style={styles.infoValue}>{searchResults.telefono}</span>
                        )}
                      </div>
                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Empresa:</span>
                        {isEditing ? (
                          <input
                            value={editFormData.empresa || ''}
                            onChange={(e) => setEditFormData({ ...editFormData, empresa: e.target.value.toUpperCase() })}
                            style={{ ...styles.formInput, padding: '4px', height: 'auto' }}
                          />
                        ) : (
                          <span style={styles.infoValue}>{searchResults.empresa || 'N/A'}</span>
                        )}
                      </div>
                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Gerente:</span>
                        {isEditing ? (
                          <input
                            value={editFormData.gerente || ''}
                            onChange={(e) => setEditFormData({ ...editFormData, gerente: e.target.value.toUpperCase() })}
                            style={{ ...styles.formInput, padding: '4px', height: 'auto' }}
                          />
                        ) : (
                          <span style={styles.infoValue}>{searchResults.gerente || 'N/A'}</span>
                        )}
                      </div>
                      <div style={styles.infoRow}>
                        <span style={styles.infoLabel}>Planta:</span>
                        {isEditing ? (
                          <select
                            value={isPlantaFixed ? user?.tipo_planta : (editFormData.tipo_planta || 'PI')}
                            onChange={(e) => setEditFormData({ ...editFormData, tipo_planta: e.target.value })}
                            style={{ ...styles.formInput, padding: '4px', height: 'auto', backgroundColor: isPlantaFixed ? '#F1F5F9' : 'white' }}
                            disabled={isPlantaFixed}
                          >
                            {(!isPlantaFixed || user?.tipo_planta === 'PI') && <option value="PI">Planta Interna (PI)</option>}
                            {(!isPlantaFixed || user?.tipo_planta === 'PE') && <option value="PE">Planta Externa (PE)</option>}
                          </select>
                        ) : (
                          <span style={styles.infoValue}>
                            {searchResults.tipo_planta === 'PE' ? 'Planta Externa (PE)' : 'Planta Interna (PI)'}
                          </span>
                        )}
                      </div>
                      {!searchResults.is_active && (searchResults.deactivated_at || searchResults.updated_at) && (
                        <div style={styles.infoRow}>
                          <span style={{ ...styles.infoLabel, color: '#DC2626' }}>Fecha de Baja:</span>
                          <span style={{ ...styles.infoValue, color: '#DC2626', fontWeight: 'bold' }}>
                            {new Date(searchResults.deactivated_at || searchResults.updated_at).toLocaleString('es-MX')}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* 🚨 SECCIÓN DE AUDITORÍA OBLIGATORIA AL EDITAR */}
                {isEditing && (
                  <div style={{
                    backgroundColor: '#FEF3C7',
                    border: '2px dashed #F59E0B',
                    borderRadius: '10px',
                    padding: '16px',
                    marginTop: '20px'
                  }}>
                    <h4 style={{ margin: '0 0 12px 0', color: '#92400E', fontSize: '15px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span>⚠️</span> Requisitos de Auditoría Obligatorios para Guardar Modificación
                    </h4>

                    <div style={{ marginBottom: '16px' }}>
                      <label style={{ display: 'block', fontSize: '13px', fontWeight: 'bold', color: '#78350F', marginBottom: '6px' }}>
                        💬 Comentario / Justificación de la modificación <span style={{ color: '#DC2626' }}>* (Obligatorio)</span>
                      </label>
                      <textarea
                        value={editComment}
                        onChange={(e) => setEditComment(e.target.value)}
                        placeholder="Escribe la razón explicativa de la modificación (ej: Solicitado por Gerente en correo del 13-Ago, corrección de distrito...)"
                        rows="3"
                        style={{
                          width: '100%',
                          padding: '10px 12px',
                          borderRadius: '6px',
                          border: editComment.trim().length >= 3 ? '1px solid #D97706' : '2px solid #EF4444',
                          fontSize: '13px',
                          fontFamily: 'inherit',
                          boxSizing: 'border-box'
                        }}
                      />
                      {editComment.trim().length < 3 && (
                        <span style={{ color: '#DC2626', fontSize: '11px', fontWeight: 'bold', marginTop: '4px', display: 'block' }}>
                          Ingrese una justificación de al menos 3 caracteres.
                        </span>
                      )}
                    </div>

                    <div>
                      <label style={{ display: 'block', fontSize: '13px', fontWeight: 'bold', color: '#78350F', marginBottom: '6px' }}>
                        📷 Evidencia Fotográfica de Solicitud <span style={{ color: '#DC2626' }}>* (Obligatoria)</span>
                      </label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleEvidenceFileChange}
                        style={{ display: 'none' }}
                        id="user-edit-evidence-input"
                      />
                      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
                        <label
                          htmlFor="user-edit-evidence-input"
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '6px',
                            backgroundColor: '#D97706',
                            color: 'white',
                            padding: '8px 14px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            fontSize: '13px'
                          }}
                        >
                          <span>📁</span> {editEvidenceFile ? 'Cambiar Imagen de Evidencia' : 'Adjuntar Imagen de Evidencia'}
                        </label>

                        {editEvidencePreview ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <img
                              src={editEvidencePreview}
                              alt="Vista previa evidencia"
                              style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '6px', border: '2px solid #D97706' }}
                            />
                            <span style={{ fontSize: '12px', color: '#047857', fontWeight: 'bold' }}>
                              ✅ {editEvidenceFile?.name}
                            </span>
                          </div>
                        ) : (
                          <span style={{ fontSize: '12px', color: '#DC2626', fontWeight: 'bold' }}>
                            ❌ Ninguna imagen seleccionada (Obligatoria)
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Tab 2: Create User */}
        {activeTab === 'create' && (
          <div>
            <div style={{ marginBottom: '32px' }}>
              <h2 style={styles.mainSectionTitle}>Selecciona el tipo de usuario</h2>
              <div style={styles.roleGrid}>
                {Object.entries(roleConfig)
                  .filter(([role]) => isPEUser ? role === 'technician' : true)
                  .map(([role, config]) => (
                  <div
                    key={role}
                    onClick={() => setSelectedRole(role)}
                    style={{
                      ...styles.roleCard,
                      backgroundColor: selectedRole === role ? config.color : 'white',
                      color: selectedRole === role ? 'white' : '#374151',
                      transform: selectedRole === role ? 'scale(1.02)' : 'scale(1)',
                      boxShadow: selectedRole === role ?
                        '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)' :
                        '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'
                    }}
                  >
                    <div style={styles.roleCardHeader}>
                      <span style={{ fontSize: '24px' }}>{config.icon}</span>
                      <h3 style={styles.roleCardTitle}>{config.label}</h3>
                    </div>
                    <p style={{
                      ...styles.roleCardDesc,
                      opacity: selectedRole === role ? 0.9 : 0.7
                    }}>
                      {role === 'technician' && 'Personal de campo encargado de visitas técnicas'}
                      {role === 'inspector' && 'Supervisores que verifican la calidad del trabajo'}
                      {role === 'district_manager' && 'Gerentes con acceso a reportes y gestión'}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div style={styles.card}>
              <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: isMobile ? 'stretch' : 'center',
                gap: '16px',
                marginBottom: '20px'
              }}>
                <h2 style={{ ...styles.cardTitle, margin: 0 }}>Información del Nuevo Usuario</h2>
                {selectedRole === 'technician' && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <span style={{ fontSize: '13px', fontWeight: '600', color: '#4B5563' }}>Semana:</span>
                      <input
                        type="number"
                        min="1"
                        max="53"
                        value={uploadWeekNumber}
                        onChange={(e) => setUploadWeekNumber(parseInt(e.target.value) || '')}
                        style={{
                          width: '60px',
                          padding: '6px',
                          border: '1.5px solid #D1D5DB',
                          borderRadius: '6px',
                          fontSize: '13px',
                          fontWeight: 'bold',
                          textAlign: 'center',
                          outline: 'none',
                          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)'
                        }}
                      />
                    </div>
                    <input
                      type="file"
                      id="bulkUpload"
                      accept=".csv"
                      style={{ display: 'none' }}
                      onChange={(e) => handleBulkUpload(e.target.files[0])}
                    />
                    <button
                      onClick={() => {
                        document.getElementById('bulkUpload').click();
                      }}
                      disabled={uploading}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: isPEUser ? '#2563EB' : '#1E40AF',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontWeight: '600',
                        fontSize: '13px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                    >
                      {uploading ? '⏳ Procesando...' : isPEUser ? '📥 Carga Masiva PE' : '📥 Carga Masiva'}
                    </button>
                  </div>
                )}
              </div>

              {uploadPreview && (
                <div style={{
                  backgroundColor: '#EFF6FF',
                  padding: '20px',
                  borderRadius: '12px',
                  marginBottom: '24px',
                  border: '1.5px solid #BFDBFE',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', borderBottom: '1px solid #DBEAFE', paddingBottom: '12px' }}>
                    <h3 style={{ margin: 0, fontSize: '15px', color: '#1E40AF', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 'bold' }}>
                      <span>📊</span> Análisis Previo de Carga Masiva (Simulado)
                    </h3>
                    <button 
                      onClick={handleCancelUpload} 
                      style={{ 
                        border: 'none', 
                        background: 'none', 
                        cursor: 'pointer', 
                        fontSize: '20px', 
                        color: '#9CA3AF'
                      }}
                      title="Cancelar Carga"
                    >
                      &times;
                    </button>
                  </div>

                  {/* Banner de carga histórica */}
                  {uploadPreview.is_historical && (
                    <div style={{
                      backgroundColor: '#FEF3C7',
                      color: '#92400E',
                      padding: '12px 16px',
                      borderRadius: '8px',
                      marginBottom: '16px',
                      border: '1px solid #FCD34D',
                      fontSize: '13px',
                      fontWeight: '500',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '8px'
                    }}>
                      <span style={{ fontSize: '16px', marginTop: '-1px' }}>⚠️</span>
                      <div>
                        <strong>Carga Histórica Detectada (Semana {uploadWeekNumber} &lt; Semana Actual {uploadPreview.current_week})</strong>
                        <div style={{ marginTop: '2px', fontSize: '12px', opacity: 0.9 }}>
                          Esta carga pertenece a una semana pasada. Los cambios detectados en los técnicos existentes solo se registrarán en su historial de auditoría y <strong>no</strong> modificarán su perfil activo ni su estatus actual en el sistema.
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Resumen boxes */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))', gap: '10px', marginBottom: '20px' }}>
                    <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '8px', border: '1px solid #E5E7EB', textAlign: 'center' }}>
                      <div style={{ fontSize: '10px', color: '#6B7280', fontWeight: '600', textTransform: 'uppercase' }}>Filas en CSV</div>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1F2937', marginTop: '4px' }}>{uploadPreview.summary.total_rows}</div>
                    </div>
                    <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '8px', border: '1px solid #E5E7EB', textAlign: 'center' }}>
                      <div style={{ fontSize: '10px', color: '#059669', fontWeight: '600', textTransform: 'uppercase' }}>Nuevos a crear</div>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#059669', marginTop: '4px' }}>{uploadPreview.summary.creations_count}</div>
                    </div>
                    <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '8px', border: '1px solid #E5E7EB', textAlign: 'center' }}>
                      <div style={{ fontSize: '10px', color: '#2563EB', fontWeight: '600', textTransform: 'uppercase' }}>
                        {uploadPreview.is_historical ? 'Cambios en Historial' : 'A actualizar'}
                      </div>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#2563EB', marginTop: '4px' }}>{uploadPreview.summary.updates_count}</div>
                    </div>
                    <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '8px', border: '1px solid #E5E7EB', textAlign: 'center' }}>
                      <div style={{ fontSize: '10px', color: '#4B5563', fontWeight: '600', textTransform: 'uppercase' }}>Sin cambios</div>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#4B5563', marginTop: '4px' }}>{uploadPreview.summary.no_changes_count}</div>
                    </div>
                    <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '8px', border: '1px solid #E5E7EB', textAlign: 'center' }}>
                      <div style={{ fontSize: '10px', color: '#DC2626', fontWeight: '600', textTransform: 'uppercase' }}>Errores (Omitidos)</div>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#DC2626', marginTop: '4px' }}>{uploadPreview.summary.errors_count}</div>
                    </div>
                  </div>

                  {/* Listado de Errores Críticos (Vacíos, NAN, Duplicados) */}
                  {uploadPreview.errors && uploadPreview.errors.length > 0 && (
                    <div style={{ marginBottom: '16px', backgroundColor: '#FEF2F2', padding: '12px', borderRadius: '8px', border: '1px solid #FEE2E2' }}>
                      <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#991B1B', marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span>⚠️</span> Errores de Validación (Se omitirán estas filas):
                      </div>
                      <div style={{ maxHeight: '120px', overflowY: 'auto', fontSize: '11px', color: '#B91C1C', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        {uploadPreview.errors.map((err, i) => (
                          <div key={i} style={{ padding: '4px 8px', backgroundColor: 'rgba(239, 68, 68, 0.05)', borderRadius: '4px' }}>
                            • {err}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Listado de Actualizaciones detalladas con Aprobación por Campo y por Usuario */}
                  {uploadPreview.updates && uploadPreview.updates.length > 0 && (() => {
                    const availableFields = Array.from(new Set(
                      uploadPreview.updates.flatMap(upd => upd.changes.map(chg => chg.field))
                    )).sort();

                    const getFieldTotalCount = (field) => {
                      return uploadPreview.updates.filter(upd => 
                        upd.changes.some(chg => chg.field === field)
                      ).length;
                    };

                    const getFieldAcceptedCount = (field) => {
                      return uploadPreview.updates.filter(upd => 
                        upd.changes.some(chg => chg.field === field) && 
                        (acceptedUpdates[upd.usuario_ffm] || []).includes(field)
                      ).length;
                    };

                    const totalPossibleUpdates = uploadPreview.updates.reduce((acc, upd) => acc + upd.changes.length, 0);
                    const totalSelectedUpdates = uploadPreview.updates.reduce((acc, upd) => acc + ((acceptedUpdates[upd.usuario_ffm] || []).length), 0);
                    const totalAffectedTechs = uploadPreview.updates.filter(upd => (acceptedUpdates[upd.usuario_ffm] || []).length > 0).length;

                    const filteredUpdates = uploadPreview.updates.filter(upd => {
                      const matchesField = updateFilterField === 'ALL' || upd.changes.some(chg => chg.field === updateFilterField);
                      const q = updatesSearchQuery.trim().toLowerCase();
                      const matchesQuery = !q || 
                        (upd.usuario_ffm || '').toLowerCase().includes(q) ||
                        (upd.full_name || '').toLowerCase().includes(q);
                      return matchesField && matchesQuery;
                    });

                    return (
                      <div style={{ marginBottom: '16px', backgroundColor: 'white', padding: '16px', borderRadius: '10px', border: '1px solid #E5E7EB', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                        {/* Cabecera de la sección de actualizaciones */}
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', gap: '10px', borderBottom: '1px solid #F3F4F6', pb: '10px', paddingBottom: '12px' }}>
                          <div>
                            <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#1E3A8A', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span>{uploadPreview.is_historical ? '📜' : '🔄'}</span>
                              <span>{uploadPreview.is_historical ? 'Historial a Registrar' : 'Actualizaciones Detectadas'}:</span>
                              <span style={{ 
                                backgroundColor: totalSelectedUpdates > 0 ? '#DBEAFE' : '#F3F4F6', 
                                color: totalSelectedUpdates > 0 ? '#1E40AF' : '#6B7280', 
                                padding: '2px 8px', 
                                borderRadius: '12px', 
                                fontSize: '11px', 
                                fontWeight: '700' 
                              }}>
                                {totalSelectedUpdates} de {totalPossibleUpdates} cambios aceptados ({totalAffectedTechs} técnicos)
                              </span>
                            </div>
                            <div style={{ fontSize: '11px', color: '#64748B', marginTop: '2px' }}>
                              Marca o desmarca si deseas aplicar cambios por <strong>apartado</strong> (ej. Región, Distrito) o individualmente por <strong>técnico</strong>.
                            </div>
                          </div>

                          {/* Botones globales Aceptar Todos / Omitir Todos */}
                          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                            <button
                              type="button"
                              onClick={() => setAllUpdatesGlobally(true)}
                              style={{
                                padding: '5px 10px',
                                borderRadius: '6px',
                                border: '1px solid #86EFAC',
                                backgroundColor: '#F0FDF4',
                                color: '#166534',
                                fontSize: '11px',
                                fontWeight: '700',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                              }}
                              title="Aceptar todos los cambios propuestos en todos los técnicos"
                            >
                              ✅ Aceptar Todos
                            </button>
                            <button
                              type="button"
                              onClick={() => setAllUpdatesGlobally(false)}
                              style={{
                                padding: '5px 10px',
                                borderRadius: '6px',
                                border: '1px solid #E5E7EB',
                                backgroundColor: '#F9FAFB',
                                color: '#4B5563',
                                fontSize: '11px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                              }}
                              title="Omitir todos los cambios de todos los técnicos"
                            >
                              ❌ Omitir Todos
                            </button>
                          </div>
                        </div>

                        {/* PANEL DESTACADO: Aceptación por Apartado / Campo */}
                        <div style={{ 
                          backgroundColor: '#F8FAFC', 
                          border: '1px solid #E2E8F0', 
                          borderRadius: '8px', 
                          padding: '12px', 
                          marginBottom: '14px' 
                        }}>
                          <div style={{ fontSize: '11.5px', fontWeight: 'bold', color: '#334155', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span>🏷️</span> Decisión Rápida por Apartado (Afecta a todos los técnicos con ese dato):
                          </div>
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '8px' }}>
                            {availableFields.map(field => {
                              const totalForField = getFieldTotalCount(field);
                              const acceptedForField = getFieldAcceptedCount(field);
                              const isAllAccepted = acceptedForField === totalForField && totalForField > 0;
                              const isNoneAccepted = acceptedForField === 0;

                              return (
                                <div 
                                  key={field}
                                  style={{
                                    backgroundColor: isAllAccepted ? '#F0FDF4' : isNoneAccepted ? '#FFFFFF' : '#EFF6FF',
                                    border: `1.5px solid ${isAllAccepted ? '#86EFAC' : isNoneAccepted ? '#E2E8F0' : '#93C5FD'}`,
                                    borderRadius: '8px',
                                    padding: '8px 10px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '6px',
                                    transition: 'all 0.15s ease'
                                  }}
                                >
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ 
                                      fontWeight: '700', 
                                      fontSize: '11.5px', 
                                      color: isAllAccepted ? '#166534' : isNoneAccepted ? '#475569' : '#1E40AF' 
                                    }}>
                                      {field === 'Región' ? '📍 Región' : 
                                       field === 'Distrito' ? '🏢 Distrito' : 
                                       field === 'Gerente' ? '👔 Gerente' : 
                                       field === 'Empresa' ? '🏭 Empresa' : 
                                       field === 'Teléfono' ? '📞 Teléfono' : 
                                       field === 'Planta' ? '⚡ Planta' : 
                                       field === 'Estatus' ? '🚦 Estatus' : `📝 ${field}`}
                                    </span>
                                    <span style={{ 
                                      fontSize: '10px', 
                                      fontWeight: 'bold', 
                                      padding: '1px 6px', 
                                      borderRadius: '10px',
                                      backgroundColor: isAllAccepted ? '#DCFCE7' : isNoneAccepted ? '#F1F5F9' : '#DBEAFE',
                                      color: isAllAccepted ? '#15803D' : isNoneAccepted ? '#64748B' : '#1D4ED8'
                                    }}>
                                      {acceptedForField} / {totalForField}
                                    </span>
                                  </div>

                                  <div style={{ display: 'flex', gap: '4px' }}>
                                    <button
                                      type="button"
                                      onClick={() => toggleFieldGlobally(field, true)}
                                      style={{
                                        flex: 1,
                                        padding: '3px 6px',
                                        fontSize: '10px',
                                        fontWeight: '700',
                                        borderRadius: '4px',
                                        border: '1px solid #86EFAC',
                                        backgroundColor: isAllAccepted ? '#16A34A' : '#FFFFFF',
                                        color: isAllAccepted ? '#FFFFFF' : '#15803D',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      ✓ Aceptar ({totalForField})
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => toggleFieldGlobally(field, false)}
                                      style={{
                                        flex: 1,
                                        padding: '3px 6px',
                                        fontSize: '10px',
                                        fontWeight: '600',
                                        borderRadius: '4px',
                                        border: '1px solid #CBD5E1',
                                        backgroundColor: isNoneAccepted ? '#64748B' : '#FFFFFF',
                                        color: isNoneAccepted ? '#FFFFFF' : '#475569',
                                        cursor: 'pointer'
                                      }}
                                    >
                                      ✕ Omitir
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        {/* Barra de Búsqueda y Filtros de visualización */}
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                          {/* Buscador de técnicos */}
                          <div style={{ flex: '1 1 240px', maxWidth: '340px', position: 'relative' }}>
                            <input
                              type="text"
                              value={updatesSearchQuery}
                              onChange={(e) => setUpdatesSearchQuery(e.target.value)}
                              placeholder="🔍 Buscar técnico por FFM o Nombre..."
                              style={{
                                width: '100%',
                                padding: '6px 10px',
                                borderRadius: '6px',
                                border: '1px solid #CBD5E1',
                                fontSize: '11px',
                                outline: 'none',
                                boxSizing: 'border-box'
                              }}
                            />
                            {updatesSearchQuery && (
                              <button
                                type="button"
                                onClick={() => setUpdatesSearchQuery('')}
                                style={{
                                  position: 'absolute',
                                  right: '6px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  border: 'none',
                                  background: 'none',
                                  color: '#94A3B8',
                                  cursor: 'pointer',
                                  fontSize: '12px'
                                }}
                              >
                                &times;
                              </button>
                            )}
                          </div>

                          {/* Chips de filtro visual */}
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
                            <span style={{ fontSize: '10px', color: '#64748B', fontWeight: 'bold' }}>Ver cambios en:</span>
                            <button
                              type="button"
                              onClick={() => setUpdateFilterField('ALL')}
                              style={{
                                padding: '2px 7px',
                                borderRadius: '10px',
                                border: '1px solid #CBD5E1',
                                fontSize: '10px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                backgroundColor: updateFilterField === 'ALL' ? '#1E3A8A' : '#FFFFFF',
                                color: updateFilterField === 'ALL' ? 'white' : '#475569'
                              }}
                            >
                              Todos ({uploadPreview.updates.length})
                            </button>
                            {availableFields.map(field => (
                              <button
                                key={field}
                                type="button"
                                onClick={() => setUpdateFilterField(field)}
                                style={{
                                  padding: '2px 7px',
                                  borderRadius: '10px',
                                  border: '1px solid #CBD5E1',
                                  fontSize: '10px',
                                  fontWeight: 'bold',
                                  cursor: 'pointer',
                                  backgroundColor: updateFilterField === field ? '#1E3A8A' : '#FFFFFF',
                                  color: updateFilterField === field ? 'white' : '#475569'
                                }}
                              >
                                {field} ({getFieldTotalCount(field)})
                              </button>
                            ))}
                          </div>
                        </div>

                        {/* LISTADO DE TÉCNICOS INDIVIDUALES CON SWITCHES POR CAMPO */}
                        <div style={{ 
                          maxHeight: '340px', 
                          overflowY: 'auto', 
                          display: 'flex', 
                          flexDirection: 'column', 
                          gap: '10px', 
                          border: '1px solid #E2E8F0', 
                          padding: '10px', 
                          borderRadius: '8px', 
                          backgroundColor: '#FAFAFA' 
                        }}>
                          {filteredUpdates.length === 0 ? (
                            <div style={{ fontSize: '11px', color: '#94A3B8', textAlign: 'center', padding: '24px' }}>
                              🔍 No se encontraron técnicos con el filtro o término de búsqueda aplicado.
                            </div>
                          ) : (
                            filteredUpdates.map((upd, idx) => {
                              const userAcceptedFields = acceptedUpdates[upd.usuario_ffm] || [];
                              const isAllUserAccepted = upd.changes.length > 0 && upd.changes.every(c => userAcceptedFields.includes(c.field));
                              const isNoneUserAccepted = userAcceptedFields.length === 0;

                              return (
                                <div 
                                  key={idx} 
                                  style={{ 
                                    backgroundColor: isNoneUserAccepted ? '#F9FAFB' : '#FFFFFF',
                                    border: `1.5px solid ${isAllUserAccepted ? '#BFDBFE' : isNoneUserAccepted ? '#E5E7EB' : '#93C5FD'}`, 
                                    borderRadius: '8px', 
                                    padding: '10px 12px',
                                    opacity: isNoneUserAccepted ? 0.65 : 1.0,
                                    transition: 'all 0.15s ease'
                                  }}
                                >
                                  {/* Encabezado del Técnico */}
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <input
                                        type="checkbox"
                                        id={`tech-${upd.usuario_ffm}`}
                                        checked={isAllUserAccepted}
                                        onChange={() => toggleAllChangesForUser(upd.usuario_ffm, upd.changes)}
                                        style={{ cursor: 'pointer', width: '15px', height: '15px' }}
                                        title={isAllUserAccepted ? 'Desmarcar todos los cambios de este técnico' : 'Aceptar todos los cambios de este técnico'}
                                      />
                                      <label 
                                        htmlFor={`tech-${upd.usuario_ffm}`}
                                        style={{ fontWeight: 'bold', color: '#1F2937', fontSize: '11.5px', cursor: 'pointer' }}
                                      >
                                        <span style={{ 
                                          backgroundColor: '#EEF2FF', 
                                          color: '#4338CA', 
                                          padding: '2px 6px', 
                                          borderRadius: '4px', 
                                          fontFamily: 'monospace', 
                                          marginRight: '6px' 
                                        }}>
                                          {upd.usuario_ffm}
                                        </span>
                                        {upd.full_name || 'Sin Nombre'}
                                      </label>
                                    </div>

                                    {/* Insignia y botón rápido por técnico */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                      <span style={{
                                        fontSize: '10px',
                                        fontWeight: '700',
                                        padding: '2px 8px',
                                        borderRadius: '12px',
                                        backgroundColor: isAllUserAccepted ? '#DCFCE7' : isNoneUserAccepted ? '#F3F4F6' : '#EFF6FF',
                                        color: isAllUserAccepted ? '#166534' : isNoneUserAccepted ? '#6B7280' : '#1E40AF'
                                      }}>
                                        {isNoneUserAccepted ? '⏸️ Omitido' : `${userAcceptedFields.length} de ${upd.changes.length} cambios`}
                                      </span>
                                      <button
                                        type="button"
                                        onClick={() => toggleAllChangesForUser(upd.usuario_ffm, upd.changes)}
                                        style={{
                                          padding: '2px 6px',
                                          fontSize: '10px',
                                          fontWeight: '600',
                                          border: '1px solid #CBD5E1',
                                          borderRadius: '4px',
                                          backgroundColor: '#FFFFFF',
                                          color: '#475569',
                                          cursor: 'pointer'
                                        }}
                                      >
                                        {isAllUserAccepted ? 'Omitir técnico' : 'Aceptar todos'}
                                      </button>
                                    </div>
                                  </div>

                                  {/* Lista de cambios específicos para este técnico */}
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginLeft: '22px' }}>
                                    {upd.changes
                                      .filter(chg => updateFilterField === 'ALL' || chg.field === updateFilterField)
                                      .map((chg, i) => {
                                        const isChangeAccepted = userAcceptedFields.includes(chg.field);

                                        return (
                                          <div 
                                            key={i} 
                                            onClick={() => toggleChangeForUser(upd.usuario_ffm, chg.field)}
                                            style={{ 
                                              display: 'flex', 
                                              alignItems: 'center', 
                                              justifyContent: 'space-between',
                                              padding: '5px 8px',
                                              borderRadius: '6px',
                                              backgroundColor: isChangeAccepted ? '#F0FDF4' : '#F8FAFC',
                                              border: `1px solid ${isChangeAccepted ? '#BBF7D0' : '#E2E8F0'}`,
                                              cursor: 'pointer',
                                              fontSize: '11px',
                                              transition: 'background-color 0.1s ease'
                                            }}
                                          >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                              <input
                                                type="checkbox"
                                                checked={isChangeAccepted}
                                                onChange={() => {}} // Manejado por onClick del contenedor
                                                style={{ cursor: 'pointer' }}
                                              />
                                              <span style={{ 
                                                color: '#1E40AF', 
                                                fontWeight: 'bold', 
                                                backgroundColor: '#DBEAFE', 
                                                padding: '1px 6px', 
                                                borderRadius: '4px',
                                                fontSize: '10px'
                                              }}>
                                                {chg.field}
                                              </span>
                                              <span style={{ textDecoration: 'line-through', color: '#94A3B8' }}>
                                                {chg.old || '(vacío)'}
                                              </span>
                                              <span style={{ color: '#64748B' }}>➡️</span>
                                              <span style={{ color: isChangeAccepted ? '#15803D' : '#64748B', fontWeight: 'bold' }}>
                                                {chg.new || '(vacío)'}
                                              </span>
                                              {uploadPreview.is_historical && (
                                                <span style={{ fontSize: '9.5px', color: '#9CA3AF', fontStyle: 'italic' }}>
                                                  (Solo Historial)
                                                </span>
                                              )}
                                            </div>

                                            <div>
                                              <span style={{
                                                fontSize: '10px',
                                                fontWeight: '700',
                                                color: isChangeAccepted ? '#166534' : '#94A3B8'
                                              }}>
                                                {isChangeAccepted ? '✓ Se actualizará' : '✕ No cambiar'}
                                              </span>
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    );
                  })()}

                  {/* Listado de Nuevos Técnicos con selección interactiva */}
                  {uploadPreview.creations && uploadPreview.creations.length > 0 && (() => {
                    const totalCreations = uploadPreview.creations.length;
                    const selectedCreationsCount = uploadPreview.creations.filter(cre => acceptedCreations[cre.usuario_ffm]).length;
                    const isAllCreationsSelected = selectedCreationsCount === totalCreations;

                    return (
                      <div style={{ marginBottom: '20px', backgroundColor: 'white', padding: '14px', borderRadius: '8px', border: '1px solid #E5E7EB', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                          <div>
                            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#065F46', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span>✨</span> Nuevos Técnicos a Registrar ({selectedCreationsCount} de {totalCreations}):
                            </div>
                            <div style={{ fontSize: '10.5px', color: '#64748B' }}>
                              Puedes desmarcar técnicos específicos si no deseas darlos de alta en esta carga.
                            </div>
                          </div>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button
                              type="button"
                              onClick={() => setAllCreationsGlobally(true)}
                              style={{
                                padding: '3px 8px',
                                borderRadius: '4px',
                                border: '1px solid #86EFAC',
                                backgroundColor: isAllCreationsSelected ? '#16A34A' : '#F0FDF4',
                                color: isAllCreationsSelected ? '#FFFFFF' : '#166534',
                                fontSize: '10px',
                                fontWeight: '700',
                                cursor: 'pointer'
                              }}
                            >
                              ✓ Crear Todos ({totalCreations})
                            </button>
                            <button
                              type="button"
                              onClick={() => setAllCreationsGlobally(false)}
                              style={{
                                padding: '3px 8px',
                                borderRadius: '4px',
                                border: '1px solid #CBD5E1',
                                backgroundColor: '#F9FAFB',
                                color: '#475569',
                                fontSize: '10px',
                                fontWeight: '600',
                                cursor: 'pointer'
                              }}
                            >
                              ✕ Omitir Todos
                            </button>
                          </div>
                        </div>

                        <div style={{ maxHeight: '180px', overflowY: 'auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '8px' }}>
                          {uploadPreview.creations.map((cre, idx) => {
                            const isSelected = !!acceptedCreations[cre.usuario_ffm];

                            return (
                              <div 
                                key={idx} 
                                onClick={() => toggleCreation(cre.usuario_ffm)}
                                style={{ 
                                  padding: '8px 10px', 
                                  backgroundColor: isSelected ? '#F0FDF4' : '#F9FAFB', 
                                  border: `1.5px solid ${isSelected ? '#86EFAC' : '#E5E7EB'}`, 
                                  borderRadius: '6px', 
                                  fontSize: '11px',
                                  cursor: 'pointer',
                                  opacity: isSelected ? 1 : 0.6,
                                  transition: 'all 0.15s ease'
                                }}
                              >
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '2px' }}>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <input
                                      type="checkbox"
                                      checked={isSelected}
                                      onChange={() => {}}
                                      style={{ cursor: 'pointer' }}
                                    />
                                    <span style={{ fontWeight: 'bold', color: isSelected ? '#166534' : '#4B5563', fontFamily: 'monospace' }}>
                                      {cre.usuario_ffm}
                                    </span>
                                  </div>
                                  <span style={{ 
                                    fontSize: '9.5px', 
                                    fontWeight: 'bold',
                                    color: isSelected ? '#15803D' : '#9CA3AF'
                                  }}>
                                    {isSelected ? 'Registrar' : 'Omitido'}
                                  </span>
                                </div>
                                <div style={{ color: '#374151', fontWeight: '500', marginLeft: '20px' }}>{cre.full_name || 'Sin nombre'}</div>
                                <div style={{ color: '#6B7280', fontSize: '10px', marginLeft: '20px', marginTop: '2px' }}>
                                  📍 {cre.region} / {cre.distrito} | 🏢 {cre.empresa || 'S/E'}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })()}

                  {/* Resumen de selección antes de aplicar y Botones de acción */}
                  {(() => {
                    const totalSelectedUpdates = uploadPreview.updates ? uploadPreview.updates.reduce((acc, upd) => acc + ((acceptedUpdates[upd.usuario_ffm] || []).length), 0) : 0;
                    const totalAffectedTechs = uploadPreview.updates ? uploadPreview.updates.filter(upd => (acceptedUpdates[upd.usuario_ffm] || []).length > 0).length : 0;
                    const totalSelectedCreations = uploadPreview.creations ? uploadPreview.creations.filter(cre => acceptedCreations[cre.usuario_ffm]).length : 0;
                    const hasSelections = totalSelectedUpdates > 0 || totalSelectedCreations > 0;

                    return (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'space-between', alignItems: 'center', paddingTop: '10px', borderTop: '1px solid #DBEAFE' }}>
                        <div style={{ fontSize: '12px', color: '#1E40AF', fontWeight: '600' }}>
                          {hasSelections ? (
                            <span>
                              📋 Se aplicarán <strong>{totalSelectedUpdates}</strong> cambios en <strong>{totalAffectedTechs}</strong> técnicos
                              {totalSelectedCreations > 0 && <span> y se registrarán <strong>{totalSelectedCreations}</strong> técnicos nuevos</span>}.
                            </span>
                          ) : (
                            <span style={{ color: '#DC2626' }}>
                              ⚠️ No has seleccionado ningún cambio ni técnico nuevo a aplicar.
                            </span>
                          )}
                        </div>

                        <div style={{ display: 'flex', gap: '10px' }}>
                          <button
                            type="button"
                            onClick={handleCancelUpload}
                            disabled={uploading}
                            style={{
                              padding: '9px 18px',
                              backgroundColor: '#E5E7EB',
                              color: '#374151',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontWeight: '600',
                              fontSize: '12px'
                            }}
                          >
                            Cancelar
                          </button>
                          <button
                            type="button"
                            onClick={handleConfirmUpload}
                            disabled={uploading || !hasSelections}
                            style={{
                              padding: '9px 20px',
                              backgroundColor: hasSelections ? '#059669' : '#9CA3AF',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: hasSelections && !uploading ? 'pointer' : 'not-allowed',
                              fontWeight: '700',
                              fontSize: '12px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              boxShadow: hasSelections ? '0 4px 6px -1px rgba(5, 150, 105, 0.25)' : 'none'
                            }}
                          >
                            {uploading ? '⏳ Procesando...' : `✅ Confirmar y Aplicar Carga (${totalSelectedUpdates} cambios + ${totalSelectedCreations} nuevos)`}
                          </button>
                        </div>
                      </div>
                    );
                  })()}
                </div>
              )}

              {uploadResult && (
                <div style={{
                  backgroundColor: '#F3F4F6',
                  padding: '12px',
                  borderRadius: '8px',
                  marginBottom: '20px',
                  border: '1px solid #D1D5DB'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <h4 style={{ margin: 0, fontSize: '14px' }}>📊 Resumen de Carga</h4>
                    <button onClick={() => setUploadResult(null)} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '16px' }}>&times;</button>
                  </div>
                  <div style={{ display: 'flex', gap: '15px', fontSize: '12px' }}>
                    <span style={{ color: '#059669', fontWeight: 'bold' }}>✅ Creados: {uploadResult.created}</span>
                    {uploadResult.is_historical ? (
                      <span style={{ color: '#8B5CF6', fontWeight: 'bold' }}>📜 Historiales Registrados: {uploadResult.historical_added}</span>
                    ) : (
                      <span style={{ color: '#2563EB', fontWeight: 'bold' }}>🔄 Actualizados: {uploadResult.updated}</span>
                    )}
                    <span style={{ color: '#DC2626', fontWeight: 'bold' }}>❌ Errores: {uploadResult.errors?.length || 0}</span>
                  </div>
                  {uploadResult.errors?.length > 0 && (
                    <div style={{ marginTop: '8px', fontSize: '11px', color: '#DC2626', maxHeight: '80px', overflowY: 'auto', borderTop: '1px solid #E5E7EB', paddingTop: '5px' }}>
                      {uploadResult.errors.map((err, i) => <div key={i}>• {err}</div>)}
                    </div>
                  )}
                </div>
              )}

              <form onSubmit={handleCreateUser}>
                <div style={styles.formGrid}>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Nombre Completo *</label>
                    <input
                      type="text"
                      placeholder="Ej: JUAN PÉREZ"
                      value={formData.full_name}
                      onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                      style={styles.formInput}
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Usuario *</label>
                    <input
                      type="text"
                      placeholder="Ej: JPEREZ"
                      value={formData.usuario_ffm}
                      onChange={(e) => {
                        const val = e.target.value.toUpperCase();
                        let tipoPlanta = formData.tipo_planta;
                        if (val.length >= 5) {
                          const sub = val.substring(3, 5);
                          tipoPlanta = (sub === 'MT') ? 'PI' : 'PE';
                        }
                        setFormData({ ...formData, usuario_ffm: val, tipo_planta: tipoPlanta });
                      }}
                      maxLength="13"
                      style={{
                        ...styles.formInput,
                        border: /TO\d{3}$/.test(formData.usuario_ffm) ? '2px solid #EF4444' : styles.formInput.border,
                        boxShadow: /TO\d{3}$/.test(formData.usuario_ffm) ? '0 0 0 3px rgba(239, 68, 68, 0.2)' : 'none'
                      }}
                    />
                    {/TO\d{3}$/.test(formData.usuario_ffm) && (
                      <span style={{ color: '#EF4444', fontSize: '12px', marginTop: '4px', display: 'block', fontWeight: 'bold' }}>
                        ⚠️ Detectado "TO" en lugar de "T0" al final. Reemplace la letra "O" por el número cero "0".
                      </span>
                    )}
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>CURP *</label>
                    <input
                      type="text"
                      placeholder="18 caracteres"
                      value={formData.curp}
                      onChange={(e) => setFormData({ ...formData, curp: e.target.value.toUpperCase() })}
                      maxLength="18"
                      style={styles.formInput}
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Teléfono *</label>
                    <input
                      type="tel"
                      placeholder="10 dígitos"
                      value={formData.telefono}
                      onChange={(e) => setFormData({ ...formData, telefono: e.target.value })}
                      style={styles.formInput}
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Email *</label>
                    <input
                      type="email"
                      placeholder="ejemplo@empresa.com"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      style={styles.formInput}
                    />
                  </div>
                  <div style={{ ...styles.formGroup, position: 'relative' }}>
                    <label style={styles.formLabel}>Distrito *</label>
                    <input
                      type="text"
                      placeholder={isPEUser ? "Ej: DISTRITO PE 1 (Campo libre)" : "Escribe para buscar distrito..."}
                      value={formData.distrito}
                      onChange={(e) => {
                        if (isPEUser) {
                          setFormData({ ...formData, distrito: e.target.value.toUpperCase() });
                        } else {
                          handleDistritoChange(e.target.value);
                        }
                      }}
                      onFocus={() => !isPEUser && formData.distrito && setShowDistritoSuggestions(true)}
                      style={styles.formInput}
                      autoComplete="off"
                    />
                    {!isPEUser && showDistritoSuggestions && filteredDistritos.length > 0 && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        backgroundColor: 'white',
                        border: '1px solid #D1D5DB',
                        borderRadius: '0 0 8px 8px',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                        zIndex: 10,
                        maxHeight: '200px',
                        overflowY: 'auto'
                      }}>
                        {filteredDistritos.map((item, idx) => (
                          <div
                            key={idx}
                            onClick={() => selectDistrito(item)}
                            style={{
                              padding: '10px 15px',
                              cursor: 'pointer',
                              borderBottom: idx === filteredDistritos.length - 1 ? 'none' : '1px solid #F3F4F6',
                              fontSize: '14px',
                              transition: 'background 0.2s'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#F3F4FB'}
                            onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
                          >
                            <div style={{ fontWeight: 'bold' }}>{item.distrito}</div>
                            <div style={{ fontSize: '11px', color: '#6B7280' }}>Región: {item.region}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Región *</label>
                    <input
                      type="text"
                      placeholder={isPEUser ? "Ej: REGION PE 1 (Campo libre)" : "Selecciona distrito primero"}
                      value={formData.region}
                      onChange={(e) => isPEUser && setFormData({ ...formData, region: e.target.value.toUpperCase() })}
                      readOnly={!isPEUser}
                      style={{ ...styles.formInput, ...(isPEUser ? {} : { backgroundColor: '#F9FAFB', cursor: 'not-allowed' }) }}
                    />
                  </div>
                  {selectedRole === 'technician' && (
                    <>
                      <div style={styles.formGroup}>
                        <label style={styles.formLabel}>Empresa / Proveedor *</label>
                        {isPEUser ? (
                          <input
                            type="text"
                            placeholder="Ej: PROVEEDOR PE 1 (Campo libre)"
                            value={formData.empresa}
                            onChange={(e) => setFormData({ ...formData, empresa: e.target.value.toUpperCase() })}
                            style={styles.formInput}
                          />
                        ) : (
                          <select
                            style={styles.formInput}
                            value={formData.empresa}
                            onChange={(e) => setFormData({ ...formData, empresa: e.target.value })}
                          >
                            <option value="">-- Seleccionar Empresa --</option>
                            {(empresasCatalog[formData.distrito] || []).map(emp => (
                              <option key={emp} value={emp}>{emp}</option>
                            ))}
                          </select>
                        )}
                      </div>
                      <div style={styles.formGroup}>
                        <label style={styles.formLabel}>Cluster</label>
                        <input
                          type="text"
                          placeholder="Ej: CLUSTER A"
                          value={formData.cluster}
                          onChange={(e) => setFormData({ ...formData, cluster: e.target.value.toUpperCase() })}
                          style={styles.formInput}
                        />
                      </div>
                    </>
                  )}
                  {(selectedRole === 'technician' || selectedRole === 'inspector') && (
                    <div style={styles.formGroup}>
                      <label style={styles.formLabel}>Gerente</label>
                      <input
                        type="text"
                        placeholder="Ej: GERENTE REGIONAL"
                        value={formData.gerente}
                        onChange={(e) => setFormData({ ...formData, gerente: e.target.value.toUpperCase() })}
                        style={styles.formInput}
                      />
                    </div>
                  )}
                  {selectedRole === 'technician' && (
                    <div style={styles.formGroup}>
                      <label style={styles.formLabel}>Planta *</label>
                      <select
                        style={{ ...styles.formInput, backgroundColor: isPlantaFixed ? '#F1F5F9' : 'white' }}
                        value={isPlantaFixed ? user?.tipo_planta : (formData.tipo_planta || 'PI')}
                        onChange={(e) => setFormData({ ...formData, tipo_planta: e.target.value })}
                        disabled={isPlantaFixed}
                      >
                        {(!isPlantaFixed || user?.tipo_planta === 'PI') && <option value="PI">Planta Interna (PI)</option>}
                        {(!isPlantaFixed || user?.tipo_planta === 'PE') && <option value="PE">Planta Externa (PE)</option>}
                      </select>
                      {isPlantaFixed && (
                        <span style={{ fontSize: '11px', color: '#64748B', marginTop: '4px', display: 'block' }}>
                          🔒 Fijado a Planta {user?.tipo_planta === 'PE' ? 'Externa (PE)' : 'Interna (PI)'} por tu perfil de usuario
                        </span>
                      )}
                    </div>
                  )}
                </div>

                <button
                  type="submit"
                  style={styles.createButton}
                >
                  <span>➕</span>
                  <span style={{ marginLeft: '12px' }}>Crear Usuario</span>
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Tab 3: Reports */}
        {activeTab === 'reports' && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <span style={styles.cardIcon}>📊</span>
              <div>
                <h2 style={styles.cardTitle}>Generar Reportes</h2>
                <p style={styles.cardSubtitle}>Descarga reportes detallados en formato CSV</p>
              </div>
            </div>

            <div style={styles.filterCard}>
              <h3 style={styles.filterTitle}>
                <span style={{ marginRight: '8px' }}>⚙️</span>
                Filtros de Búsqueda
              </h3>
              <div style={styles.filterGrid}>
                {/* NUEVO campo: Filtro por usuario */}
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Usuario (opcional)</label>
                  <input
                    type="text"
                    placeholder="Ej: JPEREZ"
                    value={reportFilters.usuario_ffm}
                    onChange={(e) => setReportFilters({ ...reportFilters, usuario_ffm: e.target.value.toUpperCase() })}
                    style={styles.formInput}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Región</label>
                  {isPEUser ? (
                    <input
                      type="text"
                      placeholder="Región PE (Campo libre)..."
                      value={reportFilters.region}
                      onChange={(e) => setReportFilters({ ...reportFilters, region: e.target.value.toUpperCase() })}
                      style={styles.formInput}
                    />
                  ) : user?.role === 'district_manager' ? (
                    <input
                      type="text"
                      value={user.region || 'Región Asignada'}
                      disabled
                      style={{ ...styles.formInput, backgroundColor: '#f1f5f9', cursor: 'not-allowed', color: '#475569', fontWeight: 'bold' }}
                    />
                  ) : (
                    <select
                      value={reportFilters.region}
                      onChange={(e) => setReportFilters({ ...reportFilters, region: e.target.value.toUpperCase(), distrito: '' })}
                      style={styles.formInput}
                    >
                      <option value="">-- Seleccionar Región --</option>
                      {reportRegionOptions.map(r => (
                        <option key={r} value={r}>{r}</option>
                      ))}
                    </select>
                  )}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Distrito</label>
                  {isPEUser ? (
                    <input
                      type="text"
                      placeholder="Distrito PE (Campo libre)..."
                      value={reportFilters.distrito}
                      onChange={(e) => setReportFilters({ ...reportFilters, distrito: e.target.value.toUpperCase() })}
                      style={styles.formInput}
                    />
                  ) : user?.role === 'district_manager' ? (
                    <input
                      type="text"
                      value={user.distrito || 'Distrito Asignado'}
                      disabled
                      style={{ ...styles.formInput, backgroundColor: '#f1f5f9', cursor: 'not-allowed', color: '#475569', fontWeight: 'bold' }}
                    />
                  ) : (
                    <select
                      value={reportFilters.distrito}
                      onChange={(e) => setReportFilters({ ...reportFilters, distrito: e.target.value.toUpperCase() })}
                      style={styles.formInput}
                    >
                      <option value="">-- Seleccionar Distrito --</option>
                      {reportDistritoOptions.map(d => (
                        <option key={d} value={d}>{d}</option>
                      ))}
                    </select>
                  )}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Planta</label>
                  <select
                    value={isPlantaFixed ? (user?.tipo_planta || 'PE') : (reportFilters.tipo_planta || '')}
                    onChange={(e) => {
                      if (!isPlantaFixed) {
                        setReportFilters({ ...reportFilters, tipo_planta: e.target.value });
                      }
                    }}
                    style={{
                      ...styles.formInput,
                      backgroundColor: isPlantaFixed ? '#F1F5F9' : 'white',
                      cursor: isPlantaFixed ? 'not-allowed' : 'default',
                      color: isPlantaFixed ? '#475569' : '#1E293B',
                      fontWeight: isPlantaFixed ? 'bold' : 'normal'
                    }}
                    disabled={isPlantaFixed}
                  >
                    {!isPlantaFixed && <option value="">-- Todas las Plantas --</option>}
                    {(!isPlantaFixed || user?.tipo_planta === 'PI') && <option value="PI">Planta Interna (PI)</option>}
                    {(!isPlantaFixed || user?.tipo_planta === 'PE') && <option value="PE">Planta Externa (PE)</option>}
                  </select>
                  {isPlantaFixed && (
                    <small style={{ color: '#64748B', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                      🔒 Fijado a Planta {user?.tipo_planta === 'PE' ? 'Externa (PE)' : 'Interna (PI)'} por tu perfil de usuario
                    </small>
                  )}
                </div>
                <div style={styles.dateRangeGroup}>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Fecha Inicio</label>
                    <input
                      type="date"
                      value={reportFilters.fechaInicio}
                      onChange={(e) => setReportFilters({ ...reportFilters, fechaInicio: e.target.value })}
                      onClick={(e) => e.target.showPicker && e.target.showPicker()}
                      style={styles.formInput}
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Fecha Fin</label>
                    <input
                      type="date"
                      value={reportFilters.fechaFin}
                      onChange={(e) => setReportFilters({ ...reportFilters, fechaFin: e.target.value })}
                      onClick={(e) => e.target.showPicker && e.target.showPicker()}
                      style={styles.formInput}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div style={styles.buttonGroup}>
              <button
                onClick={handlePreviewReports}
                disabled={previewLoading}
                style={styles.previewButton}
              >
                {previewLoading ? (
                  <div style={styles.spinner}></div>
                ) : (
                  <span>👁️</span>
                )}
                <span style={{ marginLeft: '12px' }}>Vista Previa</span>
              </button>

              <button
                onClick={handleDownloadReport}
                disabled={reportLoading}
                style={styles.downloadButton}
              >
                {reportLoading ? (
                  <div style={styles.spinner}></div>
                ) : (
                  <span>⬇️</span>
                )}
                <span style={{ marginLeft: '12px' }}>Descargar CSV</span>
              </button>
            </div>

            {/* Vista Previa de Resultados */}
            {showPreview && previewData.reports.length > 0 && (
              <div style={styles.previewCard}>
                <div style={styles.previewHeader}>
                  <h3 style={styles.previewTitle}>
                    <span style={{ marginRight: '8px' }}>📋</span>
                    Vista Previa - {previewData.total_records} registros encontrados
                  </h3>
                  <div style={styles.paginationControls}>
                    <select
                      value={previewData.limit}
                      onChange={handleLimitChange}
                      style={styles.pageSelect}
                    >
                      <option value="10">10 por página</option>
                      <option value="25">25 por página</option>
                      <option value="50">50 por página</option>
                      <option value="100">100 por página</option>
                    </select>
                  </div>
                </div>

                <div style={styles.tableContainer}>
                  <table style={styles.table}>
                    <thead>
                      <tr style={styles.tableHeader}>
                        <th style={styles.tableHeaderCell}>Usuario</th>
                        <th style={styles.tableHeaderCell}>Nombre</th>
                        <th style={styles.tableHeaderCell}>Región/Distrito</th>
                        <th style={styles.tableHeaderCell}>Inicio</th>
                        <th style={styles.tableHeaderCell}>Fin</th>
                        <th style={styles.tableHeaderCell}>Estado</th>
                        <th style={styles.tableHeaderCell}>Segmentos</th>
                        <th style={styles.tableHeaderCell}>No Realizables</th>
                        <th style={styles.tableHeaderCell}>Tiempo (min)</th>
                        <th style={styles.tableHeaderCell}>Distancia (m)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {previewData.reports.map((report, i) => (
                        <tr key={report.id} style={{
                          ...styles.tableRow,
                          backgroundColor: i % 2 === 0 ? 'white' : '#F9FAFB'
                        }}>
                          <td style={{ ...styles.tableCell, fontWeight: 'bold', color: '#2563EB' }}>
                            {report.usuario_ffm}
                          </td>
                          <td style={styles.tableCell}>{report.full_name}</td>
                          <td style={styles.tableCell}>
                            <div style={{ fontSize: '12px' }}>
                              <div>{report.region}</div>
                              <div style={{ color: '#6B7280' }}>{report.distrito}</div>
                            </div>
                          </td>
                          <td style={styles.tableCell}>
                            {report.start_time ? new Date(report.start_time).toLocaleDateString('es-MX') : 'N/A'}
                          </td>
                          <td style={styles.tableCell}>
                            {report.end_time ? new Date(report.end_time).toLocaleDateString('es-MX') : 'N/A'}
                          </td>
                          <td style={styles.tableCell}>
                            <span style={{
                              ...styles.statusBadge,
                              backgroundColor: report.status === 'completed' ? '#DCFCE7' :
                                report.status === 'active' ? '#DBEAFE' : '#FEF3C7',
                              color: report.status === 'completed' ? '#166534' :
                                report.status === 'active' ? '#1E40AF' : '#92400E'
                            }}>
                              {report.status === 'completed' ? 'Completado' :
                                report.status === 'active' ? 'Activo' : 'Otro'}
                            </span>
                          </td>
                          <td style={{ ...styles.tableCell, textAlign: 'center', fontWeight: 'bold' }}>
                            {report.total_segments}
                          </td>
                          <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                            {report.total_unrealizable}
                          </td>
                          <td style={styles.tableCell}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <span>⏱️</span>
                              <span>{report.total_work_minutes || 0}</span>
                              {report.lunch_minutes > 0 && (
                                <span style={{ fontSize: '10px', color: '#6B7280' }}>
                                  (+{report.lunch_minutes} alm)
                                </span>
                              )}
                            </div>
                          </td>
                          <td style={styles.tableCell}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <span>📏</span>
                              <span>{(report.daily_distance_meters || 0).toLocaleString()}</span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Paginación */}
                <div style={styles.pagination}>
                  <button
                    onClick={() => handlePageChange(previewData.page - 1)}
                    disabled={previewData.page <= 1 || previewLoading}
                    style={styles.pageButton}
                  >
                    ← Anterior
                  </button>

                  <div style={styles.pageInfo}>
                    Página {previewData.page} de {previewData.total_pages}
                    <span style={{ marginLeft: '12px', color: '#6B7280' }}>
                      ({previewData.total_records} registros totales)
                    </span>
                  </div>

                  <button
                    onClick={() => handlePageChange(previewData.page + 1)}
                    disabled={previewData.page >= previewData.total_pages || previewLoading}
                    style={styles.pageButton}
                  >
                    Siguiente →
                  </button>
                </div>

                <div style={styles.previewActions}>
                  <button
                    onClick={handleDownloadAfterPreview}
                    disabled={reportLoading}
                    style={styles.downloadPreviewButton}
                  >
                    <span>⬇️</span>
                    <span style={{ marginLeft: '8px' }}>Descargar estos {previewData.total_records} registros</span>
                  </button>
                </div>
              </div>
            )}

            {/* Mensaje cuando no hay resultados */}
            {showPreview && previewData.reports.length === 0 && !previewLoading && (
              <div style={styles.emptyState}>
                <div style={styles.emptyIcon}>🔍</div>
                <h3 style={styles.emptyTitle}>No se encontraron registros</h3>
                <p style={styles.emptyText}>
                  Intenta con diferentes filtros o deja los campos vacíos para ver todos los registros.
                </p>
              </div>
            )}

            <div style={styles.noteCard}>
              <h3 style={styles.noteTitle}>
                <span style={{ marginRight: '8px' }}>ℹ️</span>
                Instrucciones de uso
              </h3>
              <p style={styles.noteText}>
                1. <strong>Vista previa:</strong> Primero usa el botón "Vista Previa" para ver los registros<br />
                2. <strong>Filtros combinados:</strong> Puedes combinar usuario con fechas, región y distrito<br />
                3. <strong>Descarga:</strong> Una vez confirmados los resultados, descarga el CSV completo<br />
                4. <strong>Sin filtros:</strong> Deja los campos vacíos para ver todos los registros
              </p>
            </div>
          </div>
        )}

        {/* Tab 4: Close Routes */}
        {activeTab === 'close-routes' && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <span style={styles.cardIcon}>🚗</span>
              <div>
                <h2 style={styles.cardTitle}>Recorridos Activos</h2>
                <p style={styles.cardSubtitle}>Gestiona y cierra recorridos activos de técnicos</p>
              </div>
            </div>

            <form onSubmit={handleSearchActiveRoutes} style={{ marginBottom: '32px' }}>
              <div style={styles.searchContainer}>
                <input
                  type="text"
                  placeholder="Buscar por usuario (opcional - dejar vacío para ver todos)"
                  value={searchRoutesUser}
                  onChange={(e) => setSearchRoutesUser(e.target.value.toUpperCase())}
                  style={styles.searchInput}
                />
                <button
                  type="submit"
                  disabled={routesLoading}
                  style={styles.searchButton}
                >
                  {routesLoading ? (
                    <div style={styles.spinner}></div>
                  ) : (
                    <span>🔍</span>
                  )}
                  <span style={{ marginLeft: '8px' }}>Buscar</span>
                </button>
              </div>
            </form>

            {activeRoutes.length > 0 && (
              <div>
                <div style={styles.routesHeader}>
                  <div style={styles.routesCount}>
                    <span style={styles.countBadge}>{activeRoutes.length} recorrido(s) activo(s)</span>
                    {!searchRoutesUser && (
                      <button
                        onClick={handleExportRoutes}
                        disabled={exporting}
                        style={styles.exportButton}
                      >
                        {exporting ? (
                          <div style={{ ...styles.spinner, width: '16px', height: '16px' }}></div>
                        ) : (
                          <span>📥</span>
                        )}
                        <span style={{ marginLeft: '6px' }}>Exportar CSV</span>
                      </button>
                    )}
                  </div>
                </div>

                <div style={styles.tableContainer}>
                  <table style={styles.table}>
                    <thead>
                      <tr style={styles.tableHeader}>
                        <th style={styles.tableHeaderCell}>ID</th>
                        <th style={styles.tableHeaderCell}>Usuario</th>
                        <th style={styles.tableHeaderCell}>Nombre</th>
                        <th style={styles.tableHeaderCell}>Ubicación</th>
                        <th style={styles.tableHeaderCell}>Inicio</th>
                        <th style={styles.tableHeaderCell}>Duración</th>
                        <th style={styles.tableHeaderCell}>Distancia</th>
                        <th style={styles.tableHeaderCell}>Estado</th>
                        <th style={styles.tableHeaderCell}>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activeRoutes.map((route, i) => (
                        <tr key={route.id} style={{
                          ...styles.tableRow,
                          backgroundColor: i % 2 === 0 ? 'white' : '#F9FAFB'
                        }}>
                          <td style={styles.tableCell}>{route.id}</td>
                          <td style={{ ...styles.tableCell, fontWeight: 'bold', color: '#2563EB' }}>
                            {route.usuario_ffm}
                          </td>
                          <td style={styles.tableCell}>{route.full_name}</td>
                          <td style={styles.tableCell}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <span>📍</span>
                              <span>{route.region} / {route.distrito}</span>
                            </div>
                          </td>
                          <td style={styles.tableCell}>
                            {new Date(route.start_time).toLocaleString('es-MX')}
                          </td>
                          <td style={styles.tableCell}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <span>⏰</span>
                              <span style={{ fontWeight: 'bold', color: '#DC2626' }}>
                                {route.horas_activas}h
                              </span>
                            </div>
                          </td>
                          <td style={styles.tableCell}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <span>📏</span>
                              <span>{route.approximate_distance_meters.toLocaleString()} m</span>
                            </div>
                          </td>
                          <td style={styles.tableCell}>
                            <div style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              padding: '4px 8px',
                              borderRadius: '12px',
                              fontSize: '12px',
                              fontWeight: '600',
                              backgroundColor: route.status === 'active' ? '#D1FAE5' : '#E5E7EB',
                              color: route.status === 'active' ? '#065F46' : '#374151'
                            }}>
                              {route.status === 'active' ? '🟢 Activo' : '⚪ Completado'}
                            </div>
                          </td>
                          <td style={styles.tableCell}>
                            {route.status === 'active' ? (
                              <button
                                onClick={() => handleCloseRoute(route.id, route.usuario_ffm)}
                                style={styles.closeRouteButton}
                              >
                                <span>❌</span>
                                <span style={{ marginLeft: '6px' }}>Cerrar</span>
                              </button>
                            ) : (
                              <button
                                onClick={() => handleReactivateRoute(route.id, route.usuario_ffm)}
                                style={{
                                  ...styles.closeRouteButton,
                                  backgroundColor: '#EFF6FF',
                                  borderColor: '#3B82F6',
                                  color: '#2563EB'
                                }}
                              >
                                <span>🔄</span>
                                <span style={{ marginLeft: '6px' }}>Reactivar</span>
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {activeRoutes.length === 0 && !routesLoading && (
              <div style={styles.emptyState}>
                <div style={styles.emptyIcon}>✅</div>
                <h3 style={styles.emptyTitle}>
                  {searchRoutesUser
                    ? `No hay recorridos activos para ${searchRoutesUser}`
                    : 'No hay recorridos activos'}
                </h3>
                <p style={styles.emptyText}>
                  {searchRoutesUser
                    ? 'Asegúrate de que el usuario FFM sea correcto.'
                    : 'Todos los recorridos están cerrados correctamente.'}
                </p>
              </div>
            )}
          </div>
        )}

        {/* Tab: Auditoría de Horarios (Tiempos Alterados) */}
        {activeTab === 'time-audit' && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <span style={styles.cardIcon}>⏰</span>
              <div>
                <h2 style={styles.cardTitle}>Auditoría de Horarios Alterados</h2>
                <p style={styles.cardSubtitle}>Identifica técnicos con el reloj del celular alterado (Hora celular posterior a la del servidor)</p>
              </div>
            </div>

            <form onSubmit={fetchTimeAuditData} style={{ ...styles.filterGrid, marginBottom: '24px' }}>
              <div>
                <label style={styles.formLabel}>Región</label>
                <select
                  style={styles.formInput}
                  value={timeAuditFilters.region}
                  onChange={(e) => setTimeAuditFilters({ ...timeAuditFilters, region: e.target.value.toUpperCase(), distrito: '', empresa: '' })}
                >
                  <option value="">-- Seleccionar Región --</option>
                  {auditRegionOptions.map(r => (
                    <option key={r} value={r}>{r}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.formLabel}>Distrito</label>
                <select
                  style={styles.formInput}
                  value={timeAuditFilters.distrito}
                  onChange={(e) => setTimeAuditFilters({ ...timeAuditFilters, distrito: e.target.value.toUpperCase(), empresa: '' })}
                >
                  <option value="">-- Seleccionar Distrito --</option>
                  {auditDistritoOptions.map(d => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.formLabel}>Proveedor (Empresa)</label>
                <select
                  style={styles.formInput}
                  value={timeAuditFilters.empresa}
                  onChange={(e) => setTimeAuditFilters({ ...timeAuditFilters, empresa: e.target.value.toUpperCase() })}
                >
                  <option value="">-- Seleccionar Empresa --</option>
                  {auditEmpresaOptions.map(emp => (
                    <option key={emp} value={emp}>{emp}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.formLabel}>Planta</label>
                <select
                  style={{
                    ...styles.formInput,
                    backgroundColor: isPlantaFixed ? '#F1F5F9' : 'white',
                    cursor: isPlantaFixed ? 'not-allowed' : 'default',
                    color: isPlantaFixed ? '#475569' : '#1E293B',
                    fontWeight: isPlantaFixed ? 'bold' : 'normal'
                  }}
                  value={isPlantaFixed ? (user?.tipo_planta || 'PE') : (timeAuditFilters.tipo_planta || '')}
                  onChange={(e) => {
                    if (!isPlantaFixed) {
                      setTimeAuditFilters({ ...timeAuditFilters, tipo_planta: e.target.value });
                    }
                  }}
                  disabled={isPlantaFixed}
                >
                  {!isPlantaFixed && <option value="">-- Todas las Plantas --</option>}
                  {(!isPlantaFixed || user?.tipo_planta === 'PI') && <option value="PI">Planta Interna (PI)</option>}
                  {(!isPlantaFixed || user?.tipo_planta === 'PE') && <option value="PE">Planta Externa (PE)</option>}
                </select>
                {isPlantaFixed && (
                  <small style={{ color: '#64748B', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                    🔒 Fijado a Planta {user?.tipo_planta === 'PE' ? 'Externa (PE)' : 'Interna (PI)'} por tu perfil
                  </small>
                )}
              </div>
              <div>
                <label style={styles.formLabel}>Usuario FFM</label>
                <input
                  style={styles.formInput}
                  type="text"
                  placeholder="Ej: FFM123"
                  value={timeAuditFilters.usuario_ffm}
                  onChange={(e) => handleTimeAuditUserChange(e.target.value)}
                  list="audit-users-list"
                />
                <datalist id="audit-users-list">
                  {userSuggestions.map(usr => (
                    <option key={usr.id} value={usr.usuario_ffm}>{usr.full_name} ({usr.empresa || 'N/A'})</option>
                  ))}
                </datalist>
              </div>
              <div>
                <label style={styles.formLabel}>Fecha de Inicio</label>
                <input
                  style={styles.formInput}
                  type="date"
                  value={timeAuditFilters.fecha_inicio}
                  onChange={(e) => setTimeAuditFilters({ ...timeAuditFilters, fecha_inicio: e.target.value })}
                />
              </div>
              <div>
                <label style={styles.formLabel}>Fecha de Fin</label>
                <input
                  style={styles.formInput}
                  type="date"
                  value={timeAuditFilters.fecha_fin}
                  onChange={(e) => setTimeAuditFilters({ ...timeAuditFilters, fecha_fin: e.target.value })}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'stretch', gridColumn: '1 / -1', gap: '16px', marginTop: '8px' }}>
                <button
                  type="submit"
                  disabled={timeAuditLoading}
                  style={{
                    padding: '12px 24px',
                    borderRadius: '10px',
                    border: '1px solid #1E293B',
                    backgroundColor: '#1E293B',
                    color: '#FFFFFF',
                    fontSize: '15px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    flex: 1,
                    transition: 'all 0.2s ease',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                  }}
                >
                  {timeAuditLoading ? (
                    <>
                      <span>🔄</span> Cargando...
                    </>
                  ) : (
                    <>
                      <span>🔍</span> Consultar Auditoría
                    </>
                  )}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setTimeAuditFilters({
                      region: '',
                      distrito: '',
                      empresa: '',
                      usuario_ffm: '',
                      tipo_planta: isPEUser ? 'PE' : '',
                      fecha_inicio: (() => {
                        const d = new Date();
                        d.setDate(d.getDate() - 7);
                        return d.toISOString().split('T')[0];
                      })(),
                      fecha_fin: new Date().toISOString().split('T')[0]
                    });
                    setUserSuggestions([]);
                  }}
                  style={{
                    padding: '12px 24px',
                    borderRadius: '10px',
                    border: '1px solid #CBD5E1',
                    backgroundColor: '#F8FAFC',
                    color: '#475569',
                    fontSize: '15px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 1,
                    transition: 'all 0.2s ease',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                  }}
                >
                  Limpiar Filtros
                </button>
              </div>
            </form>

            {timeAuditLoading && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '64px 0', gap: '16px' }}>
                <div style={{ fontSize: '32px' }}>🔄</div>
                <p style={{ color: '#64748B', fontWeight: '500' }}>Analizando marcas de tiempo y calculando desvíos en el servidor...</p>
              </div>
            )}

            {!timeAuditLoading && timeAuditData && (
              <div>
                {/* KPIs */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '24px' }}>
                  <div style={{ padding: '20px', borderRadius: '12px', backgroundColor: '#FEF2F2', border: '1px solid #FEE2E2', display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ fontSize: '28px', backgroundColor: '#FEE2E2', width: '56px', height: '56px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>👥</div>
                    <div>
                      <div style={{ fontSize: '14px', color: '#EF4444', fontWeight: '600' }}>Técnicos Sospechosos</div>
                      <div style={{ fontSize: '24px', fontWeight: '700', color: '#991B1B' }}>{timeAuditData.summary.total_tecnicos_afectados}</div>
                    </div>
                  </div>
                  <div style={{ padding: '20px', borderRadius: '12px', backgroundColor: '#FFF5F5', border: '1px solid #FED7D7', display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ fontSize: '28px', backgroundColor: '#FED7D7', width: '56px', height: '56px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>🚨</div>
                    <div>
                      <div style={{ fontSize: '14px', color: '#E53E3E', fontWeight: '600' }}>Peor Desfase</div>
                      <div style={{ fontSize: '24px', fontWeight: '700', color: '#C53030' }}>
                        {timeAuditData.summary.peor_desfase !== 0 ? (() => {
                          const valAbs = Math.abs(timeAuditData.summary.peor_desfase);
                          return valAbs >= 60 
                            ? `${Math.floor(valAbs / 60)}h${Math.round(valAbs % 60)}m` 
                            : `${Math.round(valAbs)}m`;
                        })() : '0m'}
                      </div>
                    </div>
                  </div>
                  <div style={{ padding: '20px', borderRadius: '12px', backgroundColor: '#FFFDF5', border: '1px solid #FEF3C7', display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ fontSize: '28px', backgroundColor: '#FEF3C7', width: '56px', height: '56px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>📍</div>
                    <div>
                      <div style={{ fontSize: '14px', color: '#D97706', fontWeight: '600' }}>Segmentos Afectados</div>
                      <div style={{ fontSize: '24px', fontWeight: '700', color: '#92400E' }}>{timeAuditData.summary.total_segmentos_afectados}</div>
                    </div>
                  </div>
                  <div style={{ padding: '20px', borderRadius: '12px', backgroundColor: '#F8FAFC', border: '1px solid #E2E8F0', display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ fontSize: '28px', backgroundColor: '#E2E8F0', width: '56px', height: '56px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>📊</div>
                    <div>
                      <div style={{ fontSize: '14px', color: '#64748B', fontWeight: '600' }}>Promedio Desfase</div>
                      <div style={{ fontSize: '24px', fontWeight: '700', color: '#334155' }}>
                        {Math.abs(Math.round(timeAuditData.summary.promedio_desfase))} min
                      </div>
                    </div>
                  </div>
                </div>

                {timeAuditData.technicians.length === 0 ? (
                  <div style={{ ...styles.emptyState, padding: '48px' }}>
                    <div style={styles.emptyIcon}>🎉</div>
                    <h3 style={styles.emptyTitle}>¡Sin marcas de tiempo sospechosas!</h3>
                    <p style={styles.emptyText}>Ninguno de los técnicos en el rango de búsqueda tiene discrepancias horarias negativas.</p>
                  </div>
                ) : (
                  <div>
                    {/* Visual Charts: SVG / CSS */}
                    <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '24px', marginBottom: '32px' }}>
                      {/* Chart 1: Peor Desfase (Máximo en 1 segmento) */}
                      <div style={{ border: '1px solid #E2E8F0', borderRadius: '12px', padding: '20px', backgroundColor: 'white' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '600', color: '#1E293B', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span>🔥</span> Peor Desfase Individual por Técnico (Máx en un Segmento)
                        </h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                          {timeAuditData.technicians.slice(0, 5).map((tech) => {
                            const valAbs = Math.abs(tech.desfase_maximo);
                            const maxValGlobal = Math.max(...timeAuditData.technicians.map(t => Math.abs(t.desfase_maximo))) || 1;
                            const percentage = Math.min(100, (valAbs / maxValGlobal) * 100);
                            return (
                              <div key={tech.usuario_ffm}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '4px' }}>
                                  <span style={{ fontWeight: '500', color: '#334155' }}>
                                    {tech.full_name} ({tech.usuario_ffm})
                                  </span>
                                  <span style={{ fontWeight: '600', color: '#DC2626' }}>
                                    {valAbs >= 60 ? `${Math.floor(valAbs / 60)}h${Math.round(valAbs % 60)}m` : `${Math.round(valAbs)}m`} desfasado
                                  </span>
                                </div>
                                <div style={{ width: '100%', height: '10px', backgroundColor: '#F1F5F9', borderRadius: '5px', overflow: 'hidden' }}>
                                  <div style={{ width: `${percentage}%`, height: '100%', backgroundColor: '#EF4444', borderRadius: '5px', transition: 'width 0.5s ease-in-out' }} />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      {/* Chart 2: Total Segmentos Afectados */}
                      <div style={{ border: '1px solid #E2E8F0', borderRadius: '12px', padding: '20px', backgroundColor: 'white' }}>
                        <h3 style={{ fontSize: '15px', fontWeight: '600', color: '#1E293B', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span>📊</span> Número de Segmentos con Malas Prácticas
                        </h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                          {[...timeAuditData.technicians].sort((a,b) => b.segmentos_afectados - a.segmentos_afectados).slice(0, 5).map((tech) => {
                            const val = tech.segmentos_afectados;
                            const maxValGlobal = Math.max(...timeAuditData.technicians.map(t => t.segmentos_afectados)) || 1;
                            const percentage = (val / maxValGlobal) * 100;
                            return (
                              <div key={tech.usuario_ffm}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '4px' }}>
                                  <span style={{ fontWeight: '500', color: '#334155' }}>
                                    {tech.full_name} ({tech.usuario_ffm})
                                  </span>
                                  <span style={{ fontWeight: '600', color: '#F59E0B' }}>
                                    {val} marcas afectadas
                                  </span>
                                </div>
                                <div style={{ width: '100%', height: '10px', backgroundColor: '#F1F5F9', borderRadius: '5px', overflow: 'hidden' }}>
                                  <div style={{ width: `${percentage}%`, height: '100%', backgroundColor: '#F59E0B', borderRadius: '5px', transition: 'width 0.5s ease-in-out' }} />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>

                    {/* Heatmap Grid */}
                    <div style={{ border: '1px solid #E2E8F0', borderRadius: '12px', padding: '20px', backgroundColor: 'white', marginBottom: '32px', overflowX: 'auto' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '600', color: '#1E293B', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span>🗺️</span> Mapa de Calor: Técnico vs Fecha (Máximo Desfase Diario)
                      </h3>
                      <p style={{ fontSize: '13px', color: '#64748B', marginBottom: '16px' }}>
                        El nivel de rojo indica el **desfase máximo individual** detectado en un segmento ese día.
                      </p>
                      
                      {timeAuditData.heatmap.dates.length === 0 ? (
                        <div style={{ padding: '24px', textAlign: 'center', color: '#64748B' }}>No hay datos suficientes para el mapa de calor</div>
                      ) : (
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                          <thead>
                            <tr>
                              <th style={{ padding: '8px', textAlign: 'left', borderBottom: '2px solid #E2E8F0', color: '#475569', fontWeight: '600', minWidth: '200px' }}>Técnico</th>
                              {timeAuditData.heatmap.dates.map(date => (
                                <th key={date} style={{ padding: '8px', textAlign: 'center', borderBottom: '2px solid #E2E8F0', color: '#475569', fontWeight: '600', minWidth: '70px' }}>
                                  {date.split('/')[0]}/{date.split('/')[1]}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {timeAuditData.heatmap.grid.map(row => (
                              <tr key={row.usuario_ffm} style={{ borderBottom: '1px solid #F1F5F9' }}>
                                <td style={{ padding: '8px', textAlign: 'left', fontWeight: '500', color: '#334155' }}>
                                  <div style={{ fontWeight: '600' }}>{row.full_name}</div>
                                  <div style={{ fontSize: '10px', color: '#64748B' }}>{row.usuario_ffm} • {row.empresa} • {row.distrito}</div>
                                </td>
                                {timeAuditData.heatmap.dates.map(date => {
                                  const valData = row.values[date] || { max: 0, sum: 0 };
                                  const maxVal = valData.max || 0;
                                  const sumVal = valData.sum || 0;
                                  const valAbs = Math.abs(maxVal);
                                  
                                  let bg = 'transparent';
                                  let textCol = '#64748B';
                                  let bold = 'normal';
                                  
                                  if (valAbs >= 15) {
                                    bold = '600';
                                    if (valAbs < 60) {
                                      bg = '#FCA5A5';
                                      textCol = '#7F1D1D';
                                    } else if (valAbs < 180) {
                                      bg = '#F87171';
                                      textCol = '#FFF';
                                    } else {
                                      bg = '#EF4444';
                                      textCol = '#FFF';
                                    }
                                  }
                                  
                                  return (
                                    <td
                                      key={date}
                                      title={`${row.full_name} (${row.usuario_ffm}) - ${date}: Máx desfase: ${maxVal !== 0 ? `${maxVal} min` : 'Sin'}`}
                                      style={{
                                        padding: '8px',
                                        textAlign: 'center',
                                        backgroundColor: bg,
                                        color: textCol,
                                        fontWeight: bold,
                                        border: '1px solid #E2E8F0',
                                        borderRadius: '4px'
                                      }}
                                    >
                                      {valAbs >= 15 ? `${Math.round(maxVal)}m` : '-'}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>

                    {/* Grid table */}
                    <div style={{ border: '1px solid #E2E8F0', borderRadius: '12px', padding: '20px', backgroundColor: 'white' }}>
                      <h3 style={{ fontSize: '15px', fontWeight: '600', color: '#1E293B', marginBottom: '16px' }}>
                        Detalle de Malas Prácticas
                      </h3>
                      <div style={{ overflowX: 'auto' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <thead>
                            <tr style={{ backgroundColor: '#F8FAFC', borderBottom: '2px solid #E2E8F0' }}>
                              <th style={{ ...styles.tableHeader, cursor: 'pointer' }} onClick={() => {
                                setTimeAuditSortOrder(timeAuditSortField === 'full_name' ? (timeAuditSortOrder === 'asc' ? 'desc' : 'asc') : 'asc');
                                setTimeAuditSortField('full_name');
                              }}>
                                Técnico {timeAuditSortField === 'full_name' ? (timeAuditSortOrder === 'asc' ? '▲' : '▼') : ''}
                              </th>
                              <th style={styles.tableHeader}>Proveedor / Ubicación</th>
                              <th style={{ ...styles.tableHeader, textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                                setTimeAuditSortOrder(timeAuditSortField === 'segmentos_afectados' ? (timeAuditSortOrder === 'asc' ? 'desc' : 'asc') : 'desc');
                                setTimeAuditSortField('segmentos_afectados');
                              }}>
                                Segmentos Afectados {timeAuditSortField === 'segmentos_afectados' ? (timeAuditSortOrder === 'asc' ? '▲' : '▼') : ''}
                              </th>
                              <th style={{ ...styles.tableHeader, textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                                setTimeAuditSortOrder(timeAuditSortField === 'desfase_maximo' ? (timeAuditSortOrder === 'asc' ? 'desc' : 'asc') : 'asc');
                                setTimeAuditSortField('desfase_maximo');
                              }}>
                                Desfase Máximo {timeAuditSortField === 'desfase_maximo' ? (timeAuditSortOrder === 'asc' ? '▲' : '▼') : ''}
                              </th>
                              <th style={{ ...styles.tableHeader, textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                                setTimeAuditSortOrder(timeAuditSortField === 'desfase_promedio' ? (timeAuditSortOrder === 'asc' ? 'desc' : 'asc') : 'asc');
                                setTimeAuditSortField('desfase_promedio');
                              }}>
                                Desfase Promedio {timeAuditSortField === 'desfase_promedio' ? (timeAuditSortOrder === 'asc' ? '▲' : '▼') : ''}
                              </th>
                              <th style={{ ...styles.tableHeader, textAlign: 'center', cursor: 'pointer' }} onClick={() => {
                                setTimeAuditSortOrder(timeAuditSortField === 'desfase_total' ? (timeAuditSortOrder === 'asc' ? 'desc' : 'asc') : 'asc');
                                setTimeAuditSortField('desfase_total');
                              }}>
                                Desfase Total (Suma) {timeAuditSortField === 'desfase_total' ? (timeAuditSortOrder === 'asc' ? '▲' : '▼') : ''}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {[...timeAuditData.technicians]
                              .sort((a, b) => {
                                let valA = a[timeAuditSortField];
                                let valB = b[timeAuditSortField];
                                if (typeof valA === 'string') {
                                  return timeAuditSortOrder === 'asc'
                                    ? valA.localeCompare(valB)
                                    : valB.localeCompare(valA);
                                } else {
                                  return timeAuditSortOrder === 'asc'
                                    ? valA - valB
                                    : valB - valA;
                                }
                              })
                              .map(tech => (
                                <tr key={tech.usuario_ffm} style={{ borderBottom: '1px solid #F1F5F9' }}>
                                  <td style={{ ...styles.tableCell, fontWeight: '600', color: '#1E293B' }}>
                                    {tech.full_name}
                                    <div style={{ fontSize: '11px', color: '#64748B', fontWeight: '400' }}>
                                      Usuario: {tech.usuario_ffm}
                                    </div>
                                  </td>
                                  <td style={styles.tableCell}>
                                    <div style={{ fontSize: '13px', color: '#334155' }}>
                                      <strong>Prov:</strong> {tech.empresa}
                                    </div>
                                    <div style={{ fontSize: '11px', color: '#64748B' }}>
                                      {tech.region} • {tech.distrito}
                                    </div>
                                  </td>
                                  <td style={{ ...styles.tableCell, textAlign: 'center', fontWeight: '600', color: '#F59E0B' }}>
                                    {tech.segmentos_afectados}
                                  </td>
                                  <td style={{ ...styles.tableCell, textAlign: 'center', fontWeight: '700', color: '#EF4444' }}>
                                    {Math.abs(tech.desfase_maximo)} min
                                  </td>
                                  <td style={{ ...styles.tableCell, textAlign: 'center', color: '#DC2626' }}>
                                    {Math.abs(tech.desfase_promedio)} min
                                  </td>
                                  <td style={{ ...styles.tableCell, textAlign: 'center', color: '#991B1B' }}>
                                    {Math.abs(tech.desfase_total)} min
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* Tab 5: Dashboard Técnicos */}
        {activeTab === 'dashboard' && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <span style={styles.cardIcon}>📈</span>
              <div>
                <h2 style={styles.cardTitle}>Dashboard de Técnicos</h2>
                <p style={styles.cardSubtitle}>Métricas y rendimiento de los técnicos</p>
              </div>
            </div>

            <form onSubmit={fetchDashboardData} style={{ ...styles.filterGrid, marginBottom: '24px' }}>
              <div>
                <label style={styles.formLabel}>Región</label>
                {isPEUser ? (
                  <input
                    style={styles.formInput}
                    type="text"
                    placeholder="Región PE (Campo libre)..."
                    value={dashboardFilters.region}
                    onChange={(e) => setDashboardFilters({ ...dashboardFilters, region: e.target.value.toUpperCase() })}
                  />
                ) : user?.role === 'district_manager' ? (
                  <input
                    style={{ ...styles.formInput, backgroundColor: '#f1f5f9', cursor: 'not-allowed', color: '#475569', fontWeight: 'bold' }}
                    type="text"
                    value={user.region || 'Región Asignada'}
                    disabled
                  />
                ) : (
                  <select
                    style={styles.formInput}
                    value={dashboardFilters.region}
                    onChange={(e) => setDashboardFilters({ ...dashboardFilters, region: e.target.value.toUpperCase(), distrito: '', empresa: '' })}
                  >
                    <option value="">-- Seleccionar Región --</option>
                    {dashboardRegionOptions.map(r => (
                      <option key={r} value={r}>{r}</option>
                    ))}
                  </select>
                )}
              </div>
              <div>
                <label style={styles.formLabel}>Distrito</label>
                {isPEUser ? (
                  <input
                    style={styles.formInput}
                    type="text"
                    placeholder="Distrito PE (Campo libre)..."
                    value={dashboardFilters.distrito}
                    onChange={(e) => setDashboardFilters({ ...dashboardFilters, distrito: e.target.value.toUpperCase() })}
                  />
                ) : user?.role === 'district_manager' ? (
                  <input
                    style={{ ...styles.formInput, backgroundColor: '#f1f5f9', cursor: 'not-allowed', color: '#475569', fontWeight: 'bold' }}
                    type="text"
                    value={user.distrito || 'Distrito Asignado'}
                    disabled
                  />
                ) : (
                  <select
                    style={styles.formInput}
                    value={dashboardFilters.distrito}
                    onChange={(e) => setDashboardFilters({ ...dashboardFilters, distrito: e.target.value.toUpperCase(), empresa: '' })}
                  >
                    <option value="">-- Seleccionar Distrito --</option>
                    {dashboardDistritoOptions.map(d => (
                      <option key={d} value={d}>{d}</option>
                    ))}
                  </select>
                )}
              </div>
              <div>
                <label style={styles.formLabel}>Proveedor (Empresa)</label>
                {isPEUser ? (
                  <input
                    style={styles.formInput}
                    type="text"
                    placeholder="Proveedor PE (Campo libre)..."
                    value={dashboardFilters.empresa}
                    onChange={(e) => setDashboardFilters({ ...dashboardFilters, empresa: e.target.value.toUpperCase() })}
                  />
                ) : (
                  <select
                    style={styles.formInput}
                    value={dashboardFilters.empresa}
                    onChange={(e) => setDashboardFilters({ ...dashboardFilters, empresa: e.target.value.toUpperCase() })}
                  >
                    <option value="">-- Seleccionar Empresa --</option>
                    {dashboardEmpresaOptions.map(emp => (
                      <option key={emp} value={emp}>{emp}</option>
                    ))}
                  </select>
                )}
              </div>
              <div>
                <label style={styles.formLabel}>Usuario FFM</label>
                <input
                  style={styles.formInput}
                  type="text"
                  placeholder="Ej: FFM123"
                  value={dashboardFilters.usuario_ffm}
                  onChange={(e) => setDashboardFilters({ ...dashboardFilters, usuario_ffm: e.target.value.toUpperCase() })}
                />
              </div>
              <div>
                <label style={styles.formLabel}>Nombre del Técnico</label>
                <input
                  style={styles.formInput}
                  type="text"
                  placeholder="Ej: FABIAN CARMONA"
                  value={dashboardFilters.nombre_tecnico}
                  onChange={(e) => setDashboardFilters({ ...dashboardFilters, nombre_tecnico: e.target.value })}
                />
              </div>
              <div style={{ display: 'flex', gap: '16px', gridColumn: 'span 2' }}>
                <div style={{ flex: 1 }}>
                  <label style={styles.formLabel}>Fecha de Inicio</label>
                  <input
                    style={styles.formInput}
                    type="date"
                    value={dashboardFilters.fecha_inicio}
                    onChange={(e) => setDashboardFilters({ ...dashboardFilters, fecha_inicio: e.target.value })}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={styles.formLabel}>Fecha de Fin</label>
                  <input
                    style={styles.formInput}
                    type="date"
                    value={dashboardFilters.fecha_fin}
                    onChange={(e) => setDashboardFilters({ ...dashboardFilters, fecha_fin: e.target.value })}
                  />
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gridColumn: '1 / -1' }}>
                <button
                  type="submit"
                  disabled={dashboardLoading}
                  style={styles.primaryButton}
                >
                  {dashboardLoading ? <div style={styles.spinner}></div> : 'Aplicar Filtros / Buscar'}
                </button>
              </div>
            </form>

            {dashboardData && (
              <div>
                {/* Nuevas Tarjetas Mejoradas */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                  gap: '20px',
                  marginBottom: '32px'
                }}>
                  {/* Tarjeta 1: Recorridos y Segmentos */}
                  <div style={{ background: 'linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #BFDBFE', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h3 style={{ margin: 0, color: '#1E3A8A', fontSize: '1.2rem', fontWeight: 'bold' }}>📍 Productividad General</h3>
                      <span style={{ fontSize: '24px', background: 'white', padding: '8px', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>📈</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(59, 130, 246, 0.2)', paddingBottom: '10px' }}>
                      <span style={{ color: '#3B82F6', fontWeight: '600' }}>Recorridos Finalizados</span>
                      <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#1D4ED8' }}>{dashboardData.summary.total_recorridos}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(59, 130, 246, 0.2)', paddingBottom: '10px' }}>
                      <span style={{ color: '#3B82F6', fontWeight: '600' }}>Segmentos Ejecutados</span>
                      <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#1D4ED8' }}>{dashboardData.summary.total_segmentos}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: '#EAB308', fontWeight: '600' }}>Puntos No Realizables</span>
                      <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#CA8A04' }}>{dashboardData.summary.total_no_realizables}</span>
                    </div>
                  </div>

                  {/* Tarjeta 2: Tiempo de Adherencia (Total vs Efectivo) */}
                  <div style={{ background: 'linear-gradient(135deg, #F5F3FF 0%, #EDE9FE 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #DDD6FE', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h3 style={{ margin: 0, color: '#4C1D95', fontSize: '1.2rem', fontWeight: 'bold' }}>⏱️ Rendimiento de Adherencia</h3>
                      <span style={{ fontSize: '24px', background: 'white', padding: '8px', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>⏳</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(139, 92, 246, 0.2)', paddingBottom: '10px' }}>
                      <span style={{ color: '#6D28D9', fontWeight: '600' }}>Tiempo Trabajado (Bruto)</span>
                      <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#5B21B6' }}>
                        {Math.floor(dashboardData.summary.total_tiempo_trabajado_min / 60)}h {dashboardData.summary.total_tiempo_trabajado_min % 60}m
                      </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'white', padding: '10px 15px', borderRadius: '10px', boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)' }}>
                      <span style={{ color: '#8B5CF6', fontWeight: 'bold', fontSize: '1.1rem' }}>Tiempo Operativo Efectivo</span>
                      <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#6D28D9' }}>
                        {Math.floor(dashboardData.summary.total_tiempo_efectivo_min / 60)}h {dashboardData.summary.total_tiempo_efectivo_min % 60}m
                      </span>
                    </div>
                    <div style={{ fontSize: '0.85rem', color: '#7C3AED', textAlign: 'center', fontStyle: 'italic' }}>
                      {dashboardData.summary.total_tiempo_trabajado_min > dashboardData.summary.total_tiempo_efectivo_min
                        ? `Se aplicaron penalizaciones equivalentes a ${Math.floor((dashboardData.summary.total_tiempo_trabajado_min - dashboardData.summary.total_tiempo_efectivo_min) / 60)}h ${(dashboardData.summary.total_tiempo_trabajado_min - dashboardData.summary.total_tiempo_efectivo_min) % 60}m`
                        : "No se aplicaron descuentos de tiempo en este periodo."}
                    </div>
                  </div>

                  {/* Tarjeta 3: Distancia Total vs Descontada */}
                  <div style={{ background: 'linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)', padding: '24px', borderRadius: '16px', border: '1px solid #FDE047', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h3 style={{ margin: 0, color: '#92400E', fontSize: '1.2rem', fontWeight: 'bold' }}>📏 Rendimiento de Metraje</h3>
                      <span style={{ fontSize: '24px', background: 'white', padding: '8px', borderRadius: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>🏃</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(217, 119, 6, 0.2)', paddingBottom: '10px' }}>
                      <span style={{ color: '#B45309', fontWeight: '600' }}>Distancia Total Marcada</span>
                      <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#92400E' }}>
                        {(dashboardData.summary.total_distancia_total_m / 1000).toFixed(3)} km
                      </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'white', padding: '10px 15px', borderRadius: '10px', boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)' }}>
                      <span style={{ color: '#D97706', fontWeight: 'bold', fontSize: '1.1rem' }}>Distancia Efectiva para Pago</span>
                      <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#B45309' }}>
                        {(dashboardData.summary.total_distancia_efectiva_m / 1000).toFixed(3)} km
                      </span>
                    </div>
                    <div style={{ fontSize: '0.85rem', color: '#D97706', textAlign: 'center', fontStyle: 'italic' }}>
                      {dashboardData.summary.total_distancia_total_m > dashboardData.summary.total_distancia_efectiva_m
                        ? `Se descontaron ${((dashboardData.summary.total_distancia_total_m - dashboardData.summary.total_distancia_efectiva_m) / 1000).toFixed(3)} km por distancias atípicas (> 150m)`
                        : "No hubo penalizaciones de tiradas largas en este periodo."}
                    </div>
                  </div>
                </div>

                {/* 🚨 PANEL DE PENALIZACIONES - MISMA VISTA QUE VE EL TÉCNICO */}
                {dashboardData && searchResults && dashboardData.technicians && dashboardData.technicians.length > 0 && (
                  <div style={{ marginBottom: '32px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                    <AdminPenalizacionesPanel
                      reportData={dashboardData.technicians[0]}
                      usuarioFFM={searchResults.usuario_ffm}
                      apiUrl={API_URL}
                      token={localStorage.getItem('auth_token') || localStorage.getItem('control_campo_token')}
                    />
                  </div>
                )}

                {/* Tabla de Técnicos (Detalle Ampliado) */}
                <div style={{ ...styles.tableContainer, border: 'none', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', borderRadius: '12px', overflow: 'hidden' }}>
                  <div style={{ background: '#1E293B', padding: '16px 24px', color: 'white' }}>
                    <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: '600' }}>Desglose por Técnico</h3>
                  </div>
                  <table style={{ ...styles.table, margin: 0 }}>
                    <thead style={{ background: '#F8FAFC' }}>
                      <tr>
                        <th style={{ ...styles.tableHeader, color: '#475569', fontWeight: '600', padding: '16px' }}>Técnico</th>
                        <th style={{ ...styles.tableHeader, color: '#475569', fontWeight: '600' }}>Proveedor</th>
                        <th style={{ ...styles.tableHeader, color: '#475569', fontWeight: '600', textAlign: 'center' }}>Volumen</th>
                        <th style={{ ...styles.tableHeader, color: '#475569', fontWeight: '600', background: '#F5F3FF' }}>Adherencia (Total vs Efec)</th>
                        <th style={{ ...styles.tableHeader, color: '#475569', fontWeight: '600', background: '#FEF3C7' }}>Metraje (Total vs Efec)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardData.technicians.map((tech, i) => (
                        <tr key={tech.usuario_ffm} style={{ backgroundColor: i % 2 === 0 ? 'white' : '#F8FAFC', transition: 'background-color 0.2s' }}>
                          <td style={{ ...styles.tableCell, padding: '16px' }}>
                            <div style={{ fontWeight: 'bold', color: '#0F172A', fontSize: '1rem' }}>{tech.full_name}</div>
                            <div style={{ fontSize: '0.85rem', color: '#64748B', display: 'flex', gap: '8px', alignItems: 'center', marginTop: '4px' }}>
                              <span style={{ background: '#E2E8F0', padding: '2px 6px', borderRadius: '4px', color: '#334155' }}>{tech.usuario_ffm}</span>
                              <span>{tech.region} / {tech.distrito}</span>
                            </div>
                          </td>
                          <td style={{ ...styles.tableCell, color: '#475569', fontWeight: '500' }}>{tech.empresa}</td>
                          <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                            <div style={{ fontWeight: 'bold', color: '#1D4ED8', fontSize: '1.1rem' }}>{tech.segmentos}</div>
                            <div
                              onClick={() => { setSelectedTechReports(tech); setShowReportsModal(true); }}
                              style={{
                                fontSize: '0.75rem',
                                color: '#2563EB',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                fontWeight: '500'
                              }}
                            >
                              en {tech.recorridos} ruta(s) 👁️
                            </div>
                          </td>
                          <td style={{ ...styles.tableCell, background: 'rgba(245, 243, 255, 0.5)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px', borderBottom: '1px solid #E5E7EB', paddingBottom: '4px' }}>
                              <span style={{ fontSize: '0.85rem', color: '#64748B' }}>Total:</span>
                              <span style={{ color: '#475569', fontWeight: '500' }}>{Math.floor(tech.tiempo_trabajado_min / 60)}h {tech.tiempo_trabajado_min % 60}m</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span style={{ fontSize: '0.85rem', color: '#6D28D9', fontWeight: '600' }}>Efectivo:</span>
                              <span style={{ color: '#6D28D9', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {Math.floor(tech.tiempo_efectivo_min / 60)}h {tech.tiempo_efectivo_min % 60}m
                              </span>
                            </div>
                          </td>
                          <td style={{ ...styles.tableCell, background: 'rgba(254, 243, 199, 0.5)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px', borderBottom: '1px solid #E5E7EB', paddingBottom: '4px' }}>
                              <span style={{ fontSize: '0.85rem', color: '#64748B' }}>Total:</span>
                              <span style={{ color: '#475569', fontWeight: '500' }}>{(tech.distancia_total_m / 1000).toFixed(3)} km</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span style={{ fontSize: '0.85rem', color: '#B45309', fontWeight: '600' }}>Efectivo:</span>
                              <span style={{ color: '#B45309', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                {(tech.distancia_efectiva_m / 1000).toFixed(3)} km
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {dashboardData.technicians.length === 0 && (
                        <tr>
                          <td colSpan="5" style={{ textAlign: 'center', padding: '40px', color: '#64748B' }}>
                            <div style={{ fontSize: '40px', marginBottom: '10px' }}>📊</div>
                            <div style={{ fontSize: '1.1rem', fontWeight: '500' }}>No hay datos para los filtros seleccionados</div>
                            <p style={{ marginTop: '5px' }}>Intenta cambiando el rango de fechas, región o proveedor.</p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Tab 7: RBAC Management */}
        {/* Tab: IDR Dashboard (Inspectores) */}
        {activeTab === 'idr-dashboard' && (
          <div style={styles.card}>
            <div style={{ ...styles.cardHeader, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={styles.cardIcon}>📊</span>
                <div>
                  <h2 style={styles.cardTitle}>Dashboard de Inspectores (IDR)</h2>
                  <p style={styles.cardSubtitle}>Visualización física, puntos de red aéreo/canalizado e historial de recorridos</p>
                </div>
              </div>
              {canAccess('admin:hallazgos_idr') && (
                <button
                  type="button"
                  onClick={() => setActiveTab('idr-hallazgos')}
                  style={{
                    backgroundColor: '#8B5CF6',
                    color: 'white',
                    border: 'none',
                    padding: '10px 18px',
                    borderRadius: '10px',
                    fontWeight: '600',
                    fontSize: '13px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    boxShadow: '0 4px 12px rgba(139, 92, 246, 0.3)',
                    transition: 'all 0.2s'
                  }}
                >
                  <span>📤</span>
                  <span>Cargar Hallazgos Semanales</span>
                </button>
              )}
            </div>

            {/* Filtros */}
            <form onSubmit={fetchIdrDashboardData} style={{ background: '#F8FAFC', padding: '20px', borderRadius: '12px', marginBottom: '24px', border: '1px solid #E2E8F0' }}>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', gap: '16px', marginBottom: '16px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>Región</label>
                  <select
                    value={idrFilters.region}
                    onChange={(e) => setIdrFilters({ ...idrFilters, region: e.target.value })}
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #CBD5E1', fontSize: '14px' }}
                  >
                    <option value="">Todas las Regiones</option>
                    <option value="METRO NOR PONIENTE">METRO NOR PONIENTE</option>
                    <option value="METRO SUR ORIENTE">METRO SUR ORIENTE</option>
                    <option value="OCCIDENTE">OCCIDENTE</option>
                    <option value="NOROESTE">NOROESTE</option>
                    <option value="NORESTE">NORESTE</option>
                    <option value="GOLFO">GOLFO</option>
                    <option value="SUR">SUR</option>
                  </select>
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>Distrito</label>
                  <input
                    type="text"
                    placeholder="Ej. GDL COLOMOS"
                    value={idrFilters.distrito}
                    onChange={(e) => setIdrFilters({ ...idrFilters, distrito: e.target.value.toUpperCase() })}
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #CBD5E1', fontSize: '14px' }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>Inspector (Usuario/Nombre)</label>
                  <input
                    type="text"
                    placeholder="Usuario FFM o Nombre..."
                    value={idrFilters.usuario_ffm}
                    onChange={(e) => setIdrFilters({ ...idrFilters, usuario_ffm: e.target.value })}
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #CBD5E1', fontSize: '14px' }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>Fecha Inicio</label>
                  <input
                    type="date"
                    value={idrFilters.fecha_inicio}
                    onChange={(e) => setIdrFilters({ ...idrFilters, fecha_inicio: e.target.value })}
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #CBD5E1', fontSize: '14px' }}
                  />
                </div>

                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '6px' }}>Fecha Fin</label>
                  <input
                    type="date"
                    value={idrFilters.fecha_fin}
                    onChange={(e) => setIdrFilters({ ...idrFilters, fecha_fin: e.target.value })}
                    style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #CBD5E1', fontSize: '14px' }}
                  />
                </div>

                <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
                  <button
                    type="submit"
                    disabled={idrLoading}
                    style={{ flex: 1, padding: '10px 16px', background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                  >
                    {idrLoading ? '⏳ Cargando...' : '🔍 Consultar'}
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setIdrFilters({ region: '', distrito: '', usuario_ffm: '', fecha_inicio: '', fecha_fin: '' });
                    }}
                    style={{ padding: '10px 16px', background: '#94A3B8', color: 'white', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }}
                  >
                    Limpiar
                  </button>
                </div>
              </div>
            </form>

            {/* Muestras y métricas KPI */}
            {idrData && idrData.summary && (
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(auto-fit, minmax(170px, 1fr))', gap: '16px', marginBottom: '24px' }}>
                <div style={{ background: '#EFF6FF', padding: '16px', borderRadius: '12px', border: '1px solid #BFDBFE' }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#1E40AF', display: 'block', marginBottom: '4px' }}>TOTAL RECORRIDOS</span>
                  <span style={{ fontSize: '24px', fontWeight: '700', color: '#1E3A8A' }}>{idrData.summary.total_recorridos}</span>
                </div>
                <div style={{ background: '#F0FDF4', padding: '16px', borderRadius: '12px', border: '1px solid #BBF7D0' }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#166534', display: 'block', marginBottom: '4px' }}>PUNTOS PE / PI</span>
                  <span style={{ fontSize: '24px', fontWeight: '700', color: '#14532D' }}>{idrData.summary.total_puntos}</span>
                </div>
                <div style={{ background: '#ECFDF5', padding: '16px', borderRadius: '12px', border: '1px solid #A7F3D0' }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#047857', display: 'block', marginBottom: '4px' }}>PUNTOS AÉREOS</span>
                  <span style={{ fontSize: '24px', fontWeight: '700', color: '#065F46' }}>⚡ {idrData.summary.total_aereos}</span>
                </div>
                <div style={{ background: '#F5F3FF', padding: '16px', borderRadius: '12px', border: '1px solid #DDD6FE' }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#6D28D9', display: 'block', marginBottom: '4px' }}>CANALIZADOS</span>
                  <span style={{ fontSize: '24px', fontWeight: '700', color: '#5B21B6' }}>⛖ {idrData.summary.total_canalizados}</span>
                </div>
                <div style={{ background: '#F5F3FF', padding: '16px', borderRadius: '12px', border: '1px solid #DDD6FE' }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#6D28D9', display: 'block', marginBottom: '4px' }}>TIEMPO EFECTIVO (IDR)</span>
                  <span style={{ fontSize: '20px', fontWeight: '700', color: '#5B21B6' }}>
                    {Math.floor((idrData.summary.total_tiempo_efectivo_min || 0) / 60)}h {(idrData.summary.total_tiempo_efectivo_min || 0) % 60}m
                  </span>
                  <span style={{ fontSize: '11px', color: '#64748B', display: 'block', marginTop: '2px' }}>
                    Total: {Math.floor((idrData.summary.total_tiempo_total_min || 0) / 60)}h {(idrData.summary.total_tiempo_total_min || 0) % 60}m
                  </span>
                </div>
                <div style={{ background: '#FEF3C7', padding: '16px', borderRadius: '12px', border: '1px solid #FDE68A' }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#B45309', display: 'block', marginBottom: '4px' }}>METRAJE EFECTIVO (IDR)</span>
                  <span style={{ fontSize: '20px', fontWeight: '700', color: '#92400E' }}>
                    {((idrData.summary.total_distancia_efectiva_m || 0) / 1000).toFixed(3)} km
                  </span>
                  <span style={{ fontSize: '11px', color: '#64748B', display: 'block', marginTop: '2px' }}>
                    Bruto: {((idrData.summary.total_distancia_total_m || 0) / 1000).toFixed(3)} km
                  </span>
                </div>
                <div style={{ background: '#FEF2F2', padding: '16px', borderRadius: '12px', border: '1px solid #FECACA' }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#991B1B', display: 'block', marginBottom: '4px' }}>INCIDENCIAS</span>
                  <span style={{ fontSize: '24px', fontWeight: '700', color: '#7F1D1D' }}>⚠️ {idrData.summary.total_incidencias}</span>
                </div>
                <div style={{ background: '#ECFDF5', padding: '16px', borderRadius: '12px', border: '1px solid #A7F3D0' }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#065F46', display: 'block', marginBottom: '4px' }}>EN RECORRIDO AHORA</span>
                  <span style={{ fontSize: '24px', fontWeight: '700', color: '#047857' }}>
                    🟢 {idrData.summary.inspectores_jornada_activa !== undefined ? idrData.summary.inspectores_jornada_activa : 0}
                  </span>
                  <span style={{ fontSize: '10px', color: '#059669', display: 'block', marginTop: '2px' }}>Jornada sin finalizar</span>
                </div>
                <div style={{ background: '#FFF7ED', padding: '16px', borderRadius: '12px', border: '1px solid #FFEDD5' }}>
                  <span style={{ fontSize: '12px', fontWeight: '600', color: '#C2410C', display: 'block', marginBottom: '4px' }}>TOTAL INSPECTORES</span>
                  <span style={{ fontSize: '24px', fontWeight: '700', color: '#9A3412' }}>
                    👥 {idrData.summary.total_inspectores !== undefined ? idrData.summary.total_inspectores : (idrData.technicians ? idrData.technicians.length : 0)}
                  </span>
                  <span style={{ fontSize: '10px', color: '#EA580C', display: 'block', marginTop: '2px' }}>En este periodo/filtro</span>
                </div>
              </div>
            )}

            {/* Mapa Reporte Seleccionado */}
            {selectedInspectorMapReport && (
              <div id="inspector-map-scroll-anchor" style={{ marginBottom: '24px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', background: '#1E293B', color: 'white', padding: '12px 20px', borderRadius: '12px 12px 0 0' }}>
                  <h3 style={{ margin: 0, fontSize: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    🗺️ Mapa del Recorrido de Inspector ID: {selectedInspectorMapReport.id}
                  </h3>
                  <button
                    onClick={() => setSelectedInspectorMapReport(null)}
                    style={{ background: '#EF4444', color: 'white', border: 'none', padding: '6px 16px', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}
                  >
                    Cerrar Mapa
                  </button>
                </div>
                <InspectorDashboardMap reports={[selectedInspectorMapReport]} height="550px" />
              </div>
            )}

            {/* Tabla de Desglose por Inspector (Img 1) */}
            {idrData && idrData.technicians && (
              <div>
                <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1E293B', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  👥 Desglose por Inspector ({idrData.technicians.length})
                </h3>

                <div style={{ overflowX: 'auto', borderRadius: '12px', border: '1px solid #E2E8F0' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', background: 'white' }}>
                    <thead>
                      <tr style={{ background: '#1E293B', color: 'white', textAlign: 'left' }}>
                        <th style={{ padding: '14px 16px' }}>Inspector</th>
                        <th style={{ padding: '14px 16px' }}>Región / Distrito</th>
                        <th style={{ padding: '14px 16px', textAlign: 'center' }}>Volumen Puntos</th>
                        <th style={{ padding: '14px 16px', textAlign: 'center' }}>⚡ Aéreo / ⛖ Canalizado</th>
                        <th style={{ padding: '14px 16px', textAlign: 'center' }}>Tiempo</th>
                        <th style={{ padding: '14px 16px', textAlign: 'center' }}>Metraje</th>
                        <th style={{ padding: '14px 16px', textAlign: 'center' }}>Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      {idrData.technicians.length === 0 ? (
                        <tr>
                          <td colSpan={7} style={{ padding: '30px', textAlign: 'center', color: '#64748B' }}>
                            No se encontraron inspectores con los filtros aplicados.
                          </td>
                        </tr>
                      ) : (
                        idrData.technicians.map((insp, idx) => (
                          <tr key={insp.usuario_ffm} style={{ borderBottom: '1px solid #F1F5F9', background: idx % 2 === 0 ? 'white' : '#F8FAFC' }}>
                            <td style={{ padding: '14px 16px' }}>
                              <div style={{ fontWeight: '700', color: '#1E293B' }}>{insp.full_name}</div>
                              <span style={{ fontSize: '12px', color: '#64748B', background: '#E2E8F0', padding: '2px 6px', borderRadius: '4px' }}>{insp.usuario_ffm}</span>
                            </td>
                            <td style={{ padding: '14px 16px', color: '#475569' }}>
                              <div>{insp.region}</div>
                              <span style={{ fontSize: '12px', color: '#64748B' }}>{insp.distrito}</span>
                            </td>
                            <td style={{ padding: '14px 16px', textAlign: 'center' }}>
                              <div style={{ fontWeight: '700', color: '#2563EB', fontSize: '16px' }}>{insp.puntos_totales}</div>
                              <button
                                onClick={() => {
                                  setSelectedInspectorTechReports(insp);
                                  setShowInspectorReportsModal(true);
                                }}
                                style={{ background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer', fontSize: '12px', textDecoration: 'underline', fontWeight: '600' }}
                              >
                                en {insp.recorridos} ruta(s) 👁️
                              </button>
                            </td>
                            <td style={{ padding: '14px 16px', textAlign: 'center' }}>
                              <span style={{ color: '#059669', fontWeight: '600' }}>⚡ {insp.puntos_aereos}</span>
                              <span style={{ margin: '0 6px', color: '#cbd5e1' }}>|</span>
                              <span style={{ color: '#7c3aed', fontWeight: '600' }}>⛖ {insp.puntos_canalizados}</span>
                            </td>
                            <td style={{ padding: '14px 16px', background: 'rgba(245, 243, 255, 0.5)' }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px', borderBottom: '1px solid #E5E7EB', paddingBottom: '4px' }}>
                                <span style={{ fontSize: '0.82rem', color: '#64748B' }}>Total:</span>
                                <span style={{ color: '#475569', fontWeight: '500', fontSize: '0.85rem' }}>
                                  {Math.floor((insp.tiempo_total_min || 0) / 60)}h {(insp.tiempo_total_min || 0) % 60}m
                                </span>
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ fontSize: '0.82rem', color: '#6D28D9', fontWeight: '600' }}>Efectivo:</span>
                                <span style={{ color: '#6D28D9', fontWeight: 'bold', fontSize: '1.05rem' }}>
                                  {Math.floor((insp.tiempo_efectivo_min || 0) / 60)}h {(insp.tiempo_efectivo_min || 0) % 60}m
                                </span>
                              </div>
                            </td>
                            <td style={{ padding: '14px 16px', background: 'rgba(254, 243, 199, 0.5)' }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px', borderBottom: '1px solid #E5E7EB', paddingBottom: '4px' }}>
                                <span style={{ fontSize: '0.82rem', color: '#64748B' }}>Total:</span>
                                <span style={{ color: '#475569', fontWeight: '500', fontSize: '0.85rem' }}>
                                  {(insp.distancia_total_m || 0) >= 1000 ? `${((insp.distancia_total_m || 0) / 1000).toFixed(3)} km` : `${insp.distancia_total_m || 0} m`}
                                </span>
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ fontSize: '0.82rem', color: '#B45309', fontWeight: '600' }}>Efectivo:</span>
                                <span style={{ color: '#B45309', fontWeight: 'bold', fontSize: '1.05rem' }}>
                                  {(insp.distancia_efectiva_m || 0) >= 1000 ? `${((insp.distancia_efectiva_m || 0) / 1000).toFixed(3)} km` : `${insp.distancia_efectiva_m || 0} m`}
                                </span>
                              </div>
                            </td>
                            <td style={{ padding: '14px 16px', textAlign: 'center' }}>
                              <button
                                onClick={() => {
                                  setSelectedInspectorTechReports(insp);
                                  setShowInspectorReportsModal(true);
                                }}
                                style={{ padding: '8px 14px', background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', color: 'white', border: 'none', borderRadius: '6px', fontWeight: '600', cursor: 'pointer', fontSize: '13px' }}
                              >
                                Ver Rutas 📋
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Tab: IDR Reports */}
        {activeTab === 'idr-reports' && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <span style={styles.cardIcon}>📥</span>
              <div>
                <h2 style={styles.cardTitle}>Exportar IDR</h2>
                <p style={styles.cardSubtitle}>Descarga reportes de Inspección de Red en CSV</p>
              </div>
            </div>

            {/* Two export cards side by side */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '24px' }}>

              {/* PI Validations Export */}
              {!isPEUser && (
                <div style={{ border: '2px solid #E2E8F0', borderRadius: 16, padding: 24, background: '#FAFBFC' }}>
                  <h3 style={{ margin: '0 0 6px', fontSize: 18, color: '#1E293B' }}>✅ Validaciones PI</h3>
                  <p style={{ margin: '0 0 16px', fontSize: 13, color: '#64748B' }}>
                    Segmentos validados por inspectores en Planta Interna
                  </p>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    <input id="pi-region" placeholder="Región (ej: NORESTE)" style={{ padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1', fontSize: 14 }} />
                    <input id="pi-distrito" placeholder="Distrito (ej: MONTERREY)" style={{ padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1', fontSize: 14 }} />
                    <input id="pi-usuario" placeholder="Usuario inspector (ej: INSPECTOR01)" style={{ padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1', fontSize: 14 }} />
                    <div style={{ display: 'flex', gap: 8 }}>
                      <div style={{ flex: 1 }}>
                        <label style={{ fontSize: 12, color: '#64748B', marginBottom: 4, display: 'block' }}>Desde</label>
                        <input id="pi-fecha-inicio" type="date" style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1', fontSize: 14, boxSizing: 'border-box' }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <label style={{ fontSize: 12, color: '#64748B', marginBottom: 4, display: 'block' }}>Hasta</label>
                        <input id="pi-fecha-fin" type="date" style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1', fontSize: 14, boxSizing: 'border-box' }} />
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        const params = new URLSearchParams();
                        const r = document.getElementById('pi-region')?.value;
                        const d = document.getElementById('pi-distrito')?.value;
                        const u = document.getElementById('pi-usuario')?.value;
                        const fi = document.getElementById('pi-fecha-inicio')?.value;
                        const ff = document.getElementById('pi-fecha-fin')?.value;
                        if (r) params.append('region', r);
                        if (d) params.append('distrito', d);
                        if (u) params.append('usuario', u);
                        if (fi) params.append('fecha_inicio', fi);
                        if (ff) params.append('fecha_fin', ff);
                        const token = localStorage.getItem('control_campo_token');
                        fetch(`${API_URL}/admin/export-pi-validations?${params.toString()}`, {
                          headers: { 'Authorization': `Bearer ${token}` }
                        })
                          .then(res => {
                            if (!res.ok) throw new Error('Error descargando');
                            return res.blob();
                          })
                          .then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = `validaciones_pi_${new Date().toISOString().slice(0, 10)}.csv`;
                            a.click();
                            window.URL.revokeObjectURL(url);
                            showMessage('CSV de Validaciones PI descargado', 'success');
                          })
                          .catch(err => showMessage('❌ Error: ' + err.message, 'error'));
                      }}
                      style={{
                        padding: '12px 20px', border: 'none', borderRadius: 12,
                        background: 'linear-gradient(135deg, #10B981, #059669)',
                        color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer',
                        boxShadow: '0 4px 12px rgba(16,185,129,0.3)', transition: 'all 0.2s'
                      }}
                    >
                      📥 Descargar Validaciones PI
                    </button>
                  </div>
                </div>
              )}

              {/* PE Segments Export */}
              <div style={{ border: '2px solid #E2E8F0', borderRadius: 16, padding: 24, background: '#FAFBFC' }}>
                <h3 style={{ margin: '0 0 6px', fontSize: 18, color: '#1E293B' }}>🗺️ Puntos PE</h3>
                <p style={{ margin: '0 0 16px', fontSize: 13, color: '#64748B' }}>
                  Jornadas y segmentos PE registrados por inspectores
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  <input id="pe-region" placeholder="Región (ej: NORESTE)" style={{ padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1', fontSize: 14 }} />
                  <input id="pe-distrito" placeholder="Distrito (ej: MONTERREY)" style={{ padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1', fontSize: 14 }} />
                  <input id="pe-usuario" placeholder="Usuario inspector (ej: INSPECTOR01)" style={{ padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1', fontSize: 14 }} />
                  <div style={{ display: 'flex', gap: 8 }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: 12, color: '#64748B', marginBottom: 4, display: 'block' }}>Desde</label>
                      <input id="pe-fecha-inicio" type="date" style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1', fontSize: 14, boxSizing: 'border-box' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: 12, color: '#64748B', marginBottom: 4, display: 'block' }}>Hasta</label>
                      <input id="pe-fecha-fin" type="date" style={{ width: '100%', padding: '10px 14px', borderRadius: 10, border: '1px solid #CBD5E1', fontSize: 14, boxSizing: 'border-box' }} />
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      const params = new URLSearchParams();
                      const r = document.getElementById('pe-region')?.value;
                      const d = document.getElementById('pe-distrito')?.value;
                      const u = document.getElementById('pe-usuario')?.value;
                      const fi = document.getElementById('pe-fecha-inicio')?.value;
                      const ff = document.getElementById('pe-fecha-fin')?.value;
                      if (r) params.append('region', r);
                      if (d) params.append('distrito', d);
                      if (u) params.append('usuario', u);
                      if (fi) params.append('fecha_inicio', fi);
                      if (ff) params.append('fecha_fin', ff);
                      const token = localStorage.getItem('control_campo_token');
                      fetch(`${API_URL}/admin/export-pe-segments?${params.toString()}`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                      })
                        .then(res => {
                          if (!res.ok) throw new Error('Error descargando');
                          return res.blob();
                        })
                        .then(blob => {
                          const url = window.URL.createObjectURL(blob);
                          const a = document.createElement('a');
                          a.href = url;
                          a.download = `segmentos_pe_${new Date().toISOString().slice(0, 10)}.csv`;
                          a.click();
                          window.URL.revokeObjectURL(url);
                          showMessage('CSV de Segmentos PE descargado', 'success');
                        })
                        .catch(err => showMessage('❌ Error: ' + err.message, 'error'));
                    }}
                    style={{
                      padding: '12px 20px', border: 'none', borderRadius: 12,
                      background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)',
                      color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer',
                      boxShadow: '0 4px 12px rgba(139,92,246,0.3)', transition: 'all 0.2s'
                    }}
                  >
                    📥 Descargar Puntos PE
                  </button>
                </div>
              </div>

            </div>
          </div>
        )}

        {/* Tab: Carga de Hallazgos IDR */}
        {activeTab === 'idr-hallazgos' && (
          <div style={styles.card}>
            <HallazgosIDRPanel apiUrl={API_URL} isMobile={isMobile} currentUser={user} />
          </div>
        )}

        {activeTab === 'rbac' && (
          <div style={styles.card}>
            <div style={styles.cardHeader}>
              <span style={styles.cardIcon}>🛡️</span>
              <div>
                <h2 style={styles.cardTitle}>Administración de Roles y Permisos</h2>
                <p style={styles.cardSubtitle}>Crea perfiles con permisos granulares para tu equipo administrativo</p>
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
              <button
                onClick={() => {
                  setEditingRole(null);
                  setNewRoleData({ name: '', description: '', permission_ids: [] });
                  setShowRoleModal(true);
                }}
                style={{ ...styles.previewButton, width: 'auto', padding: '10px 20px' }}
              >
                <span>➕</span> Crear Nuevo Rol
              </button>
            </div>

            {rbacLoading ? (
              <div style={styles.loadingContainer}>
                <div style={styles.spinner}></div>
                <p>Cargando roles...</p>
              </div>
            ) : (
              <div style={styles.tableContainer}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHeader}>
                      <th style={styles.tableHeaderCell}>Nombre del Rol</th>
                      <th style={styles.tableHeaderCell}>Descripción</th>
                      <th style={styles.tableHeaderCell}>Permisos</th>
                      <th style={styles.tableHeaderCell}>Usuarios</th>
                      <th style={styles.tableHeaderCell}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rbacRoles.map((role) => (
                      <tr key={role.id} style={styles.tableRow}>
                        <td style={{ ...styles.tableCell, fontWeight: 'bold' }}>
                          {role.name}
                          {role.is_system_role && <span style={{ marginLeft: '6px', fontSize: '10px', backgroundColor: '#E5E7EB', padding: '2px 4px', borderRadius: '4px' }}>SISTEMA</span>}
                        </td>
                        <td style={styles.tableCell}>{role.description}</td>
                        <td style={styles.tableCell}>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                            {role.permissions.map(p => (
                              <span key={p.id} style={{ fontSize: '10px', backgroundColor: '#DBEAFE', color: '#1E40AF', padding: '2px 6px', borderRadius: '10px' }}>
                                {p.name}
                              </span>
                            ))}
                            {role.permissions.length === 0 && <span style={{ color: '#9CA3AF', fontStyle: 'italic' }}>Sin permisos</span>}
                          </div>
                        </td>
                        <td style={styles.tableCell}>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            {role.users && role.users.length > 0 ? (
                              role.users.slice(0, 5).map(u => (
                                <span key={u.id} style={{ fontSize: '11px', color: '#374151' }}>
                                  • {u.full_name} <span style={{ color: '#6B7280', fontSize: '10px' }}>({u.usuario_ffm})</span>
                                </span>
                              ))
                            ) : (
                              <span style={{ color: '#9CA3AF', fontStyle: 'italic', fontSize: '11px' }}>Sin usuarios</span>
                            )}
                            {role.users && role.users.length > 5 && (
                              <span style={{ fontSize: '10px', color: '#2563EB', fontWeight: 'bold', marginTop: '2px' }}>
                                + {role.users.length - 5} usuarios más...
                              </span>
                            )}
                          </div>
                        </td>
                        <td style={styles.tableCell}>
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <button
                              onClick={() => {
                                setEditingRole(role);
                                setNewRoleData({
                                  name: role.name,
                                  description: role.description,
                                  permission_ids: role.permissions.map(p => p.id)
                                });
                                setShowRoleModal(true);
                              }}
                              style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '18px' }}
                              title="Editar Rol"
                            >
                              ✏️
                            </button>
                            <button
                              onClick={() => {
                                setNewAdminData({ ...newAdminData, role_id: role.id });
                                setShowCreateAdminModal(true);
                              }}
                              style={{ padding: '4px 8px', background: '#2563EB', color: 'white', border: 'none', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' }}
                            >
                              + Usuario
                            </button>
                            {!role.is_system_role && (
                              <button
                                onClick={() => handleDeleteRole(role.id)}
                                style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '18px' }}
                                title="Eliminar Rol"
                              >
                                🗑️
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </main>

      {/* Modal de Coincidencias de Búsqueda Histórica */}
      {showHistoryMatchesModal && (
        <div style={styles.modalOverlay}>
          <div style={{ ...styles.modalContent, maxWidth: '700px', width: '90%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #E5E7EB', paddingBottom: '12px' }}>
              <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#1F2937', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>📜</span> Resultados en Historial / Acumulados
              </h3>
              <button 
                onClick={() => setShowHistoryMatchesModal(false)}
                style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '20px', color: '#9CA3AF' }}
              >
                &times;
              </button>
            </div>
            
            <p style={{ fontSize: '13px', color: '#6B7280', marginBottom: '16px' }}>
              Mostrando los técnicos registrados en las cargas masivas acumuladas que coinciden con su búsqueda.
            </p>

            <div style={{ maxHeight: '400px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {historyMatchesList.map((tech, idx) => (
                <div 
                  key={idx}
                  style={{
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: '1.5px solid #E5E7EB',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: '#F9FAFB',
                    transition: 'all 0.2s'
                  }}
                >
                  <div>
                    <div style={{ fontWeight: 'bold', fontSize: '15px', color: '#111827' }}>{tech.full_name}</div>
                    <div style={{ fontSize: '13px', color: '#4B5563', marginTop: '2px' }}>
                      Usuario FFM: <code style={{ fontWeight: 'bold', color: '#1E40AF', fontFamily: 'monospace' }}>{tech.usuario_ffm}</code> | CURP: {tech.curp}
                    </div>
                    <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span>📍 {tech.latest_region} / {tech.latest_distrito}</span>
                      <span>•</span>
                      <span style={{ color: '#059669', fontWeight: '600' }}>📦 En {tech.bulk_count} archivo(s)</span>
                      <span>•</span>
                      <span style={{
                        padding: '2px 6px',
                        borderRadius: '4px',
                        fontSize: '10px',
                        fontWeight: '600',
                        backgroundColor: tech.current_status === 'Activo' ? '#DEF7EC' : tech.current_status === 'Inactivo' ? '#FDE8E8' : '#FEF08A',
                        color: tech.current_status === 'Activo' ? '#03543F' : tech.current_status === 'Inactivo' ? '#9B1C1C' : '#713F12'
                      }}>
                        {tech.current_status}
                      </span>
                    </div>
                  </div>
                  
                  <button
                    onClick={() => {
                      setShowHistoryMatchesModal(false);
                      handleViewTechnicianHistory(tech.usuario_ffm, tech);
                    }}
                    style={{
                      padding: '6px 12px',
                      backgroundColor: '#8B5CF6',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#7C3AED'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#8B5CF6'}
                  >
                    Ver Historial
                  </button>
                </div>
              ))}
            </div>
            
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button
                onClick={() => setShowHistoryMatchesModal(false)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#E5E7EB',
                  color: '#374151',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '13px'
                }}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL DETALLE DE RUTAS DE INSPECTOR (Img 2) */}
      {showInspectorReportsModal && selectedInspectorTechReports && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', zIndex: 3000, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '980px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.3)' }}>
            <div style={{ background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', color: 'white', padding: '20px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '16px 16px 0 0' }}>
              <div>
                <h3 style={{ margin: 0, fontSize: '18px' }}>Detalle de Rutas de Inspector</h3>
                <p style={{ margin: '4px 0 0', fontSize: '13px', opacity: 0.9 }}>
                  {selectedInspectorTechReports.full_name} ({selectedInspectorTechReports.usuario_ffm}) — {selectedInspectorTechReports.region} / {selectedInspectorTechReports.distrito}
                </p>
              </div>
              <button
                onClick={() => setShowInspectorReportsModal(false)}
                style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', width: '32px', height: '32px', borderRadius: '50%', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold' }}
              >
                ✕
              </button>
            </div>

            <div style={{ padding: '24px' }}>
              <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13.5px' }}>
                  <thead>
                    <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0', textAlign: 'left', color: '#475569' }}>
                      <th style={{ padding: '12px' }}>Recorrido ID</th>
                      <th style={{ padding: '12px' }}>📱 Inicio (Celular)</th>
                      <th style={{ padding: '12px' }}>🖥️ Recepción (Servidor)</th>
                      <th style={{ padding: '12px' }}>🏁 Fin</th>
                      <th style={{ padding: '12px', textAlign: 'center' }}>Estado</th>
                      <th style={{ padding: '12px', textAlign: 'center' }}>Puntos</th>
                      <th style={{ padding: '12px', textAlign: 'center' }}>⚡ / ⛖</th>
                      <th style={{ padding: '12px', textAlign: 'center' }}>Tiempo</th>
                      <th style={{ padding: '12px', textAlign: 'center' }}>Metraje</th>
                      <th style={{ padding: '12px', textAlign: 'center' }}>Mapa</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedInspectorTechReports.reports.map((rep) => (
                      <tr key={rep.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                        <td style={{ padding: '12px', fontWeight: '700', color: '#1e293b' }}>#{rep.id}</td>
                        <td style={{ padding: '12px', color: '#475569' }}>
                          {rep.start_time ? new Date(rep.start_time).toLocaleString('es-MX') : 'N/A'}
                        </td>
                        <td style={{ padding: '12px', color: '#2563eb', fontWeight: '600', fontSize: '12.5px' }}>
                          {rep.server_created_at ? new Date(rep.server_created_at).toLocaleString('es-MX') : 'N/A'}
                        </td>
                        <td style={{ padding: '12px', color: '#475569' }}>
                          {rep.end_time ? new Date(rep.end_time).toLocaleString('es-MX') : 'En curso...'}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          <span style={{
                            background: rep.status === 'completed' ? '#dcfce7' : '#fef9c3',
                            color: rep.status === 'completed' ? '#15803d' : '#a16207',
                            padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '700'
                          }}>
                            {rep.status === 'completed' ? 'Completado' : 'Activo'}
                          </span>
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center', fontWeight: '700', color: '#2563eb' }}>
                          {rep.segmentos}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center', fontSize: '12.5px' }}>
                          <span style={{ color: '#059669', fontWeight: '600' }}>⚡ {rep.puntos_aereos}</span> | <span style={{ color: '#7c3aed', fontWeight: '600' }}>⛖ {rep.puntos_canalizados}</span>
                        </td>
                        <td style={{ padding: '12px', background: 'rgba(245, 243, 255, 0.5)', minWidth: '130px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#64748B' }}>
                            <span>Total:</span>
                            <span style={{ fontWeight: '500', color: '#475569' }}>{Math.floor((rep.tiempo_total_min || 0) / 60)}h {(rep.tiempo_total_min || 0) % 60}m</span>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12.5px', color: '#6D28D9', fontWeight: '700', marginTop: '2px' }}>
                            <span>Efectivo:</span>
                            <span>{Math.floor((rep.tiempo_efectivo_min || 0) / 60)}h {(rep.tiempo_efectivo_min || 0) % 60}m</span>
                          </div>
                          {rep.inicio_lejos && (
                            <div style={{ fontSize: '10.5px', color: '#ea580c', fontWeight: '600', marginTop: '3px' }}>📍 Inicio &gt;500m (traslado)</div>
                          )}
                          {rep.cierre_lejos && (
                            <div style={{ fontSize: '10.5px', color: '#ea580c', fontWeight: '600', marginTop: '2px' }}>🏁 Cierre &gt;500m (traslado)</div>
                          )}
                        </td>
                        <td style={{ padding: '12px', background: 'rgba(254, 243, 199, 0.5)', minWidth: '140px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#64748B' }}>
                            <span>Total:</span>
                            <span style={{ fontWeight: '500', color: '#475569' }}>{(rep.distancia_total_m || 0) >= 1000 ? `${((rep.distancia_total_m || 0) / 1000).toFixed(3)} km` : `${rep.distancia_total_m || 0} m`}</span>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12.5px', color: '#B45309', fontWeight: '700', marginTop: '2px' }}>
                            <span>Efectivo:</span>
                            <span>{(rep.distancia_efectiva_m || 0) >= 1000 ? `${((rep.distancia_efectiva_m || 0) / 1000).toFixed(3)} km` : `${rep.distancia_efectiva_m || 0} m`}</span>
                          </div>
                          {(rep.distancia_total_m || 0) > (rep.distancia_efectiva_m || 0) && (
                            <div style={{ fontSize: '10.5px', color: '#ea580c', fontWeight: '600', marginTop: '2px' }}>
                              -{(((rep.distancia_total_m || 0) - (rep.distancia_efectiva_m || 0)) / 1000).toFixed(2)} km tiradas largas
                            </div>
                          )}
                        </td>
                        <td style={{ padding: '12px', textAlign: 'center' }}>
                          <button
                            onClick={() => {
                              setSelectedInspectorMapReport(rep);
                              setShowInspectorReportsModal(false);
                            }}
                            style={{ padding: '6px 14px', background: '#2563eb', color: 'white', border: 'none', borderRadius: '6px', fontWeight: '600', cursor: 'pointer', fontSize: '12px', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                          >
                            Ver Mapa 🗺️
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div style={{ padding: '16px 24px', background: '#f8fafc', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', borderRadius: '0 0 16px 16px' }}>
              <button
                onClick={() => setShowInspectorReportsModal(false)}
                style={{ padding: '10px 20px', background: '#e2e8f0', color: '#475569', border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer' }}
              >
                Cerrar Detalle
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Historial y Línea de Tiempo del Técnico */}
      {showHistoryModal && historyTech && (
        <div style={styles.modalOverlay}>
          <div style={{ ...styles.modalContent, maxWidth: '800px', width: '95%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '2px solid #E5E7EB', paddingBottom: '12px' }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#1F2937', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span>📜</span> Historial de Cambios y Acumulados
                </h3>
                <span style={{ fontSize: '13px', color: '#4B5563', marginTop: '4px' }}>
                  Técnico: <span style={{ fontWeight: 'bold', color: '#111827' }}>{historyTech.full_name}</span> | FFM: <code style={{ fontWeight: 'bold', fontFamily: 'monospace' }}>{historyTech.usuario_ffm}</code>
                </span>
              </div>
              <button 
                onClick={() => setShowHistoryModal(false)}
                style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '20px', color: '#9CA3AF' }}
              >
                &times;
              </button>
            </div>

            {/* Info Resumen */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
              gap: '12px',
              backgroundColor: '#F3F4F6',
              padding: '12px 16px',
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <div>
                <span style={{ fontSize: '11px', color: '#6B7280', display: 'block', textTransform: 'uppercase' }}>CURP</span>
                <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#374151' }}>{historyTech.curp || 'N/A'}</span>
              </div>
              <div>
                <span style={{ fontSize: '11px', color: '#6B7280', display: 'block', textTransform: 'uppercase' }}>Estado Actual</span>
                <span style={{
                  display: 'inline-block',
                  padding: '2px 6px',
                  borderRadius: '4px',
                  fontSize: '11px',
                  fontWeight: '700',
                  backgroundColor: historyTech.current_status === 'Activo' || historyTech.is_active === true ? '#DEF7EC' : '#FDE8E8',
                  color: historyTech.current_status === 'Activo' || historyTech.is_active === true ? '#03543F' : '#9B1C1C',
                  marginTop: '2px'
                }}>
                  {historyTech.current_status || (historyTech.is_active ? 'Activo' : 'Inactivo')}
                </span>
              </div>
              <div>
                <span style={{ fontSize: '11px', color: '#6B7280', display: 'block', textTransform: 'uppercase' }}>Cargas Masivas</span>
                <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#059669' }}>
                  {techHistoryList.filter(h => h.change_type === 'bulk_upload').length} archivos acumulados
                </span>
              </div>
            </div>

            {/* Línea de Tiempo */}
            <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#374151', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span>⏱️</span> Línea de Tiempo de Cambios (Más reciente primero)
            </h4>
            
            <div style={{
              maxHeight: '400px',
              overflowY: 'auto',
              padding: '8px',
              border: '1px solid #E5E7EB',
              borderRadius: '8px',
              position: 'relative'
            }}>
              {techHistoryList.length === 0 ? (
                <div style={{ padding: '24px', textAlign: 'center', color: '#9CA3AF', fontSize: '14px' }}>
                  No hay registros en el historial de este técnico.
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {techHistoryList.map((log, index) => {
                    const isBulk = log.change_type === 'bulk_upload';
                    const hasChanges = log.changes && Object.keys(log.changes).length > 0;
                    
                    return (
                      <div 
                        key={log.id || index}
                        style={{
                          borderLeft: `4px solid ${isBulk ? '#10B981' : '#8B5CF6'}`,
                          paddingLeft: '14px',
                          position: 'relative',
                          backgroundColor: isBulk ? '#F0FDF4' : '#F5F3FF',
                          padding: '12px',
                          borderRadius: '0 8px 8px 0',
                          border: '1px solid #E5E7EB',
                          borderLeftWidth: '4px'
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                          <span style={{
                            fontSize: '11px',
                            fontWeight: 'bold',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            backgroundColor: isBulk ? '#D1FAE5' : '#EDE9FE',
                            color: isBulk ? '#065F46' : '#5B21B6'
                          }}>
                            {isBulk ? '📦 Carga Masiva' : '✏️ Edición Manual'}
                          </span>
                          <span style={{ fontSize: '11px', color: '#6B7280', fontWeight: '500' }}>
                            {log.created_at ? new Date(log.created_at).toLocaleString() : ''}
                          </span>
                        </div>
                        
                        <div style={{ fontSize: '13px', marginTop: '8px', color: '#1F2937' }}>
                          {isBulk ? (
                            <div>
                              <div>
                                **Archivo**: <span style={{ fontFamily: 'monospace', color: '#4B5563', fontSize: '12px' }}>{log.filename || 'N/A'}</span>
                                {log.week_number && (
                                  <span style={{ marginLeft: '8px', fontWeight: 'bold', color: '#047857' }}>
                                    (Semana {log.week_number})
                                  </span>
                                )}
                              </div>
                              <div style={{ marginTop: '4px', fontSize: '12px', color: '#4B5563' }}>
                                **Estado en archivo**: Región: {log.region} | Distrito: {log.distrito} | Empresa: {log.empresa || 'N/A'} | Gerente: {log.gerente || 'N/A'}
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div style={{ fontSize: '12px', color: '#4B5563', marginBottom: '4px' }}>
                                **Modificado por**: <span style={{ fontWeight: 'bold', color: '#4C1D95' }}>{log.edited_by_name}</span>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Cambios específicos */}
                        {hasChanges && (
                          <div style={{
                            marginTop: '8px',
                            backgroundColor: 'white',
                            border: '1px solid #E5E7EB',
                            borderRadius: '6px',
                            padding: '8px 12px'
                          }}>
                            <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#4B5563', marginBottom: '4px' }}>
                              Diferencias / Cambios detectados:
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                              {Object.entries(log.changes).map(([field, diff]) => (
                                <div key={field} style={{ fontSize: '11px', color: '#374151' }}>
                                  <span style={{ fontWeight: '600', textTransform: 'capitalize' }}>
                                    {field === 'full_name' ? 'Nombre' : 
                                     field === 'usuario_ffm' ? 'Usuario' :
                                     field === 'is_active' ? 'Estatus Activo' : field}
                                  </span>: <span style={{ color: '#DC2626', textDecoration: 'line-through', marginRight: '4px' }}>{String(diff.old)}</span>
                                  ➡️ <span style={{ color: '#059669', fontWeight: 'bold' }}>{String(diff.new)}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Comentario / Motivo registrado */}
                        {log.comentario && (
                          <div style={{
                            marginTop: '8px',
                            backgroundColor: '#F8FAFC',
                            border: '1px solid #CBD5E1',
                            borderLeft: '3px solid #3B82F6',
                            borderRadius: '6px',
                            padding: '8px 12px',
                            fontSize: '12px',
                            color: '#1E293B'
                          }}>
                            <span style={{ fontWeight: 'bold', color: '#1E40AF' }}>💬 Motivo / Justificación: </span>
                            {log.comentario}
                          </div>
                        )}

                        {/* Evidencia fotográfica adjunta */}
                        {log.evidencia_url && (
                          <div style={{ marginTop: '8px' }}>
                            <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#475569', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <span>📷</span> Evidencia Fotográfica Adjunta:
                            </div>
                            <img
                              src={`${API_URL.replace('/api/v1', '')}${log.evidencia_url}`}
                              alt="Evidencia de edición"
                              onClick={() => setSelectedEvidenceModalImage(`${API_URL.replace('/api/v1', '')}${log.evidencia_url}`)}
                              style={{
                                width: '110px',
                                height: '110px',
                                objectFit: 'cover',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                border: '2px solid #94A3B8',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                transition: 'transform 0.2s ease'
                              }}
                              title="Haz clic para ver en pantalla completa"
                            />
                          </div>
                        )}
                        
                        {isBulk && !hasChanges && index < techHistoryList.length - 1 && (
                          <div style={{ fontSize: '11px', color: '#059669', marginTop: '6px', fontStyle: 'italic', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span>✅</span> Sin cambios de distrito u otra información respecto a la carga anterior.
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px', gap: '8px' }}>
              {historyTech.usuario_ffm && (
                <button
                  onClick={() => handleViewTechnicianHistory(historyTech.usuario_ffm, historyTech)}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#EDE9FE',
                    color: '#5B21B6',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontWeight: '700',
                    fontSize: '13px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}
                >
                  🔄 Recargar
                </button>
              )}
              <button
                onClick={() => setShowHistoryModal(false)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#E5E7EB',
                  color: '#374151',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: '600',
                  fontSize: '13px'
                }}
              >
          
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para ver imagen de evidencia en tamaño completo */}
      {selectedEvidenceModalImage && (
        <div 
          style={styles.modalOverlay}
          onClick={() => setSelectedEvidenceModalImage(null)}
        >
          <div 
            style={{
              position: 'relative',
              maxWidth: '90vw',
              maxHeight: '90vh',
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: '16px',
              boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.5)',
              zIndex: 9999
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <h4 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: '#1F2937', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <span>📷</span> Evidencia Fotográfica de Auditoría
              </h4>
              <button
                onClick={() => setSelectedEvidenceModalImage(null)}
                style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '24px', color: '#6B7280' }}
              >
                &times;
              </button>
            </div>
            <img
              src={selectedEvidenceModalImage}
              alt="Evidencia en tamaño completo"
              style={{ maxWidth: '100%', maxHeight: '75vh', objectFit: 'contain', borderRadius: '8px', display: 'block', margin: '0 auto' }}
            />
          </div>
        </div>
      )}

      {/* RBAC Modals */}
      {showRoleModal && (
        <div style={styles.modalOverlay}>
          <div style={{ ...styles.modalContent, maxWidth: '600px', width: '90%' }}>
            <h2 style={{ ...styles.mainSectionTitle, marginBottom: '20px' }}>
              {editingRole ? 'Editar Rol' : 'Crear Nuevo Rol'}
            </h2>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Nombre del Rol</label>
              <input
                type="text"
                value={newRoleData.name}
                onChange={(e) => setNewRoleData({ ...newRoleData, name: e.target.value })}
                placeholder="Ej: Administrador Regional"
                style={styles.formInput}
                disabled={editingRole?.is_system_role}
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Descripción</label>
              <textarea
                value={newRoleData.description}
                onChange={(e) => setNewRoleData({ ...newRoleData, description: e.target.value })}
                placeholder="Describe qué puede hacer este perfil..."
                style={{ ...styles.formInput, height: '80px', paddingTop: '10px' }}
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Seleccionar Permisos</label>
              <div style={{ maxHeight: '250px', overflowY: 'auto', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '12px', marginTop: '8px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '8px' }}>
                  {rbacPermissions
                    .filter(perm => isPEUser ? !['admin:idr_dashboard', 'admin:idr_reports', 'system:manage_rbac'].includes(perm.name) : true)
                    .map(perm => (
                    <label key={perm.id} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '4px' }}>
                      <input
                        type="checkbox"
                        checked={newRoleData.permission_ids.includes(perm.id)}
                        onChange={(e) => {
                          const ids = e.target.checked
                            ? [...newRoleData.permission_ids, perm.id]
                            : newRoleData.permission_ids.filter(id => id !== perm.id);
                          setNewRoleData({ ...newRoleData, permission_ids: ids });
                        }}
                        style={{ marginRight: '8px', width: '18px', height: '18px' }}
                      />
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ fontSize: '14px', fontWeight: 'bold' }}>{perm.name}</span>
                        <span style={{ fontSize: '12px', color: '#6B7280' }}>{perm.description}</span>
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ ...styles.buttonGroup, marginTop: '30px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={() => setShowRoleModal(false)}
                style={{ ...styles.previewButton, backgroundColor: '#6B7280', width: 'auto' }}
              >
                Cancelar
              </button>
              <button
                onClick={handleSaveRole}
                style={{ ...styles.downloadButton, width: 'auto' }}
              >
                Guardar Rol
              </button>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'ai-feature-flag' && (
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={styles.cardIcon}>🤖</span>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                <h2 style={styles.cardTitle}>Despliegue Gradual de IA (Feature Flag por Proveedor)</h2>
                <span style={{
                  background: 'linear-gradient(135deg, #8B5CF6 0%, #6366F1 100%)',
                  color: 'white',
                  fontSize: '11px',
                  fontWeight: '700',
                  padding: '4px 10px',
                  borderRadius: '20px',
                  letterSpacing: '0.5px',
                  boxShadow: '0 2px 4px rgba(139, 92, 246, 0.3)'
                }}>
                  🔒 SOLO SUPERADMIN
                </span>
              </div>
              <p style={styles.cardSubtitle}>
                Control visual de activación por empresa proveedora. Los supervisores y coordinadores normales no tienen acceso a esta configuración.
              </p>
            </div>
          </div>

          {/* Tarjetas resumen de métricas */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
            gap: '16px',
            marginBottom: '28px'
          }}>
            <div style={{
              background: '#F8FAFC',
              border: '1px solid #E2E8F0',
              borderRadius: '12px',
              padding: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div>
                <div style={{ fontSize: '12px', color: '#64748B', fontWeight: '600', textTransform: 'uppercase' }}>Total Proveedores</div>
                <div style={{ fontSize: '28px', fontWeight: '800', color: '#0F172A', marginTop: '4px' }}>{aiProviders.length}</div>
              </div>
              <div style={{ fontSize: '32px', opacity: 0.8 }}>🏢</div>
            </div>

            <div style={{
              background: '#F0FDF4',
              border: '1px solid #BBF7D0',
              borderRadius: '12px',
              padding: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div>
                <div style={{ fontSize: '12px', color: '#166534', fontWeight: '600', textTransform: 'uppercase' }}>IA Activada</div>
                <div style={{ fontSize: '28px', fontWeight: '800', color: '#15803D', marginTop: '4px' }}>
                  {aiProviders.filter(p => p.ia_activa).length}
                </div>
              </div>
              <div style={{ fontSize: '32px', opacity: 0.8 }}>⚡</div>
            </div>

            <div style={{
              background: '#FEF2F2',
              border: '1px solid #FECACA',
              borderRadius: '12px',
              padding: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div>
                <div style={{ fontSize: '12px', color: '#991B1B', fontWeight: '600', textTransform: 'uppercase' }}>IA Desactivada</div>
                <div style={{ fontSize: '28px', fontWeight: '800', color: '#DC2626', marginTop: '4px' }}>
                  {aiProviders.filter(p => !p.ia_activa).length}
                </div>
              </div>
              <div style={{ fontSize: '32px', opacity: 0.8 }}>⏸️</div>
            </div>
          </div>

          {/* Barra de búsqueda y recarga */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '16px',
            marginBottom: '24px',
            flexDirection: isMobile ? 'column' : 'row'
          }}>
            <div style={{ position: 'relative', width: isMobile ? '100%' : '320px' }}>
              <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8' }}>🔍</span>
              <input
                type="text"
                placeholder="Buscar proveedor..."
                value={aiSearchQuery}
                onChange={(e) => setAiSearchQuery(e.target.value)}
                style={{
                  ...styles.input,
                  paddingLeft: '38px',
                  width: '100%',
                  borderRadius: '10px'
                }}
              />
            </div>

            <button
              onClick={fetchAiFeatureFlags}
              disabled={aiLoading}
              style={{
                ...styles.secondaryButton,
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                width: isMobile ? '100%' : 'auto'
              }}
            >
              <span>{aiLoading ? '🔄 Cargando...' : '🔄 Actualizar Lista'}</span>
            </button>
          </div>

          {/* Lista de Proveedores */}
          {aiLoading ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: '#64748B' }}>
              <div style={{ fontSize: '36px', marginBottom: '12px' }}>🔄</div>
              <div style={{ fontWeight: '600', fontSize: '16px' }}>Cargando estado de proveedores...</div>
            </div>
          ) : aiProviders.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: '#64748B', background: '#F8FAFC', borderRadius: '12px' }}>
              <div style={{ fontSize: '36px', marginBottom: '12px' }}>📭</div>
              <div style={{ fontWeight: '600', fontSize: '16px' }}>No se encontraron empresas o proveedores en el sistema.</div>
            </div>
          ) : (
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(300px, 1fr))',
              gap: '20px'
            }}>
              {aiProviders
                .filter(p => p.empresa.toLowerCase().includes(aiSearchQuery.toLowerCase()))
                .map((prov) => {
                  const isToggling = aiToggling[prov.empresa];
                  return (
                    <div
                      key={prov.empresa}
                      style={{
                        background: prov.ia_activa ? '#F0FDF4' : '#FFFFFF',
                        border: prov.ia_activa ? '2px solid #22C55E' : '1px solid #E2E8F0',
                        borderRadius: '16px',
                        padding: '20px',
                        boxShadow: prov.ia_activa ? '0 10px 15px -3px rgba(34, 197, 94, 0.1)' : '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                        transition: 'all 0.2s ease',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        gap: '16px'
                      }}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
                        <div>
                          <div style={{ fontSize: '18px', fontWeight: '800', color: '#0F172A', letterSpacing: '-0.3px' }}>
                            {prov.empresa}
                          </div>
                          <div style={{ fontSize: '12px', color: '#64748B', marginTop: '4px' }}>
                            {prov.ia_activa
                              ? '🟢 IA Activa (Interceptación habilitada)'
                              : '🔴 IA Inactiva (Flujo estándar sin IA)'}
                          </div>
                        </div>

                        <span style={{
                          fontSize: '11px',
                          fontWeight: '700',
                          padding: '4px 10px',
                          borderRadius: '12px',
                          background: prov.ia_activa ? '#DCFCE7' : '#F1F5F9',
                          color: prov.ia_activa ? '#15803D' : '#64748B',
                          border: prov.ia_activa ? '1px solid #86EFAC' : '1px solid #CBD5E1'
                        }}>
                          {prov.ia_activa ? 'ACTIVADO' : 'APAGADO'}
                        </span>
                      </div>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        paddingTop: '12px',
                        borderTop: '1px solid ' + (prov.ia_activa ? '#DCFCE7' : '#F1F5F9')
                      }}>
                        <span style={{ fontSize: '13px', fontWeight: '600', color: '#334155' }}>
                          Evaluación por IA
                        </span>

                        <button
                          onClick={() => handleToggleAiFeature(prov.empresa, prov.ia_activa)}
                          disabled={isToggling}
                          style={{
                            position: 'relative',
                            width: '64px',
                            height: '34px',
                            borderRadius: '17px',
                            border: 'none',
                            cursor: isToggling ? 'not-allowed' : 'pointer',
                            backgroundColor: prov.ia_activa ? '#22C55E' : '#CBD5E1',
                            transition: 'background-color 0.3s ease',
                            padding: '3px',
                            outline: 'none',
                            boxShadow: prov.ia_activa ? '0 0 10px rgba(34, 197, 94, 0.4)' : 'none'
                          }}
                        >
                          <div style={{
                            width: '28px',
                            height: '28px',
                            borderRadius: '50%',
                            backgroundColor: 'white',
                            transform: prov.ia_activa ? 'translateX(30px)' : 'translateX(0)',
                            transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '12px'
                          }}>
                            {isToggling ? '⌛' : prov.ia_activa ? '⚡' : '⚪'}
                          </div>
                        </button>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      )}

      {activeTab === 'ai-audits' && (
        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={styles.cardIcon}>🔍</span>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                <h2 style={styles.cardTitle}>Auditoría y Galería de Evaluaciones por IA</h2>
                <span style={{
                  background: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)',
                  color: 'white',
                  fontSize: '11px',
                  fontWeight: '700',
                  padding: '4px 10px',
                  borderRadius: '20px',
                  letterSpacing: '0.5px',
                  boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)'
                }}>
                  🛡️ Permiso: admin:ai_audits
                </span>
              </div>
              <p style={styles.cardSubtitle}>
                Inspección visual de fotografías de campo analizadas por Google Gemini. Filtre por fotos correctas, dudosas o rechazadas.
              </p>
            </div>
          </div>

          {/* Tarjetas resumen de métricas */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
            gap: '16px',
            marginBottom: '28px'
          }}>
            <div style={{
              background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '18px',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between'
            }}>
              <div>
                <div style={{ fontSize: '11px', color: '#64748B', fontWeight: '700', textTransform: 'uppercase' }}>Total Analizadas</div>
                <div style={{ fontSize: '26px', fontWeight: '800', color: '#0F172A', marginTop: '4px' }}>
                  {aiAuditData?.metrics?.total || 0}
                </div>
              </div>
              <div style={{ fontSize: '28px' }}>📊</div>
            </div>

            <div style={{
              background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: '12px', padding: '18px',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between'
            }}>
              <div>
                <div style={{ fontSize: '11px', color: '#166534', fontWeight: '700', textTransform: 'uppercase' }}>🟢 Correctas</div>
                <div style={{ fontSize: '26px', fontWeight: '800', color: '#15803D', marginTop: '4px' }}>
                  {aiAuditData?.metrics?.correctas || 0}
                </div>
              </div>
              <div style={{ fontSize: '28px' }}>✅</div>
            </div>

            <div style={{
              background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: '12px', padding: '18px',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between'
            }}>
              <div>
                <div style={{ fontSize: '11px', color: '#B45309', fontWeight: '700', textTransform: 'uppercase' }}>🟡 Dudosas / Sospechosas</div>
                <div style={{ fontSize: '26px', fontWeight: '800', color: '#D97706', marginTop: '4px' }}>
                  {aiAuditData?.metrics?.sospechosas || 0}
                </div>
              </div>
              <div style={{ fontSize: '28px' }}>⚠️</div>
            </div>

            <div style={{
              background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '12px', padding: '18px',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between'
            }}>
              <div>
                <div style={{ fontSize: '11px', color: '#991B1B', fontWeight: '700', textTransform: 'uppercase' }}>🔴 Incorrectas / Rechazadas</div>
                <div style={{ fontSize: '26px', fontWeight: '800', color: '#DC2626', marginTop: '4px' }}>
                  {aiAuditData?.metrics?.incorrectas || 0}
                </div>
              </div>
              <div style={{ fontSize: '28px' }}>❌</div>
            </div>
          </div>

          {/* Filtros Rápidos por Estado e Insumos */}
          <form onSubmit={(e) => fetchAiAuditData(e, 1)} style={{
            background: '#F8FAFC', padding: '20px', borderRadius: '14px', border: '1px solid #E2E8F0', marginBottom: '28px'
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              
              {/* Botones de Selección de Estado */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                <span style={{ fontSize: '13px', fontWeight: '700', color: '#334155', marginRight: '8px' }}>Clasificación IA:</span>
                {[
                  { id: 'TODAS', label: 'Todas', color: '#475569' },
                  { id: 'CORRECTA', label: '🟢 Correctas', color: '#16A34A' },
                  { id: 'SOSPECHOSA', label: '🟡 Dudosas / Sospechosas', color: '#D97706' },
                  { id: 'INCORRECTA', label: '🔴 Incorrectas / Rechazadas', color: '#DC2626' }
                ].map(b => (
                  <button
                    key={b.id}
                    type="button"
                    onClick={() => {
                      setAiAuditFilters(prev => ({ ...prev, estado_ia: b.id }));
                    }}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '20px',
                      fontSize: '13px',
                      fontWeight: '700',
                      border: aiAuditFilters.estado_ia === b.id ? `2px solid ${b.color}` : '1px solid #CBD5E1',
                      backgroundColor: aiAuditFilters.estado_ia === b.id ? 'white' : '#F1F5F9',
                      color: aiAuditFilters.estado_ia === b.id ? b.color : '#64748B',
                      cursor: 'pointer',
                      boxShadow: aiAuditFilters.estado_ia === b.id ? '0 2px 4px rgba(0,0,0,0.08)' : 'none',
                      transition: 'all 0.2s ease'
                    }}
                  >
                    {b.label}
                  </button>
                ))}
              </div>

              {/* Controles de Búsqueda y Fecha */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr) auto',
                gap: '12px',
                alignItems: 'end'
              }}>
                <div>
                  <label style={{ fontSize: '12px', fontWeight: '600', color: '#475569', display: 'block', marginBottom: '4px' }}>Proveedor / Empresa</label>
                  <input
                    type="text"
                    placeholder="Ej. GLOBARED, SOL..."
                    value={aiAuditFilters.empresa}
                    onChange={(e) => setAiAuditFilters(prev => ({ ...prev, empresa: e.target.value }))}
                    style={{ ...styles.input, width: '100%', borderRadius: '8px', fontSize: '13px' }}
                  />
                </div>

                <div>
                  <label style={{ fontSize: '12px', fontWeight: '600', color: '#475569', display: 'block', marginBottom: '4px' }}>Usuario FFM Técnico</label>
                  <input
                    type="text"
                    placeholder="Ej. SOLMTCMXT0163"
                    value={aiAuditFilters.usuario_ffm}
                    onChange={(e) => setAiAuditFilters(prev => ({ ...prev, usuario_ffm: e.target.value }))}
                    style={{ ...styles.input, width: '100%', borderRadius: '8px', fontSize: '13px' }}
                  />
                </div>

                <div>
                  <label style={{ fontSize: '12px', fontWeight: '600', color: '#475569', display: 'block', marginBottom: '4px' }}>Fecha Inicio</label>
                  <input
                    type="date"
                    value={aiAuditFilters.fecha_inicio}
                    onChange={(e) => setAiAuditFilters(prev => ({ ...prev, fecha_inicio: e.target.value }))}
                    style={{ ...styles.input, width: '100%', borderRadius: '8px', fontSize: '13px' }}
                  />
                </div>

                <button
                  type="submit"
                  disabled={aiAuditLoading}
                  style={{
                    ...styles.primaryButton,
                    padding: '10px 20px',
                    borderRadius: '8px',
                    fontWeight: '700',
                    fontSize: '13px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    height: '40px'
                  }}
                >
                  <span>{aiAuditLoading ? '🔄' : '🔍'}</span>
                  <span>Filtrar</span>
                </button>
              </div>

            </div>
          </form>

          {/* Resultados de la Galería */}
          {aiAuditLoading ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: '#64748B' }}>
              <div style={{ fontSize: '36px', marginBottom: '12px' }}>🔄</div>
              <div style={{ fontWeight: '600', fontSize: '16px' }}>Cargando evaluaciones de Gemini IA...</div>
            </div>
          ) : !aiAuditData || !aiAuditData.evaluations || aiAuditData.evaluations.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: '#64748B', background: '#F8FAFC', borderRadius: '16px' }}>
              <div style={{ fontSize: '36px', marginBottom: '12px' }}>📭</div>
              <div style={{ fontWeight: '600', fontSize: '16px' }}>No se encontraron segmentos evaluados con el filtro seleccionado.</div>
              <div style={{ fontSize: '13px', color: '#94A3B8', marginTop: '4px' }}>Prueba seleccionando "Todas" o limpiando el filtro de empresa/técnico.</div>
            </div>
          ) : (
            <div>
              <div style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(480px, 1fr))',
                gap: '24px',
                marginBottom: '32px'
              }}>
                {aiAuditData.evaluations.map((item) => {
                  const evalIa = item.evaluacion_ia || {};
                  const est = str => (str || '').toUpperCase();
                  const estadoClass = est(evalIa.estado_ia);
                  let badgeBg = '#F1F5F9';
                  let badgeText = '#475569';
                  let badgeBorder = '#CBD5E1';
                  let badgeIcon = '⚪';


                  if (estadoClass === 'CORRECTA') {
                    badgeBg = '#DCFCE7';
                    badgeText = '#15803D';
                    badgeBorder = '#86EFAC';
                    badgeIcon = '🟢';
                  } else if (estadoClass === 'INCORRECTA' || estadoClass === 'RECHAZADA') {
                    badgeBg = '#FEE2E2';
                    badgeText = '#991B1B';
                    badgeBorder = '#FCA5A5';
                    badgeIcon = '🔴';
                  } else if (estadoClass === 'SOSPECHOSA' || estadoClass === 'DUDOSA') {
                    badgeBg = '#FEF3C7';
                    badgeText = '#92400E';
                    badgeBorder = '#FDE68A';
                    badgeIcon = '🟡';
                  }


                  const baseUrl = getMediaBaseUrl();

                  const fullPhoto1 = item.photo1_url ? (item.photo1_url.startsWith('http') ? item.photo1_url : `${baseUrl}${item.photo1_url}`) : '';
                  const fullPhoto2 = item.photo2_url ? (item.photo2_url.startsWith('http') ? item.photo2_url : `${baseUrl}${item.photo2_url}`) : '';

                  return (
                    <div
                      key={item.segment_id}
                      style={{
                        background: 'white',
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                      }}
                    >
                      {/* Cabecera de la Tarjeta */}
                      <div style={{ padding: '16px 20px', background: '#F8FAFC', borderBottom: '1px solid #E2E8F0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <div style={{ fontWeight: '800', fontSize: '15px', color: '#0F172A' }}>
                            {item.technician_name} <span style={{ color: '#64748B', fontWeight: '500' }}>({item.usuario_ffm})</span>
                          </div>
                          <div style={{ fontSize: '12px', color: '#64748B', marginTop: '2px' }}>
                            🏢 <b>{item.empresa}</b> | 📍 {item.region} - {item.distrito}
                          </div>
                        </div>

                        <div style={{ textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{
                              background: badgeBg,
                              color: badgeText,
                              border: `1px solid ${badgeBorder}`,
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontWeight: '800',
                              fontSize: '12px',
                              display: 'inline-block'
                            }}>
                              {badgeIcon} {evalIa.estado_ia || 'EVALUADO'} {evalIa.confianza ? `(${Math.round(evalIa.confianza * 100)}%)` : ''}
                            </span>

                            <button
                              type="button"
                              title="Reevaluar con nuevos filtros de oscuridad/IA"
                              onClick={() => handleReevaluateSegment(item.segment_id)}
                              style={{
                                background: '#F1F5F9', border: '1px solid #CBD5E1', color: '#334155',
                                borderRadius: '8px', padding: '4px 8px', fontSize: '11px', fontWeight: '700',
                                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '3px'
                              }}
                            >
                              🔄 Reevaluar
                            </button>
                          </div>

                          <div style={{ fontSize: '11px', color: '#94A3B8' }}>
                            {item.created_at ? new Date(item.created_at).toLocaleString('es-MX') : ''}
                          </div>
                        </div>
                      </div>

                      {/* Fotos Lado a Lado (Antes vs Después) */}
                      <div style={{ padding: '16px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', background: '#0F172A' }}>
                        <div style={{ position: 'relative' }}>
                          <div style={{ position: 'absolute', top: '8px', left: '8px', background: 'rgba(15,23,42,0.85)', color: 'white', fontSize: '11px', fontWeight: '700', padding: '3px 8px', borderRadius: '4px', zIndex: 2 }}>
                            📷 FOTO ANTES
                          </div>
                          {fullPhoto1 ? (
                            <img
                              src={fullPhoto1}
                              alt="Foto Antes"
                              onClick={() => setSelectedAiImageModal({ url: fullPhoto1, title: `Foto ANTES - ${item.technician_name}` })}
                              style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '8px', cursor: 'zoom-in', border: '1px solid #334155' }}
                            />
                          ) : (
                            <div style={{ width: '100%', height: '180px', background: '#1E293B', color: '#94A3B8', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', fontSize: '12px' }}>Sin foto</div>
                          )}
                        </div>

                        <div style={{ position: 'relative' }}>
                          <div style={{ position: 'absolute', top: '8px', left: '8px', background: 'rgba(15,23,42,0.85)', color: '#4ADE80', fontSize: '11px', fontWeight: '700', padding: '3px 8px', borderRadius: '4px', zIndex: 2 }}>
                            ✨ FOTO DESPUÉS
                          </div>
                          {fullPhoto2 ? (
                            <img
                              src={fullPhoto2}
                              alt="Foto Después"
                              onClick={() => setSelectedAiImageModal({ url: fullPhoto2, title: `Foto DESPUÉS - ${item.technician_name}` })}
                              style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '8px', cursor: 'zoom-in', border: '1px solid #334155' }}
                            />
                          ) : (
                            <div style={{ width: '100%', height: '180px', background: '#1E293B', color: '#94A3B8', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', fontSize: '12px' }}>Sin foto</div>
                          )}
                        </div>
                      </div>

                      {/* Desglose de Hallazgos por Gemini y Sección de Feedback RLHF */}
                      <div style={{ padding: '16px 20px', background: 'white' }}>
                        {item.activities && item.activities.length > 0 && (
                          <div style={{ marginBottom: '10px', fontSize: '12px', color: '#475569' }}>
                            <b>Actividades etiquetadas:</b> {item.activities.join(', ')}
                          </div>
                        )}

                        <div style={{ background: '#F8FAFC', padding: '14px', borderRadius: '12px', border: '1px solid #E2E8F0', fontSize: '12.5px', color: '#1E293B', lineHeight: '1.5', marginBottom: '12px' }}>
                          {evalIa.deteccion_anomalias && evalIa.deteccion_anomalias.toLowerCase() !== 'ninguna' && (
                            <div style={{ marginBottom: '8px', padding: '6px 10px', background: '#FEF2F2', border: '1px solid #FCA5A5', borderRadius: '6px', color: '#991B1B', fontWeight: '700', fontSize: '12px' }}>
                              🚨 Anomalía Detectada: {evalIa.deteccion_anomalias}
                            </div>
                          )}

                          {evalIa.hallazgos_antes && (
                            <div style={{ marginBottom: '6px' }}>
                              <b style={{ color: '#475569' }}>🔍 Hallazgos Antes:</b> {evalIa.hallazgos_antes}
                            </div>
                          )}
                          {evalIa.hallazgos_despues && (
                            <div style={{ marginBottom: '6px' }}>
                              <b style={{ color: '#15803D' }}>🔍 Hallazgos Después:</b> {evalIa.hallazgos_despues}
                            </div>
                          )}
                          {evalIa.mensaje && (
                            <div>
                              <b style={{ color: '#2563EB' }}>📋 Dictamen:</b> {evalIa.mensaje}
                            </div>
                          )}
                        </div>

                        {/* Módulo de Recompensa / Retroalimentación del Supervisor (RLHF) */}
                        <div style={{ background: '#F1F5F9', borderRadius: '10px', padding: '12px', border: '1px dashed #CBD5E1' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <span style={{ fontSize: '12px', fontWeight: '800', color: '#334155', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span>🎓</span> Retroalimentación de Supervisor (Recompensa IA):
                            </span>

                            {evalIa.feedback_supervisor && (
                              <span style={{
                                fontSize: '11px',
                                fontWeight: '700',
                                padding: '2px 8px',
                                borderRadius: '10px',
                                background: evalIa.feedback_supervisor.acuerdo ? '#DCFCE7' : '#FEE2E2',
                                color: evalIa.feedback_supervisor.acuerdo ? '#15803D' : '#991B1B',
                                border: `1px solid ${evalIa.feedback_supervisor.acuerdo ? '#86EFAC' : '#FCA5A5'}`
                              }}>
                                {evalIa.feedback_supervisor.acuerdo ? '✅ Dictamen Aprobado' : '🔴 Alucinación Corregida'}
                              </span>
                            )}
                          </div>

                          {evalIa.feedback_supervisor && (
                            <div style={{ fontSize: '12px', color: '#475569', background: 'white', padding: '8px 12px', borderRadius: '6px', border: '1px solid #E2E8F0', marginBottom: '8px' }}>
                              <b>👤 Supervisor ({evalIa.feedback_supervisor.supervisor_nombre || evalIa.feedback_supervisor.supervisor_usuario}):</b> "{evalIa.feedback_supervisor.comentario}"
                              <div style={{ fontSize: '10px', color: '#94A3B8', marginTop: '4px' }}>
                                Registrado el {new Date(evalIa.feedback_supervisor.timestamp).toLocaleString('es-MX')} | Criterio entrenado: <b>{evalIa.feedback_supervisor.correct_label || 'CORREGIDO'}</b>
                              </div>
                            </div>
                          )}

                          <div>
                            <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                              <button
                                type="button"
                                onClick={() => handleSendSupervisorFeedback(item.segment_id, true, 'CORRECTA')}
                                style={{
                                  flex: 1, padding: '6px 10px', borderRadius: '6px', border: '1px solid #86EFAC',
                                  background: '#DCFCE7', color: '#15803D', fontWeight: '700', fontSize: '11.5px',
                                  cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px'
                                }}
                              >
                                👍 {evalIa.feedback_supervisor ? 'Re-Aprobar' : 'Aprobar Dictamen'}
                              </button>

                              <button
                                type="button"
                                onClick={() => {
                                  setFeedbackForms(prev => ({
                                    ...prev,
                                    [item.segment_id]: {
                                      showForm: !prev[item.segment_id]?.showForm,
                                      comentario: prev[item.segment_id]?.comentario || (evalIa.feedback_supervisor?.comentario || ''),
                                      correctLabel: evalIa.feedback_supervisor?.correct_label || 'INCORRECTA'
                                    }
                                  }));
                                }}
                                style={{
                                  flex: 1, padding: '6px 10px', borderRadius: '6px', border: '1px solid #FCA5A5',
                                  background: '#FEE2E2', color: '#991B1B', fontWeight: '700', fontSize: '11.5px',
                                  cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px'
                                }}
                              >
                                👎 {evalIa.feedback_supervisor ? '✏️ Editar Alucinación / Corregir' : 'Reportar Alucinación / Corregir'}
                              </button>
                            </div>

                            {feedbackForms[item.segment_id]?.showForm && (
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px', background: 'white', padding: '10px', borderRadius: '8px', border: '1px solid #CBD5E1' }}>
                                <div>
                                  <label style={{ fontSize: '11px', fontWeight: '700', color: '#475569', display: 'block', marginBottom: '4px' }}>
                                    Estatus correcto que debió emitir la IA:
                                  </label>
                                  <select
                                    value={feedbackForms[item.segment_id]?.correctLabel || 'INCORRECTA'}
                                    onChange={(e) => setFeedbackForms(prev => ({
                                      ...prev,
                                      [item.segment_id]: { ...prev[item.segment_id], correctLabel: e.target.value }
                                    }))}
                                    style={{ width: '100%', padding: '4px 8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '12px' }}
                                  >
                                    <option value="INCORRECTA">🔴 INCORRECTA / RECHAZADA (Foto mal tomada/oscura/sin trabajo)</option>
                                    <option value="SOSPECHOSA">🟡 SOSPECHOSA (Requiere inspección manual)</option>
                                    <option value="CORRECTA">🟢 CORRECTA (Trabajo bien hecho)</option>
                                  </select>
                                </div>

                                <div>
                                  <label style={{ fontSize: '11px', fontWeight: '700', color: '#475569', display: 'block', marginBottom: '4px' }}>
                                    Comentario de entrenamiento para la IA:
                                  </label>
                                  <textarea
                                    rows={2}
                                    placeholder="Ej. La foto del después está totalmente oscura/tapada por un dedo. Debe ser rechazada."
                                    value={feedbackForms[item.segment_id]?.comentario || ''}
                                    onChange={(e) => setFeedbackForms(prev => ({
                                      ...prev,
                                      [item.segment_id]: { ...prev[item.segment_id], comentario: e.target.value }
                                    }))}
                                    style={{ width: '100%', padding: '6px 8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '12px', resize: 'vertical' }}
                                  />
                                </div>

                                <button
                                  type="button"
                                  onClick={() => handleSendSupervisorFeedback(item.segment_id, false)}
                                  style={{
                                    padding: '6px 12px', background: '#2563EB', color: 'white', border: 'none',
                                    borderRadius: '6px', fontWeight: '700', fontSize: '12px', cursor: 'pointer',
                                    alignSelf: 'flex-end'
                                  }}
                                >
                                  💾 Guardar Retroalimentación
                                </button>
                              </div>
                            )}
                          </div>
                        </div>

                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Paginación */}
              {aiAuditData.total_pages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px', marginTop: '20px' }}>
                  <button
                    onClick={(e) => fetchAiAuditData(e, aiAuditPage - 1)}
                    disabled={aiAuditPage <= 1 || aiAuditLoading}
                    style={{ ...styles.secondaryButton, padding: '8px 16px', borderRadius: '8px', fontSize: '13px' }}
                  >
                    ◀ Anterior
                  </button>
                  <span style={{ fontSize: '13px', fontWeight: '700', color: '#475569' }}>
                    Página {aiAuditPage} de {aiAuditData.total_pages}
                  </span>
                  <button
                    onClick={(e) => fetchAiAuditData(e, aiAuditPage + 1)}
                    disabled={aiAuditPage >= aiAuditData.total_pages || aiAuditLoading}
                    style={{ ...styles.secondaryButton, padding: '8px 16px', borderRadius: '8px', fontSize: '13px' }}
                  >
                    Siguiente ▶
                  </button>
                </div>
              )}
            </div>
          )}

          {/* Modal de Zoom de Imagen */}
          {selectedAiImageModal && (
            <div
              onClick={() => setSelectedAiImageModal(null)}
              style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(15, 23, 42, 0.9)', zIndex: 99999,
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px'
              }}
            >
              <div style={{ color: 'white', fontWeight: '700', marginBottom: '12px', fontSize: '16px' }}>
                {selectedAiImageModal.title} (Haz clic en cualquier lugar para cerrar)
              </div>
              <img
                src={selectedAiImageModal.url}
                alt="Vista Ampliada"
                style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: '12px', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)' }}
              />
            </div>
          )}
        </div>
      )}

      {activeTab === 'relocate-tech' && user?.usuario_ffm === 'IGNOROSA' && (
        <RelocateTechnicianPanel apiUrl={API_URL} distritosCatalog={distritosCatalog} isMobile={isMobile} />
      )}

      {activeTab === 'pactadas' && (


        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={styles.cardIcon}>📋</span>
            <div>
              <h2 style={styles.cardTitle}>Procesamiento de Cuadrillas Pactadas y Asistencia</h2>
              <p style={styles.cardSubtitle}>
                Flujo automatizado de limpieza de datos, consolidación de OTs y emparejamiento con cuadrillas pactadas.
              </p>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
            
            {/* --- PASO 1: LIMPIEZA DE CIERRE DIARIO --- */}
            <div style={{ background: '#F8FAFC', padding: '28px', borderRadius: '16px', border: '1px solid #E2E8F0' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <span style={{ background: '#3B82F6', color: 'white', borderRadius: '50%', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '14px' }}>1</span>
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1E293B' }}>Fase 1: Subir y Limpiar Cierre Diario</h3>
              </div>
              
              <form onSubmit={handleCleanCierre}>
                {/* Filtros Opcionales de Región, Distrito y Proveedor */}
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                  <MultiSelectDropdown
                    label="Región (Opcional)"
                    options={pactadasRegionOptions}
                    selectedValues={pactadasRegions}
                    onChange={(vals) => {
                      setPactadasRegions(vals);
                      setPactadasDistritos([]);
                      setPactadasEmpresas([]);
                    }}
                  />
                  <MultiSelectDropdown
                    label="Distrito (Opcional)"
                    options={pactadasDistritoOptions}
                    selectedValues={pactadasDistritos}
                    onChange={(vals) => {
                      setPactadasDistritos(vals);
                      setPactadasEmpresas([]);
                    }}
                  />
                  <MultiSelectDropdown
                    label="Proveedor (Opcional)"
                    options={pactadasEmpresaOptions}
                    selectedValues={pactadasEmpresas}
                    onChange={setPactadasEmpresas}
                  />
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569', fontSize: '14px' }}>
                    Archivo de Cierre Diario (.csv) <span style={{ color: '#EF4444' }}>*Obligatorio</span>
                  </label>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setCierreFile(e.target.files[0]);
                      setCleanCierreFilename('');
                    }}
                    style={{
                      width: '100%', padding: '12px', borderRadius: '10px',
                      border: '1px solid #CBD5E1', background: 'white', fontSize: '14px',
                      boxSizing: 'border-box'
                    }}
                    required
                  />
                </div>

                <button
                  type="submit"
                  disabled={cleanLoading}
                  style={{
                    padding: '12px 24px', border: 'none', borderRadius: '10px',
                    background: cleanLoading ? '#94A3B8' : 'linear-gradient(135deg, #3B82F6, #1D4ED8)',
                    color: '#fff', fontWeight: '700', fontSize: '15px', cursor: cleanLoading ? 'default' : 'pointer',
                    boxShadow: '0 4px 10px rgba(59,130,246,0.2)', transition: 'all 0.2s', width: '100%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'
                  }}
                >
                  {cleanLoading ? (
                    <>
                      <div style={{
                        width: '18px', height: '18px', border: '3px solid rgba(255,255,255,0.3)',
                        borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 1s linear infinite'
                      }}></div>
                      Limpiando datos del Cierre Diario...
                    </>
                  ) : (
                    '🧼 Limpiar Cierre Diario'
                  )}
                </button>
              </form>

              {cleanCierreFilename && (
                <div style={{ marginTop: '20px', background: '#ECFDF5', border: '1px solid #A7F3D0', padding: '16px', borderRadius: '12px' }}>
                  <p style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#065F46', fontWeight: '600' }}>
                    ¡Limpieza completada con éxito!
                  </p>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                    <button
                      onClick={() => handleDownloadPactadasFile(cleanCierreFilename)}
                      style={{
                        padding: '10px 18px', border: 'none', borderRadius: '8px',
                        background: '#10B981', color: '#fff', fontWeight: '700', cursor: 'pointer',
                        fontSize: '13px', display: 'flex', alignItems: 'center', gap: '6px'
                      }}
                    >
                      <span>📥</span> Descargar Cierre Limpio (CSV)
                    </button>
                  </div>
                  <p style={{ margin: '12px 0 0 0', fontSize: '13px', color: '#047857' }}>
                    * Descarga el archivo anterior si deseas revisarlo o corregirlo. Luego, procede a la Fase 2 a continuación.
                  </p>
                </div>
              )}
            </div>

            {/* --- PASO 2: PROCESAMIENTO FINAL --- */}
            <div style={{ 
              background: 'white', 
              padding: '28px', 
              borderRadius: '16px', 
              border: '1px solid #E2E8F0',
              opacity: cleanCierreFilename ? 1 : 0.6,
              pointerEvents: cleanCierreFilename ? 'auto' : 'none'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <span style={{ background: '#10B981', color: 'white', borderRadius: '50%', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '14px' }}>2</span>
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1E293B' }}>Fase 2: Procesar Asistencia y Cuadrillas Pactadas</h3>
              </div>

              {!cleanCierreFilename && (
                <div style={{ background: '#FEF3C7', border: '1px solid #FDE68A', padding: '12px 16px', borderRadius: '8px', marginBottom: '20px', fontSize: '14px', color: '#92400E' }}>
                  ⚠️ Completa la **Fase 1** primero para habilitar este paso.
                </div>
              )}

              <form onSubmit={handleProcessPactadas}>

                {/* Filtros Fase 2 - Consulta a la BD */}
                <div style={{ background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: '12px', padding: '16px', marginBottom: '20px' }}>
                  <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#1D4ED8', fontWeight: '600' }}>
                    🗂️ Filtros para consulta en base de datos — Solo se traerán recorridos del distrito y proveedor seleccionados.
                    {(p2Distritos.length > 0 || p2Empresas.length > 0) && (
                      <span style={{ marginLeft: '8px', fontWeight: '400', color: '#3B82F6' }}>
                        (heredados de Fase 1 — puedes modificarlos)
                      </span>
                    )}
                  </p>
                  <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr', gap: '12px' }}>
                    <MultiSelectDropdown
                      label="Región"
                      options={pactadasRegionOptions}
                      selectedValues={p2Regions}
                      onChange={(vals) => {
                        setP2Regions(vals);
                        setP2Distritos([]);
                        setP2Empresas([]);
                      }}
                    />
                    <MultiSelectDropdown
                      label="Distrito"
                      options={distritosCatalog
                        .filter(d => p2Regions.length === 0 || p2Regions.includes(d.region))
                        .map(d => d.distrito)
                        .filter(Boolean)
                        .sort()}
                      selectedValues={p2Distritos}
                      onChange={(vals) => {
                        setP2Distritos(vals);
                        setP2Empresas([]);
                      }}
                    />
                    <MultiSelectDropdown
                      label="Proveedor / Empresa"
                      options={pactadasEmpresaOptions}
                      selectedValues={p2Empresas}
                      onChange={setP2Empresas}
                    />
                  </div>
                  {(p2Distritos.length > 0 || p2Empresas.length > 0) && (
                    <p style={{ margin: '10px 0 0 0', fontSize: '12px', color: '#1E40AF' }}>
                      📍 Procesando: {p2Distritos.length > 0 ? p2Distritos.join(', ') : 'Todos los distritos'}
                      {p2Empresas.length > 0 ? ` · 🏢 ${p2Empresas.join(', ')}` : ''}
                    </p>
                  )}
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569', fontSize: '14px' }}>Fecha Inicio</label>
                    <input
                      type="date"
                      value={pactadasStartDate}
                      onChange={(e) => setPactadasStartDate(e.target.value)}
                      style={{
                        width: '100%', padding: '12px', borderRadius: '10px',
                        border: '1px solid #CBD5E1', fontSize: '15px',
                        boxSizing: 'border-box'
                      }}
                      required={!!cleanCierreFilename}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569', fontSize: '14px' }}>Fecha Fin</label>
                    <input
                      type="date"
                      value={pactadasEndDate}
                      onChange={(e) => setPactadasEndDate(e.target.value)}
                      style={{
                        width: '100%', padding: '12px', borderRadius: '10px',
                        border: '1px solid #CBD5E1', fontSize: '15px',
                        boxSizing: 'border-box'
                      }}
                      required={!!cleanCierreFilename}
                    />
                  </div>
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569', fontSize: '14px' }}>
                    Origen del Archivo de Cierre Limpio
                  </label>
                  <div style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
                      <input
                        type="radio"
                        name="cierreSource"
                        value="temp"
                        checked={cierreSourceOption === 'temp'}
                        onChange={() => setCierreSourceOption('temp')}
                      />
                      Usar archivo limpio generado en Fase 1
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
                      <input
                        type="radio"
                        name="cierreSource"
                        value="upload"
                        checked={cierreSourceOption === 'upload'}
                        onChange={() => setCierreSourceOption('upload')}
                      />
                      Subir archivo corregido manualmente (.csv)
                    </label>
                  </div>

                  {cierreSourceOption === 'temp' ? (
                    <div style={{ background: '#F1F5F9', padding: '12px 16px', borderRadius: '10px', fontSize: '14px', color: '#475569', border: '1px solid #E2E8F0' }}>
                      📄 Archivo temporal a utilizar: <strong>{cleanCierreFilename || 'Ninguno'}</strong>
                    </div>
                  ) : (
                    <div>
                      <input
                        type="file"
                        accept=".csv"
                        onChange={(e) => setModifiedCierreFile(e.target.files[0])}
                        style={{
                          width: '100%', padding: '12px', borderRadius: '10px',
                          border: '1px solid #CBD5E1', background: 'white', fontSize: '14px',
                          boxSizing: 'border-box'
                        }}
                        required={cierreSourceOption === 'upload' && !!cleanCierreFilename}
                      />
                    </div>
                  )}
                </div>

                <div style={{ marginBottom: '24px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#475569', fontSize: '14px' }}>
                    Matriz de Cuadrillas Pactadas (.csv) <span style={{ color: '#64748B', fontWeight: 'normal' }}>(Opcional - Al subir un archivo nuevo, este REEMPLAZARÁ la matriz por defecto del servidor)</span>
                  </label>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={(e) => setPactadasFile(e.target.files[0])}
                    style={{
                      width: '100%', padding: '12px', borderRadius: '10px',
                      border: '1px solid #CBD5E1', background: 'white', fontSize: '14px',
                      boxSizing: 'border-box'
                    }}
                  />
                  
                  {pactadasInfo && (
                    <div style={{
                      marginTop: '10px',
                      padding: '10px 14px',
                      background: '#F0F9FF',
                      border: '1px solid #BAE6FD',
                      borderRadius: '8px',
                      fontSize: '13px',
                      color: '#0369A1',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      flexWrap: 'wrap'
                    }}>
                      <span>📌 <strong>Archivo actual en servidor:</strong> {pactadasInfo.filename}</span>
                      {pactadasInfo.last_modified && (
                        <span>| 🕒 <strong>Última actualización:</strong> {pactadasInfo.last_modified}</span>
                      )}
                      {pactadasInfo.months && pactadasInfo.months.length > 0 && (
                        <span>| 📅 <strong>Mes(es) registrado(s):</strong> <code style={{ background: '#E0F2FE', padding: '2px 6px', borderRadius: '4px', color: '#0369A1', fontWeight: 'bold' }}>{pactadasInfo.months.join(', ')}</code></span>
                      )}
                    </div>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={pactadasLoading}
                  style={{
                    padding: '14px 28px', border: 'none', borderRadius: '12px',
                    background: pactadasLoading ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                    color: '#fff', fontWeight: '700', fontSize: '16px', cursor: pactadasLoading ? 'default' : 'pointer',
                    boxShadow: '0 4px 12px rgba(16,185,129,0.2)', transition: 'all 0.2s', width: '100%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'
                  }}
                >
                  {pactadasLoading ? (
                    <>
                      <div style={{
                        width: '18px', height: '18px', border: '3px solid rgba(255,255,255,0.3)',
                        borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 1s linear infinite'
                      }}></div>
                      Procesando datos y cruzando asistencia...
                    </>
                  ) : (
                    '🚀 Procesar Cuadrillas e Integrar Asistencia'
                  )}
                </button>
              </form>
            </div>

          </div>

          {/* CSS Animation local */}
          <style dangerouslySetInnerHTML={{__html: `
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}} />

          {pactadasResult && (
            <div style={{ marginTop: '40px', borderTop: '1px solid #E2E8F0', paddingTop: '40px' }}>
              <h3 style={{ fontSize: '20px', fontWeight: '700', color: '#1E293B', marginBottom: '24px' }}>
                🎉 Resultados del Procesamiento
              </h3>

              {/* Botones de Descarga */}
              <div style={{ background: '#F1F5F9', padding: '24px', borderRadius: '16px', marginBottom: '40px', display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'center' }}>
                <h4 style={{ margin: 0, width: '100%', fontSize: '15px', color: '#475569', fontWeight: '700', marginBottom: '8px' }}>
                  💾 DESCARGAR HOJA DE CÁLCULO GENERADA
                </h4>
                <button
                  onClick={() => handleDownloadPactadasFile(pactadasResult.csv_file)}
                  style={{
                    padding: '12px 24px', border: 'none', borderRadius: '10px',
                    background: 'linear-gradient(135deg, #10B981, #059669)',
                    color: '#fff', fontWeight: '700', cursor: 'pointer',
                    boxShadow: '0 2px 8px rgba(16,185,129,0.2)', display: 'flex', alignItems: 'center', gap: '8px'
                  }}
                >
                  <span>📥</span> Descargar Matriz Final (CSV)
                </button>
              </div>

              {/* Tablas de Auditoría */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '40px' }}>
                {/* Top 10 Metraje */}
                <div>
                  <h4 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: '700', color: '#EF4444', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>⚠️</span> Top 10 Técnicos con Mayor Metraje
                  </h4>
                  <div style={{ overflowX: 'auto', border: '1px solid #E2E8F0', borderRadius: '12px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' }}>
                      <thead>
                        <tr style={{ background: '#F8FAFC', borderBottom: '1px solid #E2E8F0' }}>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569' }}>Usuario</th>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569' }}>Fecha</th>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569' }}>Empresa</th>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569' }}>Distrito</th>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569', textAlign: 'right' }}>Distancia (m)</th>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569', textAlign: 'right' }}>Tiempo Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pactadasResult.top_exagerados.map((item, idx) => (
                           <tr key={idx} style={{ borderBottom: '1px solid #E2E8F0' }}>
                            <td style={{ padding: '12px 16px', fontWeight: '600', color: '#0F172A' }}>{item.TECNICO}</td>
                            <td style={{ padding: '12px 16px', color: '#334155' }}>{item.FECHA}</td>
                            <td style={{ padding: '12px 16px', color: '#334155' }}>{item.EMPRESA}</td>
                            <td style={{ padding: '12px 16px', color: '#334155' }}>{item.DISTRITO}</td>
                            <td style={{ padding: '12px 16px', color: '#0F172A', fontWeight: '700', textAlign: 'right' }}>{item.DISTANCIA_TOTAL}</td>
                            <td style={{ padding: '12px 16px', color: '#0F172A', fontWeight: '700', textAlign: 'right' }}>{item.TIEMPO_TOTAL}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Top 10 Tiempo */}
                <div>
                  <h4 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: '700', color: '#3B82F6', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>🔍</span> Top 10 Técnicos con Mayor Tiempo (Tiempo Real)
                  </h4>
                  <div style={{ overflowX: 'auto', border: '1px solid #E2E8F0', borderRadius: '12px' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' }}>
                      <thead>
                        <tr style={{ background: '#F8FAFC', borderBottom: '1px solid #E2E8F0' }}>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569' }}>Usuario</th>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569' }}>Fecha</th>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569' }}>Empresa</th>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569' }}>Distrito</th>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569', textAlign: 'right' }}>Distancia (m)</th>
                          <th style={{ padding: '12px 16px', fontWeight: '600', color: '#475569', textAlign: 'right' }}>Tiempo Total (Real)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pactadasResult.top_minimos.map((item, idx) => (
                           <tr key={idx} style={{ borderBottom: '1px solid #E2E8F0' }}>
                            <td style={{ padding: '12px 16px', fontWeight: '600', color: '#0F172A' }}>{item.TECNICO}</td>
                            <td style={{ padding: '12px 16px', color: '#334155' }}>{item.FECHA}</td>
                            <td style={{ padding: '12px 16px', color: '#334155' }}>{item.EMPRESA}</td>
                            <td style={{ padding: '12px 16px', color: '#334155' }}>{item.DISTRITO}</td>
                            <td style={{ padding: '12px 16px', color: '#0F172A', fontWeight: '700', textAlign: 'right' }}>{item.DISTANCIA_TOTAL}</td>
                            <td style={{ padding: '12px 16px', color: '#0F172A', fontWeight: '700', textAlign: 'right' }}>{item.TIEMPO_TOTAL}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {showAssignModal && (
        <div style={styles.modalOverlay}>
          <div style={{ ...styles.modalContent, maxWidth: '450px', width: '90%' }}>
            <h2 style={{ ...styles.mainSectionTitle, marginBottom: '20px' }}>Asignar Rol Granular</h2>
            <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#F3F4F6', borderRadius: '8px' }}>
              <p style={{ margin: 0, fontSize: '14px', color: '#374151' }}>Usuario: <strong>{targetUserForRole?.full_name}</strong></p>
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6B7280' }}>ID: {targetUserForRole?.usuario_ffm}</p>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Selecciona un Perfil de Administrador</label>
              <select
                value={newRoleData.role_id || ''}
                onChange={(e) => setNewRoleData({ ...newRoleData, role_id: e.target.value })}
                style={{ ...styles.formInput, appearance: 'auto' }}
              >
                <option value="">-- Sin Rol Especial (Solo Técnico) --</option>
                {rbacRoles.map(role => (
                  <option key={role.id} value={role.id}>{role.name}</option>
                ))}
              </select>
            </div>
            <p style={{ fontSize: '12px', color: '#6B7280', fontStyle: 'italic', marginTop: '10px' }}>
              * Al asignar un rol, este usuario tendrá los permisos específicos definidos en el perfil.
            </p>
            <div style={{ ...styles.buttonGroup, marginTop: '30px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={() => setShowAssignModal(false)}
                style={{ ...styles.previewButton, backgroundColor: '#6B7280', width: 'auto' }}
              >
                Cancelar
              </button>
              <button
                onClick={handleAssignRole}
                style={{ ...styles.downloadButton, width: 'auto' }}
              >
                Confirmar Asignación
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Credentials Modal */}
      {createdUser && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <div style={styles.modalHeaderContent}>
                <div style={styles.modalIcon}>✅</div>
                <div>
                  <h2 style={styles.modalTitle}>¡Usuario Creado!</h2>
                  <p style={styles.modalSubtitle}>Credenciales generadas exitosamente</p>
                </div>
              </div>
            </div>

            <div style={styles.modalBody}>
              <div style={styles.credentialsGrid}>
                <div style={styles.credentialItem}>
                  <label style={styles.credentialLabel}>Nombre Completo</label>
                  <div style={styles.credentialValue}>{createdUser.full_name}</div>
                </div>

                <div style={styles.credentialItem}>
                  <label style={styles.credentialLabel}>Usuario</label>
                  <div style={styles.credentialInputWrapper}>
                    <code style={styles.credentialCode}>{createdUser.usuario_ffm}</code>
                    <button
                      onClick={() => copyToClipboard(createdUser.usuario_ffm)}
                      style={styles.copyButton}
                    >
                      📋
                    </button>
                  </div>
                </div>

                <div style={styles.credentialItem}>
                  <label style={styles.credentialLabel}>Contraseña Temporal</label>
                  <div style={styles.credentialInputWrapper}>
                    <code style={styles.passwordCode}>{createdUser.password}</code>
                    <button
                      onClick={() => copyToClipboard(createdUser.password)}
                      style={styles.copyButton}
                    >
                      📋
                    </button>
                  </div>
                  <p style={styles.passwordNote}>
                    ⚠️ Esta contraseña es temporal. El usuario deberá cambiarla en su primer acceso.
                  </p>
                </div>

                <div style={styles.credentialItem}>
                  <label style={styles.credentialLabel}>Información Adicional</label>
                  <div style={styles.additionalInfo}>
                    <div>
                      <span style={styles.additionalLabel}>Rol:</span>
                      <span style={styles.additionalValue}>
                        {roleConfig[createdUser.role]?.label}
                      </span>
                    </div>
                    <div>
                      <span style={styles.additionalLabel}>Ubicación:</span>
                      <span style={styles.additionalValue}>
                        {createdUser.region} / {createdUser.distrito}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div style={styles.modalActions}>
                <button
                  onClick={() => copyToClipboard(`Usuario: ${createdUser.usuario_ffm}\nContraseña: ${createdUser.password}\nNombre: ${createdUser.full_name}\nRol: ${roleConfig[createdUser.role]?.label}\nUbicación: ${createdUser.region} / ${createdUser.distrito}`, true)}
                  style={styles.copyAllButton}
                >
                  <span>📋</span>
                  <span style={{ marginLeft: '8px' }}>Copiar Credenciales</span>
                </button>
                <button
                  onClick={() => setCreatedUser(null)}
                  style={styles.closeModalButton}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Reports Modal */}
      {showReportsModal && selectedTechReports && (
        <div style={styles.modalOverlay}>
          <div style={{ ...styles.modal, maxWidth: '1400px', width: '95%' }}>
            <div style={{ ...styles.modalHeader, background: 'linear-gradient(90deg, #2563EB 0%, #4F46E5 100%)' }}>
              <div style={styles.modalHeaderContent}>
                <div style={styles.modalIcon}>📊</div>
                <div>
                  <h2 style={styles.modalTitle}>Detalle de Rutas</h2>
                  <p style={styles.modalSubtitle}>{selectedTechReports.full_name} ({selectedTechReports.usuario_ffm})</p>
                </div>
                <button
                  onClick={() => { setShowReportsModal(false); setSelectedMapReport(null); }}
                  style={{
                    marginLeft: 'auto',
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    color: 'white',
                    padding: '8px',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '32px',
                    height: '32px'
                  }}
                >
                  ✕
                </button>
              </div>
            </div>

            <div style={{ ...styles.modalBody, maxHeight: '82vh', overflowY: 'auto', padding: '24px' }}>
              {selectedMapReport && (
                <div id="map-scroll-anchor" style={{ marginBottom: '24px', animation: 'fadeIn 0.5s ease-out' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ fontSize: '24px' }}>🗺️</span>
                      <h3 style={{ margin: 0, color: '#1E293B', fontWeight: 'bold', fontSize: '1.2rem' }}>
                        Mapa del Reporte ID: {selectedMapReport.id}
                      </h3>
                    </div>
                    <button
                      onClick={() => setSelectedMapReport(null)}
                      style={{
                        padding: '6px 12px',
                        background: '#EF4444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}
                    >
                      Cerrar Mapa
                    </button>
                  </div>
                  <DashboardMap reports={[selectedMapReport]} height="600px" />
                  {/* Leyenda de colores */}
                  <div style={{
                    display: 'flex', flexWrap: 'wrap', gap: '12px',
                    padding: '12px 16px',
                    background: '#F8FAFC',
                    borderRadius: '8px',
                    border: '1px solid #E2E8F0',
                    marginTop: '-16px',
                    marginBottom: '8px',
                    fontSize: '13px',
                    color: '#374151'
                  }}>
                    <span style={{ fontWeight: '600', color: '#1E293B' }}>Leyenda:</span>
                    {[
                      { color: '#2563EB', label: 'Inicio de recorrido' },
                      { color: '#16A34A', label: 'Segmento válido' },
                      { color: '#EA580C', label: 'Tirada larga (>150m)' },
                      { color: '#DC2626', label: 'No realizable' },
                      { color: '#7C3AED', label: 'Fin de recorrido' },
                    ].map(({ color, label }) => (
                      <span key={label} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <span style={{
                          display: 'inline-block',
                          width: '12px', height: '12px',
                          borderRadius: '50%',
                          backgroundColor: color,
                          border: '2px solid white',
                          boxShadow: '0 0 3px rgba(0,0,0,0.4)',
                          flexShrink: 0
                        }} />
                        {label}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              <div style={{ ...styles.tableContainer, border: 'none' }}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHeader}>
                      <th style={styles.tableHeaderCell}>Reporte ID</th>
                      <th style={styles.tableHeaderCell}>Inicio</th>
                      <th style={styles.tableHeaderCell}>Fin</th>
                      <th style={styles.tableHeaderCell}>Estado</th>
                      <th style={{ ...styles.tableHeaderCell, textAlign: 'center' }}>Segmentos</th>
                      <th style={styles.tableHeaderCell}>Adherencia (Efec)</th>
                      <th style={styles.tableHeaderCell}>Metraje (Efec)</th>
                      <th style={styles.tableHeaderCell}>Metraje Total</th>
                      <th style={{ ...styles.tableHeaderCell, textAlign: 'center' }}>No Realiz.</th>
                      <th style={{ ...styles.tableHeaderCell, textAlign: 'center' }}>Mapa</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedTechReports.reports.map((report, i) => (
                      <tr key={report.id} style={{
                        ...styles.tableRow,
                        backgroundColor: i % 2 === 0 ? 'white' : '#F9FAFB',
                        cursor: 'default'
                      }}>
                        <td style={{ ...styles.tableCell, fontWeight: 'bold' }}>{report.id}</td>
                        <td style={styles.tableCell}>{new Date(report.start_time).toLocaleString('es-MX')}</td>
                        <td style={styles.tableCell}>{report.end_time ? new Date(report.end_time).toLocaleString('es-MX') : 'N/A'}</td>
                        <td style={styles.tableCell}>
                          <span style={{
                            ...styles.statusBadge,
                            backgroundColor: report.status === 'completed' ? '#DCFCE7' : '#FEF3C7',
                            color: report.status === 'completed' ? '#166534' : '#92400E'
                          }}>
                            {report.status === 'completed' ? 'Completado' : 'Activo'}
                          </span>
                        </td>
                        <td style={{ ...styles.tableCell, textAlign: 'center' }}>{report.segmentos}</td>
                        <td style={styles.tableCell}>{Math.floor(report.tiempo_efectivo_min / 60)}h {report.tiempo_efectivo_min % 60}m</td>
                        <td style={styles.tableCell}>{(report.distancia_efectiva_m / 1000).toFixed(3)} km</td>
                        <td style={styles.tableCell}>{(report.distancia_total_m / 1000).toFixed(3)} km</td>
                        <td style={{ ...styles.tableCell, textAlign: 'center' }}>{report.no_realizables}</td>
                        <td style={{ ...styles.tableCell, textAlign: 'center' }}>
                          <button
                            onClick={() => setSelectedMapReport(report)}
                            style={{
                              padding: '6px 10px',
                              background: '#3B82F6',
                              color: 'white',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              margin: '0 auto',
                              transition: 'background 0.2s',
                            }}
                            onMouseOver={(e) => e.target.style.background = '#2563EB'}
                            onMouseOut={(e) => e.target.style.background = '#3B82F6'}
                          >
                            Ver Mapa 🗺️
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div style={{ ...styles.modalActions, padding: '20px', borderTop: '1px solid #E5E7EB', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
              <button
                onClick={() => { setShowReportsModal(false); setSelectedMapReport(null); }}
                style={{ ...styles.closeModalButton, flex: 'none', minWidth: '150px', background: '#F3F4F6', color: '#374151', border: '1px solid #D1D5DB' }}
              >
                Cerrar Detalle
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🚨 NUEVO: Modal de Detalles de Usuario con Penalizaciones y Auditoría */}
      {showCreateAdminModal && (
        <div style={styles.modalOverlay}>
          <div style={{ ...styles.modalContent, maxWidth: '500px', width: '90%' }}>
            <div style={{ padding: '20px' }}>
              <h2 style={{ ...styles.cardTitle, marginBottom: '20px', fontSize: '1.5rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '24px' }}>🛡️</span>
                Crear Administrador: {rbacRoles.find(r => r.id === newAdminData.role_id)?.name}
              </h2>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '15px' }}>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Nombre Completo *</label>
                  <input
                    type="text"
                    value={newAdminData.full_name}
                    onChange={(e) => setNewAdminData({ ...newAdminData, full_name: e.target.value })}
                    placeholder="Ej: Gustavo Rodríguez"
                    style={styles.formInput}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>ID de Usuario (Usuario FFM) *</label>
                  <input
                    type="text"
                    value={newAdminData.usuario_ffm}
                    onChange={(e) => setNewAdminData({ ...newAdminData, usuario_ffm: e.target.value.toUpperCase() })}
                    placeholder="Ej: GRODRIGUEZ"
                    maxLength="13"
                    style={{
                      ...styles.formInput,
                      border: /TO\d{3}$/.test(newAdminData.usuario_ffm) ? '2px solid #EF4444' : styles.formInput.border,
                      boxShadow: /TO\d{3}$/.test(newAdminData.usuario_ffm) ? '0 0 0 3px rgba(239, 68, 68, 0.2)' : 'none'
                    }}
                  />
                  {/TO\d{3}$/.test(newAdminData.usuario_ffm) && (
                    <span style={{ color: '#EF4444', fontSize: '12px', marginTop: '4px', display: 'block', fontWeight: 'bold' }}>
                      ⚠️ Detectado "TO" en lugar de "T0" al final. Reemplace la letra "O" por el número cero "0".
                    </span>
                  )}
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Correo Electrónico *</label>
                  <input
                    type="email"
                    value={newAdminData.email}
                    onChange={(e) => setNewAdminData({ ...newAdminData, email: e.target.value })}
                    placeholder="ejemplo@empresa.com"
                    style={styles.formInput}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Teléfono</label>
                  <input
                    type="tel"
                    value={newAdminData.telefono}
                    onChange={(e) => setNewAdminData({ ...newAdminData, telefono: e.target.value })}
                    placeholder="10 dígitos"
                    style={styles.formInput}
                  />
                </div>

                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Planta Asignada *</label>
                  <select
                    value={newAdminData.tipo_planta || 'PE'}
                    onChange={(e) => setNewAdminData({ ...newAdminData, tipo_planta: e.target.value })}
                    style={styles.formInput}
                  >
                    <option value="PE">Planta Externa (PE)</option>
                    <option value="PI">Planta Interna (PI)</option>
                  </select>
                </div>
              </div>

              <div style={{
                marginTop: '20px',
                padding: '12px',
                backgroundColor: '#F3F4F6',
                borderRadius: '8px',
                fontSize: '12px',
                color: '#4B5563',
                lineHeight: '1.4'
              }}>
                ℹ️ Al crear este usuario se le asignará automáticamente el rol de sistema <strong>ADMIN</strong> y el perfil granular seleccionado. La contraseña será generada aleatoriamente y podrás copiarla al finalizar.
              </div>

              <div style={{ ...styles.modalActions, marginTop: '24px', justifyContent: 'flex-end', gap: '12px' }}>
                <button
                  onClick={() => setShowCreateAdminModal(false)}
                  style={{
                    padding: '10px 20px',
                    borderRadius: '8px',
                    border: '1px solid #D1D5DB',
                    backgroundColor: 'white',
                    cursor: 'pointer',
                    fontWeight: '500'
                  }}
                >
                  Cancelar
                </button>
                <button
                  onClick={handleCreateAdminUser}
                  style={{
                    padding: '10px 24px',
                    borderRadius: '8px',
                    border: 'none',
                    backgroundColor: '#2563EB',
                    color: 'white',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.4)'
                  }}
                >
                  Crear y Asignar Rol
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <UserDetailsModal
        usuario_ffm={selectedUserForDetails}
        isOpen={showUserDetailsModal}
        onClose={() => setShowUserDetailsModal(false)}
        API_URL={API_URL}
      />

    </div>
  );
};

// Estilos CSS inline
const baseStyles = {
  container: {
    minHeight: '100vh',
    background: '#F8FAFC',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  },
  header: {
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    background: 'linear-gradient(135deg, #1E293B 0%, #0F172A 100%)',
    color: 'white',
    padding: '20px 0',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
  },
  headerContent: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '0 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  headerIcon: {
    width: '48px',
    height: '48px',
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(4px)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    border: '1px solid rgba(255, 255, 255, 0.1)'
  },
  headerTitle: {
    margin: 0,
    fontSize: '22px',
    fontWeight: '800',
    letterSpacing: '-0.025em'
  },
  headerSubtitle: {
    margin: '2px 0 0 0',
    fontSize: '14px',
    color: '#94A3B8',
    fontWeight: '500'
  },
  logoutButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 18px',
    background: 'rgba(255, 255, 255, 0.05)',
    color: 'white',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '10px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '14px',
    transition: 'all 0.2s',
    gap: '8px'
  },
  categoriesWrapper: {
    background: 'white',
    borderBottom: '1px solid #E2E8F0',
    padding: '12px 0'
  },
  categoriesContainer: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '0 24px',
    display: 'flex',
    gap: '12px',
    overflowX: 'auto',
    scrollbarWidth: 'none'
  },
  categoryButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 24px',
    background: 'none',
    color: '#94A3B8',
    border: '2px solid transparent',
    cursor: 'pointer',
    fontWeight: '700',
    fontSize: '14px',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap',
    borderRadius: '14px',
    outline: 'none',
    boxShadow: 'none'
  },
  categoryButtonActive: {
    background: 'white',
    transform: 'translateY(-1px)',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05)',
    zIndex: 2
  },
  tabsWrapperContainer: {
    background: '#F1F5F9',
    padding: '16px 0'
  },
  tabsContainer: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '0 24px'
  },
  tabsWrapper: {
    display: 'flex',
    gap: '10px',
    overflowX: 'auto',
    scrollbarWidth: 'none'
  },
  tabButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 20px',
    background: 'none',
    color: '#94A3B8',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '14px',
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap',
    outline: 'none'
  },
  tabButtonActive: {
    background: 'white',
    color: '#1E293B',
    boxShadow: '0 4px 12px -2px rgba(0, 0, 0, 0.1)',
    opacity: 1,
    zIndex: 2
  },
  main: {
    maxWidth: '1280px',
    margin: '32px auto',
    padding: '0 24px'
  },
  card: {
    background: 'white',
    borderRadius: '20px',
    padding: '32px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.01)',
    border: '1px solid #F1F5F9'
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '32px'
  },
  cardIcon: {
    width: '56px',
    height: '56px',
    background: '#F8FAFC',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '28px',
    boxShadow: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)'
  },
  cardTitle: {
    margin: 0,
    fontSize: '24px',
    fontWeight: '800',
    color: '#0F172A',
    letterSpacing: '-0.025em'
  },
  cardSubtitle: {
    margin: '4px 0 0 0',
    fontSize: '15px',
    color: '#64748B',
    fontWeight: '500'
  },
  searchContainer: {
    display: 'flex',
    gap: '12px'
  },
  searchInput: {
    flex: 1,
    padding: '12px 16px',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    fontSize: '16px',
    outline: 'none',
    transition: 'border 0.2s'
  },
  searchButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 24px',
    background: 'linear-gradient(90deg, #2563EB 0%, #4F46E5 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'opacity 0.2s'
  },
  spinner: {
    width: '20px',
    height: '20px',
    border: '2px solid white',
    borderTopColor: 'transparent',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  userCard: {
    background: 'linear-gradient(135deg, #F9FAFB 0%, #F3F4F6 100%)',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    padding: '24px'
  },
  userHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px'
  },
  userNameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '12px'
  },
  userName: {
    margin: 0,
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#111827'
  },
  statusBadge: {
    padding: '4px 12px',
    borderRadius: '9999px',
    fontSize: '12px',
    fontWeight: '600'
  },
  userInfoRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    alignItems: 'center'
  },
  selectionList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    animation: 'fadeIn 0.3s ease-out'
  },
  selectionItem: {
    padding: '16px',
    background: 'white',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    '&:hover': {
      borderColor: '#3B82F6',
      backgroundColor: '#F9FAFB'
    }
  },
  infoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  infoLabel: {
    fontSize: '14px',
    color: '#6B7280'
  },
  code: {
    background: '#F3F4F6',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '14px',
    fontFamily: 'monospace'
  },
  roleBadge: {
    padding: '4px 12px',
    borderRadius: '9999px',
    fontSize: '12px',
    fontWeight: '600'
  },
  userActions: {
    display: 'flex',
    gap: '8px'
  },
  deactivateButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    background: '#FEE2E2',
    color: '#991B1B',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'background 0.2s'
  },
  activateButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    background: '#DCFCE7',
    color: '#166534',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'background 0.2s'
  },
  userGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px'
  },
  passwordSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  sectionTitle: {
    margin: 0,
    fontSize: '16px',
    fontWeight: '600',
    color: '#374151',
    display: 'flex',
    alignItems: 'center'
  },
  passwordInputContainer: {
    position: 'relative'
  },
  passwordInput: {
    width: '100%',
    padding: '12px 40px 12px 16px',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    fontSize: '16px',
    outline: 'none'
  },
  showPasswordButton: {
    position: 'absolute',
    right: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px'
  },
  updatePasswordButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px',
    background: 'linear-gradient(90deg, #F59E0B 0%, #D97706 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'opacity 0.2s'
  },
  infoSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  infoGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  infoValue: {
    fontWeight: '500',
    color: '#111827'
  },
  mainSectionTitle: {
    margin: 0,
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: '16px'
  },
  roleGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px'
  },
  roleCard: {
    padding: '24px',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.3s'
  },
  roleCardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '12px'
  },
  roleCardTitle: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 'bold'
  },
  roleCardDesc: {
    margin: 0,
    fontSize: '14px',
    lineHeight: 1.5
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px',
    marginBottom: '24px'
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  formLabel: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#374151'
  },
  formInput: {
    padding: '12px',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    fontSize: '16px',
    outline: 'none',
    transition: 'border 0.2s, box-shadow 0.2s',
    cursor: 'pointer'
  },
  createButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(90deg, #10B981 0%, #059669 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 4px 6px -1px rgba(16, 185, 129, 0.3), 0 2px 4px -1px rgba(16, 185, 129, 0.2)'
  },
  filterCard: {
    background: 'linear-gradient(90deg, #EFF6FF 0%, #DBEAFE 100%)',
    border: '1px solid #BFDBFE',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px'
  },
  filterTitle: {
    margin: '0 0 16px 0',
    fontSize: '16px',
    fontWeight: '600',
    color: '#1E40AF',
    display: 'flex',
    alignItems: 'center'
  },
  filterGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px'
  },
  dateRangeGroup: {
    gridColumn: 'span 2',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px'
  },
  downloadButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(90deg, #2563EB 0%, #4F46E5 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.3), 0 2px 4px -1px rgba(37, 99, 235, 0.2)'
  },
  noteCard: {
    background: '#FEF3C7',
    border: '1px solid #FDE68A',
    borderRadius: '12px',
    padding: '20px',
    marginTop: '24px'
  },
  noteTitle: {
    margin: '0 0 8px 0',
    fontSize: '16px',
    fontWeight: '600',
    color: '#92400E',
    display: 'flex',
    alignItems: 'center'
  },
  noteText: {
    margin: 0,
    fontSize: '14px',
    color: '#92400E',
    lineHeight: 1.5
  },
  routesHeader: {
    marginBottom: '24px'
  },
  routesCount: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  countBadge: {
    padding: '8px 16px',
    background: '#DBEAFE',
    color: '#1E40AF',
    borderRadius: '8px',
    fontWeight: '500'
  },
  exportButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    background: 'linear-gradient(90deg, #10B981 0%, #059669 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'opacity 0.2s'
  },
  tableContainer: {
    overflowX: 'auto',
    borderRadius: '8px',
    border: '1px solid #E5E7EB'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1000px'
  },
  tableHeader: {
    background: '#F9FAFB'
  },
  tableHeaderCell: {
    padding: '16px',
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '600',
    color: '#6B7280',
    borderBottom: '1px solid #E5E7EB'
  },
  tableRow: {
    borderBottom: '1px solid #E5E7EB'
  },
  tableCell: {
    padding: '16px',
    fontSize: '14px',
    color: '#374151'
  },
  closeRouteButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    background: 'linear-gradient(90deg, #DC2626 0%, #B91C1C 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'opacity 0.2s'
  },
  emptyState: {
    textAlign: 'center',
    padding: '48px',
    background: 'linear-gradient(135deg, #F9FAFB 0%, #F3F4F6 100%)',
    borderRadius: '12px',
    border: '2px dashed #D1D5DB'
  },
  emptyIcon: {
    width: '64px',
    height: '64px',
    margin: '0 auto 16px',
    background: '#D1FAE5',
    color: '#10B981',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px'
  },
  emptyTitle: {
    margin: '0 0 8px 0',
    fontSize: '18px',
    fontWeight: '600',
    color: '#374151'
  },
  emptyText: {
    margin: 0,
    fontSize: '14px',
    color: '#6B7280'
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    zIndex: 1050,
    animation: 'fadeIn 0.2s ease-out'
  },
  modal: {
    background: 'white',
    borderRadius: '16px',
    maxWidth: '500px',
    width: '100%',
    overflow: 'hidden',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
  },
  modalContent: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    padding: '30px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    maxHeight: '90vh',
    overflowY: 'auto'
  },
  modalHeader: {
    background: 'linear-gradient(90deg, #10B981 0%, #059669 100%)',
    padding: '24px',
    color: 'white'
  },
  modalHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  modalIcon: {
    padding: '8px',
    background: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '8px',
    fontSize: '20px'
  },
  modalTitle: {
    margin: 0,
    fontSize: '20px',
    fontWeight: 'bold'
  },
  modalSubtitle: {
    margin: '4px 0 0 0',
    fontSize: '14px',
    opacity: 0.9
  },
  modalBody: {
    padding: '24px'
  },
  credentialsGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginBottom: '24px'
  },
  credentialItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  credentialLabel: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#6B7280'
  },
  credentialValue: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#111827'
  },
  credentialInputWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  credentialCode: {
    flex: 1,
    background: '#F3F4F6',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '16px',
    fontFamily: 'monospace',
    color: '#111827'
  },
  passwordCode: {
    flex: 1,
    background: '#FEF2F2',
    padding: '12px',
    borderRadius: '8px',
    fontSize: '16px',
    fontFamily: 'monospace',
    color: '#991B1B',
    fontWeight: 'bold'
  },
  copyButton: {
    padding: '8px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '18px',
    color: '#6B7280'
  },
  passwordNote: {
    margin: '8px 0 0 0',
    fontSize: '12px',
    color: '#DC2626'
  },
  additionalInfo: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px'
  },
  additionalLabel: {
    fontSize: '14px',
    color: '#6B7280',
    marginRight: '8px'
  },
  additionalValue: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#111827'
  },
  modalActions: {
    display: 'flex',
    gap: '12px'
  },

  buttonGroup: {
    display: 'flex',
    gap: '12px',
    marginBottom: '24px'
  },

  previewButton: {
    flex: 1,
    padding: '16px',
    background: 'linear-gradient(90deg, #8B5CF6 0%, #7C3AED 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s, box-shadow 0.2s',
    boxShadow: '0 4px 6px -1px rgba(139, 92, 246, 0.3), 0 2px 4px -1px rgba(139, 92, 246, 0.2)'
  },

  previewCard: {
    background: 'white',
    border: '2px solid #E5E7EB',
    borderRadius: '12px',
    padding: '24px',
    marginBottom: '24px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
  },

  previewHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    paddingBottom: '16px',
    borderBottom: '2px solid #F3F4F6'
  },

  previewTitle: {
    margin: 0,
    fontSize: '18px',
    fontWeight: '600',
    color: '#374151',
    display: 'flex',
    alignItems: 'center'
  },

  paginationControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },

  pageSelect: {
    padding: '8px 12px',
    border: '1px solid #D1D5DB',
    borderRadius: '6px',
    fontSize: '14px',
    outline: 'none',
    background: 'white'
  },

  pagination: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '24px',
    paddingTop: '16px',
    borderTop: '1px solid #E5E7EB'
  },

  pageButton: {
    padding: '8px 16px',
    background: '#F3F4F6',
    color: '#374151',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'background 0.2s'
  },

  pageInfo: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#374151'
  },

  previewActions: {
    marginTop: '24px',
    paddingTop: '16px',
    borderTop: '1px solid #E5E7EB',
    textAlign: 'center'
  },

  downloadPreviewButton: {
    padding: '12px 24px',
    background: 'linear-gradient(90deg, #10B981 0%, #059669 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'transform 0.2s'
  },
  copyAllButton: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px',
    background: 'linear-gradient(90deg, #2563EB 0%, #4F46E5 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'opacity 0.2s'
  },
  closeModalButton: {
    flex: 1,
    padding: '12px',
    background: 'white',
    color: '#374151',
    border: '2px solid #D1D5DB',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'background 0.2s'
  }
};

// Agregar estilos de animación al head
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes fadeInDown {
      from {
        opacity: 0;
        transform: translateY(-10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    
    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
  `;
  document.head.appendChild(style);
}

export default PortalAdmin;